// mocks.js - full-length mock tests (Layer 3): dual-led, flat (no competency labels), balanced keys, all original.
// Schema per item: id, course, mock_num, topic, q_type, is_free, points, question_az, options{A..D}, correct, explanation.
// No lesson_number on mock items. No em-dashes in student text.

export const MOCK_TESTS = [
  {
    id: 'smt-m1-q1', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Muzeydə iki bələdçinin eyni vaxta salınmış böyük ekskursiyaları üst-üstə düşür və hər ikisi qrupu özü aparmaq istəyir. Ziyarətçilər artıq gözləyir. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Daha təcrübəli bələdçiyə qrupu dərhal həvalə edin, digərinə növbəti ekskursiyanı təklif edin və ziyarətçiləri yola salın.`,
      B: `Ziyarətçiləri qısa müddətə yönləndirib gözləməni azaldın, sonra hər iki bələdçi ilə birlikdə cədvəlin üst-üstə düşmə səbəbini aradan qaldırın.`,
      C: `Cədvəli tərtib edən əməkdaşı çağırıb səhvi dərhal düzəltməyi xahiş edin, özünüz isə ziyarətçilərlə qalın.`,
      D: `Qərarı iki bələdçinin öz aralarında həll etməsinə buraxıb prosesə qarışmayın.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Effektiv cavab əvvəlcə ziyarətçi axınını sabitləşdirir, sonra təkrarlanmaması üçün cədvəl münaqişəsinin səbəbini aradan qaldırır. B bunu edir. D məsələni tərəflərin öz mübahisəsinə buraxıb prosesə qarışmadığı üçün nə ziyarətçiləri, nə də səbəbi həll etmir, ən az effektivdir. A təcrübəyə görə tez qərar verir, lakin səbəbi açmadan bir tərəfi seçir; C düzəlişi başqasına ötürüb sizi passiv saxlayır.`,
  },
  {
    id: 'smt-m1-q2', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Gömrük postunda sənəd yoxlanışı son həftələrdə ciddi gecikmələrə səbəb olur və şikayətlər artır. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Gecikmənin əsasən kənar amillərdən qaynaqlandığını əsaslandırıb mövcud qaydanı saxlayın.`,
      B: `Bütün yoxlama prosedurunu yenidən qurmaq üçün geniş layihə başladın və tam həllə qədər heç nə dəyişməyin.`,
      C: `Gecikmənin konkret mənbələrini müəyyən edin, bir neçə kiçik düzəlişi qısa müddətdə sınaqdan keçirin və ən effektivini genişləndirin.`,
      D: `Ən ehtimal olunan səbəbə uyğun bir düzəlişi seçib dərhal bütün posta tətbiq edin.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `C əvvəlcə səbəbi daraldır, sonra kiçik sınaqlarla ən yaxşı həlli tapıb genişləndirir, ən effektivdir. D bir düzəlişi tez tətbiq edir, lakin sınaqdan keçirmədən bütün posta yaymaq risklidir. B doğru istiqamətdədir, ancaq tam yenidənqurmaya qədər heç nə dəyişməmək gecikməni uzadır. A səbəbi izah etməklə kifayətlənib problemi həll etmir, ən az effektivdir.`,
  },
  {
    id: 'smt-m1-q3', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Laboratoriyada nəticələrin hesablanmasında təkrarlanan bir uyğunsuzluq aşkar edirsiniz və bu, hesabatların düzgünlüyünə təsir edə bilər. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Uyğunsuzluğu indilik qeyd edin, lakin böyük təsir görünənə qədər müdaxilə etməyin.`,
      B: `Yalnız öz hesabatlarınızdakı dəyərləri düzəldin və işi davam etdirin.`,
      C: `Məsələni növbəti rüblük baxışda komanda ilə birlikdə nəzərdən keçirmək üçün qeyd edin.`,
      D: `Uyğunsuzluğu sənədləşdirin, mənbəyini araşdırın və aidiyyəti komandaya bildirib düzəliş prosesini başladın.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `D uyğunsuzluğu sənədləşdirir, mənbəyini tapır və komanda ilə düzəldir, ən effektivdir. A təsir görünənə qədər gözləmək səhvin hesabatlara yayılmasına imkan verir, ən az effektivdir. B yalnız öz hissəsini düzəltmək ümumi mənbəni saxlayır; C məsələni rüblük baxışa saxlamaq düzgünlük problemi üçün çox gecdir.`,
  },
  {
    id: 'smt-m1-q4', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Departamentdə həftəlik hesabatların formatı və tezliyi dəyişir və bu, komandaya əlavə iş yükü gətirir. Etibarlı bir əməkdaş bu yükün real olduğunu sakitcə bildirir. Aşağıdakı davranışların hər birini effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən az effektiv, 4 - ən effektiv.`,
    options: {
      A: `Əməkdaşla ayrıca oturub konkret narahatlığı aydınlaşdırın, yeni formatın necə tətbiq olunacağını ona uyğun tənzimləyin və gözləntiləri birlikdə müəyyən edin.`,
      B: `Narahatlığı komanda müzakirəsinə çıxarın və hesabatı işlək etmək üçün təkliflər toplayın.`,
      C: `Yeni formatın niyə vacib olduğunu konkret nümunələrlə izah edin, lakin iş yükü narahatlığına ayrıca toxunmayın.`,
      D: `Formatın təsdiqlənmiş və gözlənilən olduğunu rəsmən bildirin və suallar üçün dəstək kanalı açın.`,
    },
    correct: { A: 4, B: 3, C: 2, D: 1 },
    explanation: `Ən güclü cavab əməkdaşın konkret narahatlığını aydınlaşdırır, tətbiqi ona uyğun tənzimləyir və gözləntiləri birgə müəyyən edir (A). Narahatlığı komanda səviyyəsində müzakirəyə çıxarmaq da işə yarayır, sadəcə fərdi yanaşmadan bir az zəifdir (B). Yalnız səbəbi izah etmək məntiqlidir, ancaq iş yükü narahatlığını cavabsız qoyur (C). Formatı rəsmən təsdiqlənmiş elan edib dəstək kanalı açmaq peşəkar görünsə də, narahatlığın özünə toxunmur (D).`,
  },
  {
    id: 'smt-m1-q5', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Nəşriyyatda bir redaktorun işi son vaxtlar tələb olunan keyfiyyətdən aşağı düşüb. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Bir müddət müşahidə edin, bəlkə keyfiyyət öz-özünə qayıdar, sonra lazım olsa danışarsınız.`,
      B: `Komanda yığıncağında ümumi şəkildə keyfiyyət standartlarını xatırladın, adını çəkmədən.`,
      C: `Redaktorla erkən və mehriban şəkildə görüşün, konkret nümunələr göstərin və birlikdə inkişaf planı qurun.`,
      D: `Daha kritik tapşırıqları müvəqqəti olaraq başqa redaktora verin və vəziyyəti izləyin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `C redaktorla birbaşa, konkret və inkişaf yönümlü danışıq aparır, ən effektivdir. A heç bir müdaxilə etmədən bir müddət müşahidə etmək problemin daha da dərinləşməsinə imkan verir, ən az effektivdir. B ümumi xatırlatma zəif olsa da heç olmasa müdaxilə cəhdidir; D tapşırığı başqasına verməklə əsas söhbətdən yan keçir.`,
  },
  {
    id: 'smt-m1-q6', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Proqram keyfiyyət komandasında ciddi bir səhv buraxılışdan sonra aşkarlanıb və komanda üzvləri narahatdır. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Səhvi buraxan şəxsi müəyyən edib məsuliyyətin onun üzərində olduğunu komandaya bildirin.`,
      B: `Səhvin necə baş verdiyini ittihamsız araşdırın, prosesdəki boşluğu tapın və komandanı gələcəkdə erkən bildirməyə təşviq edin.`,
      C: `Səhvi tez araşdırıb düzəldin, lakin tapıntıları komanda ilə bölüşmədən özünüzdə saxlayın.`,
      D: `Buraxılışdan əvvəlki yoxlama addımlarını dərhal ikiqat artırın.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `B kök səbəbi ittihamsız tapır, prosesi və açıq bildiriş mədəniyyətini gücləndirir, ən effektivdir. C səhvi düzəldir, ancaq öyrənməni komanda ilə bölüşmür. D yoxlamanı artırır, lakin səbəbi anlamadan ağır tədbirdir. A məsuliyyəti bir şəxsə yükləmək gələcək səhvlərin gizlədilməsinə gətirir, ən az effektivdir.`,
  },
  {
    id: 'smt-m1-q7', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Logistika mərkəzində gözlənilməz bir sifariş axını yaranıb və mövcud komanda hamısını vaxtında çatdıra bilməyəcək. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Tapşırıqları təcillik və əhəmiyyətə görə sıralayın, komandanın bacarığına uyğun yenidən bölün və lazım olsa müvəqqəti dəstək cəlb edin.`,
      B: `Komandanı növbə ilə uzadılmış iş saatlarına keçirin ki, bütün sifarişlər çatdırılsın.`,
      C: `Komandadan eyni resursla daha sürətli işləməyi tələb edin, gedişata sonra baxarsınız.`,
      D: `Yalnız ən böyük müştərilərin sifarişlərinə fokuslanıb qalanını sonraya saxlayın.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `A işləri təcillik və əhəmiyyətə görə sıralayır, bacarığa uyğun bölür və ehtiyac olanda dəstək cəlb edir, ən effektivdir. C eyni resursla yalnız sürət tələb etmək nə plan, nə də həll verir, ən az effektivdir. B uzadılmış saatlar qısamüddətli kömək etsə də yorğunluq riski yaradır; D yalnız böyük müştəriləri seçmək təcillik-əhəmiyyət balansını pozur.`,
  },
  {
    id: 'smt-m1-q8', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Peşə kollecində bir təlimçi son vaxtlar həvəssiz görünür və yeni təşəbbüslərə qoşulmur. Aşağıdakı davranışların hər birini effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən az effektiv, 4 - ən effektiv.`,
    options: {
      A: `Bütün komandaya yeni təşəbbüslərin əhəmiyyəti barədə ümumi çıxış edin.`,
      B: `Təlimçi ilə qısa söhbətdə iştirakını gözlədiyinizi bildirin və hansı dəstəyə ehtiyacı olduğunu soruşun.`,
      C: `Bir müddət müşahidə edin, dəyişiklik olmasa söhbət açın.`,
      D: `Təlimçi ilə təkbətək oturub həvəssizliyin arxasındakı səbəbi anlayın və ona uyğun rol, məqsəd və dəstək üzərində razılaşın.`,
    },
    correct: { A: 2, B: 3, C: 2, D: 4 },
    explanation: `Ən güclü yanaşma əvvəlcə həvəssizliyin səbəbini anlayır, sonra rol, məqsəd və dəstək üzərində razılaşır (D). İştirak gözləntisini bildirib hansı dəstəyə ehtiyac olduğunu soruşmaq da faydalıdır, sadəcə səbəbi aydınlaşdırmadan başlayır (B). Ümumi çıxış və bir müddət müşahidə fərdi səbəbə birbaşa toxunmur (A və C).`,
  },
  {
    id: 'smt-m1-q9', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Şəhər arxivində bir tender qiymətləndirməsində iştirak edirsiniz və iştirakçılardan biri keçmiş yaxın həmkarınızdır. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Qiymətləndirmədə qalın, lakin tanışınıza münasibətdə xüsusilə diqqətli olacağınıza söz verin.`,
      B: `Tanışlıq barədə rəhbərliyə açıq məlumat verin və prosesdən kənarlaşmağı və ya digər üzvlərin nəzarətində davam etməyi təklif edin.`,
      C: `Qərəzin qarşısını almaq üçün tanışınızın qiymətləndirilməsini başqa üzvə həvalə edin, lakin məsələni rəsmən bildirməyin.`,
      D: `Tanış iştirakçını qiymətləndirmədən kənarlaşdırın və prosesi davam etdirin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `B maraq toqquşmasını rəhbərliyə açıq bildirir və şəffaf həll təklif edir, ən effektivdir. C münaqişəni rəsmən bildirmədən gizli şəkildə həll etməyə çalışır, şəffaflığı pozur, ən az effektivdir. A diqqətli olmaq vədi toqquşmanı aradan qaldırmır; D bir iştirakçını açıqlama olmadan kənarlaşdırmaq ədalətsiz görünə bilər.`,
  },
  {
    id: 'smt-m1-q10', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Toxuculuq müəssisəsində bir göstərici gözlənilmədən aşağı düşüb və komandadan biri buna sadə bir izah verir. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Verilən izahı məntiqli sayıb qəbul edin və hesabatı ona uyğun hazırlayın.`,
      B: `İzahı yoxlamadan rəhbərə ötürün ki, qərarı o versin.`,
      C: `Əvvəlki dövrlərin və digər sahələrin göstəricilərini, eləcə də mümkün alternativ izahları müqayisə edərək verilən izahı yoxlayın.`,
      D: `Göstəricinin düşməsini konkret bir əməkdaşın işi ilə əlaqələndirib onu dəyişdirməyi düşünün.`,
    },
    correct: ['C', 'A', 'B', 'D'],
    explanation: `C izahı keçmiş və müqayisəli məlumatlarla yoxladığı üçün ən effektivdir. A izahı yoxlamadan qəbul edir, lakin ən azı məntiqini qiymətləndirir. B yoxlanmamış izahı rəhbərə ötürərək səhvi yuxarı daşıyır. D səbəbi araşdırmadan bir şəxsi günahlandırır, ən az effektivdir.`,
  },
  {
    id: 'smt-m1-q11', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bank filialında bir müştəri xidmət zalında səsini ucaldıb bir işçi ilə kəskin mübahisə edir. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Dərhal müştərinin tərəfini tutub işçidən üzr istəməsini xahiş edin.`,
      B: `Mübahisəni zalda dayandırıb hər iki tərəfi orada dərhal barışdırmağa çalışın.`,
      C: `Əvvəlcə müştəriyə müraciət edib vəziyyəti sakitləşdirin, sonra işçi ilə ayrıca danışıb faktları anlayın və həll yolu tapın.`,
      D: `Vəziyyəti dərhal yuxarı rəhbərliyə ötürün, çünki ictimai mübahisədir.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `C əvvəlcə vəziyyəti sakitləşdirir, sonra ayrıca faktları öyrənib həll tapır, ən effektivdir. A işçini müştəri qarşısında ictimai şəkildə zəiflədir və faktları öyrənmədən tərəf tutur, ən az effektivdir. B zalda dərhal barışdırmaq faktları anlamadan tələsikdir; D məsələni dərhal yuxarı ötürmək vaxtından əvvəldir.`,
  },
  {
    id: 'smt-m1-q12', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Tədqiqat institutunda qrup rəhbərisiniz. Bir koordinasiya problemi yaranıb. Məsələ ilə bağlı ilkin məlumatların çoxu sizdədir, lakin rəhbərin də ümumi xəbərdar olması faydalı görünə bilər. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Problemi həll üçün rəhbərliyə ötürün, çünki onların baxışı daha geniş ola bilər.`,
      B: `Komandadan məsələni öz aralarında həll etmələrini xahiş edin.`,
      C: `Əvvəlcə rəhbəri ümumi məlumatlandırıb onun göstərişinə əsasən hərəkət edin.`,
      D: `Məsələni öz səviyyənizdə həll edin, nəticəni isə qısa şəkildə rəhbərə məlumat olaraq çatdırın.`,
    },
    correct: 'D',
    explanation: `Məlumatın çoxu sizdə olduğu üçün məsələni öz səviyyənizdə həll etmək, sonra nəticəni rəhbərə qısa məlumat kimi çatdırmaq həm həlli sürətləndirir, həm də rəhbərin xəbərdar olmasını təmin edir (D). Problemi tam rəhbərliyə ötürmək və ya onun göstərişini gözləmək həlli ləngidir və sizdəki məlumatı istifadə etmir (A, C). Komandaya buraxmaq isə koordinasiya məsələsində rəhbər rolunu boş saxlayır (B).`,
  },
  {
    id: 'smt-m1-q13', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Xəbər redaksiyasında bir layihənin son tarixini saxlamağın mümkün olmadığını erkən başa düşürsünüz. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Komanda ilə birlikdə son anda çatdırmaq üçün əlavə səy göstərin və mümkün olmasa xəbər verərsiniz.`,
      B: `Son tarix yaxınlaşanda rəhbərə vəziyyəti və mümkün gecikməni bildirin.`,
      C: `Problemi son ana qədər açıqlamayın, çünki erkən demək lazımsız narahatlıq yaradar.`,
      D: `Rəhbərə erkən, şəffaf və həll yönümlü şəkildə xəbər verin, mümkün variantları və ehtiyacları təqdim edin.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `D problemi erkən, şəffaf və həll təklifləri ilə bildirir, ən effektivdir. C son ana qədər gizlətmək rəhbərin reaksiya imkanını azaldır, ən az effektivdir. A əlavə səy göstərmək yaxşıdır, lakin bildirişi gecikdirir; B xəbər versə də çox gec verir.`,
  },
  {
    id: 'smt-m1-q14', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Satınalma bölməsində yeni təsdiq qaydası tətbiq olunacaq və komanda narahatdır. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Qaydanın səbəbini izah edin, komandanın narahatlıqlarını dinləyin və ilk həftələrdə yaxından dəstək verərək tətbiqi tənzimləyin.`,
      B: `Qaydanı izah edin və sualları yazılı formada toplamağı təklif edin, lakin tətbiq tarixini dəyişməyin.`,
      C: `Qaydanı tətbiq edin və faydalarını izah edin, narahatlıqlara ayrıca toxunmadan.`,
      D: `Qaydanı dərhal tam tətbiq edin və komandaya öyrəşmək üçün vaxt verəcəyinizi bildirin.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Ən güclü yanaşma səbəbi izah edir, narahatlıqları dinləyir və ilk həftələrdə dəstəklə tətbiqi tənzimləyir (A). Qaydanı izah edib sualları toplamaq da komandanı prosesə qatır, sadəcə tətbiq tarixində çevik deyil (B). Yalnız faydaları izah etmək narahatlıqları cavabsız qoyur (C). Qaydanı tam tətbiq edib sadəcə öyrəşmək vaxtı vəd etmək isə komandanı ən az cəlb edən yanaşmadır (D).`,
  },
  {
    id: 'smt-m1-q15', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Dizayn agentliyində mürəkkəb bir tapşırığı həvalə etməlisiniz. İki nəfər mövcuddur: biri bu sahədə təcrübəli, digəri öyrənmək istəyən, lakin az təcrübəli. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Tapşırığı bacarığa uyğun bölün: kritik hissəni təcrübəliyə verin, az təcrübəlini uyğun hissədə inkişaf etdirin və aralıq yoxlama qoyun.`,
      B: `Tapşırığı tam təcrübəli şəxsə verin ki, nəticə zəmanətli olsun.`,
      C: `Tapşırığı tam az təcrübəli şəxsə verin və inkişaf üçün sərbəst buraxın.`,
      D: `Tapşırığı özünüz görün ki, risk olmasın.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `A tapşırığı bacarığa görə bölür, həm nəticəni qoruyur, həm inkişafı təmin edir və aralıq yoxlama qoyur, ən effektivdir. C bütün kritik işi nəzarətsiz şəkildə az təcrübəliyə vermək yüksək risk daşıyır, ən az effektivdir. B nəticəni zəmanətə alır, ancaq inkişaf imkanını itirir; D özünüz görmək həvaləetmədən imtinadır.`,
  },
  {
    id: 'smt-m1-q16', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Çağrı mərkəzində bir əməkdaş gərgin müştəri ilə danışıqda getdikcə daha çox əsəbiləşir. Aşağıdakı davranışların hər birini effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən az effektiv, 4 - ən effektiv.`,
    options: {
      A: `Əməkdaşdan danışıqda səsini ucaltmamağı xahiş edin.`,
      B: `Danışığa qısa fasilə verməyə imkan yaradın, gərginliyi endirin, sonra sakit tonla davam etməyə dəstək olun.`,
      C: `Müdaxilə etməyin, qoy əməkdaş özü öhdəsindən gəlsin.`,
      D: `Danışığı öz üzərinizə götürüb müştəri ilə özünüz davam edin.`,
    },
    correct: { A: 2, B: 4, C: 1, D: 2 },
    explanation: `Ən güclü yanaşma qısa fasilə ilə gərginliyi endirib əməkdaşı sakit davam etməyə dəstəkləməkdir (B). Səsini ucaltmamağı xahiş etmək əlamətə toxunur, danışığı öz üzərinə götürmək isə müştərini qoruyur; hər ikisi natamamdır (A, D). Getdikcə qızışan danışığa heç müdaxilə etməmək vəziyyəti idarəsiz buraxır, ən zəifdir (C).`,
  },
  {
    id: 'smt-m1-q17', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Mühasibatlıqda bir prosesi geri qaytarılması çətin olan şəkildə dəyişmək təklif olunur. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Dəyişikliyi dərhal tətbiq edin, çünki yeni üsul daha səmərəli görünür.`,
      B: `Geri qaytarılması çətin addımdan əvvəl təsiri qiymətləndirin, mümkünsə kiçik miqyasda sınaqdan keçirin, sonra qərar verin.`,
      C: `Dəyişikliyi tətbiq etməzdən əvvəl bütün təfərrüatları aylarla araşdırın.`,
      D: `Qərarı tamamilə komandanın səsverməsinə buraxın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `B geri qaytarılması çətin addımdan əvvəl təsiri qiymətləndirir və mümkünsə kiçik sınaq aparır, ən effektivdir. A geri dönüşü çətin dəyişikliyi yoxlamadan dərhal tətbiq etmək ən böyük riski yaradır, ən az effektivdir. C aylarla araşdırma həddən artıq ləngdir; D belə bir qərarı bütövlükdə səsverməyə buraxmaq məsuliyyəti ötürür.`,
  },
  {
    id: 'smt-m1-q18', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Məktəb administrasiyasında bir qərar həm valideynlərə, həm müəllimlərə, həm də şagirdlərə təsir edir və tərəflərin maraqları fərqlidir. Aşağıdakı davranışları ən effektivdən ən az effektivə doğru sıralayın.`,
    options: {
      A: `Ən aktiv və təzyiq edən tərəfin istəyini əsas götürüb qərar verin.`,
      B: `Tərəflərin mövqeyini qısaca öyrənin, sonra qərarı özünüz verib aydın izahla elan edin.`,
      C: `Bütün maraqlı tərəfləri müəyyən edin, hər birinin maraqlarını şəffaf nəzərə alın və proses əsaslı, tarazlı qərar verin.`,
      D: `Qərarı yalnız ən çox təsirlənən tərəflə razılaşdırın, qalan tərəfləri sonra məlumatlandırın.`,
    },
    correct: ['C', 'B', 'D', 'A'],
    explanation: `C bütün tərəfləri nəzərə alıb proses əsaslı, tarazlı qərar verir, ən effektivdir. B mövqeləri qısaca öyrənib aydın izahla qərar verir. D yalnız ən çox təsirlənən tərəflə razılaşıb qalanını sonra məlumatlandırır, natamamdır. A yalnız ən çox təzyiq edən tərəfə əsaslanır, ən az effektivdir.`,
  },
  {
    id: 'smt-m1-q19', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `İT dəstək komandasında bir sistem nasazlığının qısa müddətdə çox sayda istifadəçiyə təsir edəcəyini erkən görürsünüz. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Nasazlığı yalnız daxili komanda ilə müzakirə edin, istifadəçilərə isə təsir görünənə qədər bildirməyin.`,
      B: `Nasazlığı düzəltməyə başlayın və problem böyüsə istifadəçilərə bildirin.`,
      C: `Aidiyyəti tərəfləri erkən və şəffaf məlumatlandırın, gözlənilən təsiri və həll planını izah edin.`,
      D: `Nasazlığı sənədləşdirin və komandaya bildirmədən tək həll etməyə çalışın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Təsir böyük və yaxın olduğu üçün ən güclü addım aidiyyəti tərəfləri erkən, şəffaf məlumatlandırıb həll planını izah etməkdir (C). Təsir görünənə qədər istifadəçilərə bildirməmək çox sayda insanı hazırlıqsız saxlayır, ən az effektivdir (A). Düzəltməyə başlayıb gec bildirmək (B) və komandaya bildirmədən tək həll cəhdi (D) də natamamdır, lakin istifadəçiləri büsbütün xəbərsiz qoymur.`,
  },
  {
    id: 'smt-m1-q20', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `İstehsalat sahəsində bir əməkdaş kiçik bir xəta etdiyini sizə erkən bildirir. Aşağıdakı davranışların hər birini komanda mühitinə təsirinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zərərli, 4 - ən faydalı.`,
    options: {
      A: `Əməkdaşa xətanın ciddiliyini vurğulayıb gələcəkdə daha diqqətli olmasını tələb edin.`,
      B: `Xəta kiçik olduğu üçün əlavə müzakirə etmədən düzəlişi keçin.`,
      C: `Erkən bildirdiyi üçün münasibətinizi dəyərləndirin, xətanı ittihamsız araşdırın və prosesi yaxşılaşdırın.`,
      D: `Xətanı araşdırın, lakin əməkdaşa belə xətaların təkrarlanmamasının vacibliyini vurğulayın.`,
    },
    correct: { A: 1, B: 2, C: 4, D: 2 },
    explanation: `Ən faydalı yanaşma erkən bildirişi dəyərləndirir, xətanı ittihamsız araşdırır və prosesi yaxşılaşdırır (C). Kiçik xətanı sadəcə keçmək və ya araşdırıb təkrarlanmamağın vacibliyini vurğulamaq orta təsirlidir (B, D). Xətanın ciddiliyini vurğulayıb daha diqqətli olmağı tələb etmək erkən bildirişi əngəlləyir, ən zərərlidir (A).`,
  },
  {
    id: 'smt-m1-q21', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tədbir təşkilatçısı kimi eyni gündə bir təcili, lakin az əhəmiyyətli iş və bir az təcili, lakin çox əhəmiyyətli iş qarşınıza çıxır. Aşağıdakı variantlardan ən effektiv və ən az effektiv olanı seçin.`,
    options: {
      A: `Təcili işi dərhal bitirin, sonra əhəmiyyətli işə keçin.`,
      B: `Əhəmiyyətli işə tam fokuslanıb təcili işi tam kənara qoyun.`,
      C: `Hər iki işi eyni anda aparıb hər ikisini vaxtında çatdırmağa çalışın.`,
      D: `Əhəmiyyətli işə əsas vaxtı ayırın, təcili-amma az əhəmiyyətli işi tez bağlayın və ya həvalə edin.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Diqqəti az əhəmiyyətli işin təcilliyinə deyil, nəticəyə daha çox təsir edən işə yönəltmək lazımdır. D bunu edir: əhəmiyyətli işə vaxt ayırıb təcili işi tez bağlayır. C hər ikisini eyni anda aparmaq diqqəti parçalayır və çox vaxt heç biri yaxşı alınmır, ən zəif seçimdir. A təcilliyə uyub əhəmiyyətlini gecikdirir; B isə təcili işi büsbütün kənara qoyaraq qısamüddətli bir riski gözardı edir.`,
  },
  {
    id: 'smt-m1-q22', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Liman kranı briqadasında bir operator təhlükəsizlik yoxlamasını tez-tez ötürür. Ən effektiv və ən az effektiv ilk addımı seçin.`,
    options: {
      A: `Bütün briqadaya təhlükəsizlik qaydalarını yenidən danışıb hamıya eyni xəbərdarlığı edin.`,
      B: `Operatorla təkbətək danışıb yoxlamanı niyə ötürdüyünü aydınlaşdırın və maneəni birlikdə aradan qaldırın.`,
      C: `Yoxlamanı bir müddət operatora bildirmədən özünüz gizlicə təkrarlayın.`,
      D: `Operatora yoxlamanı ötürməyin yol verilməz olduğunu birbaşa və qəti bildirin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Təkrarlanan təhlükəsizlik pozuntusunda məqsəd davranışı dayandırıb səbəbi aradan qaldırmaqdır. B operatorla təkbətək danışıb maneəni həll edir, ən effektivdir. C yoxlamanı gizlicə özünüz təkrarlamaq operatorun davranışını dəyişmir, problemi sizin nəzarətinizdən asılı saxlayır və etimadı zədələyir, ən zəifdir. D qəti xəbərdarlıq pozuntunu dayandıra bilər, ancaq səbəbi açmır; A ümumi xatırlatma isə konkret operatora birbaşa təsir etmir.`,
  },
  {
    id: 'smt-m1-q23', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Briket sexində gözlənilməz bir anomaliyanı araşdırırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ağla gələn izahı kifayət sayıb araşdırmanı bağlayın.`,
      B: `Nəyi axtardığınızı dəqiqləşdirib aidiyyəti məlumatı toplayın.`,
      C: `Ən inandırıcı izahı seçib onu təsdiqləyən məlumatla möhkəmləndirin.`,
      D: `Bir neçə mümkün izah irəli sürüb hər birini ayrıca yoxlayın.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `Yaxşı araşdırma əvvəlcə nəyin axtarıldığını dəqiqləşdirib məlumat toplamaqla başlayır (B). Sonra bir neçə izahı qurub hər birini yoxlamaq gəlir (D). Yalnız ən inandırıcı izahı seçib onu təsdiqləyən məlumat axtarmaq təsdiq qərəzinə aparır (C). İlk izahı kifayət sayıb dayanmaq isə ən zəifdir, çünki yoxlanmamış nəticə risk yaradır (A).`,
  },
  {
    id: 'smt-m1-q24', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Daşınmaz əmlak qeydiyyatı masasında həmkarınıza rəy verirsiniz. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Ümumi şəkildə "daha diqqətli ol" deyin, konkret nümunə göstərmədən.`,
      B: `Konkret davranışa və onun nəticəsinə əsaslanan rəy verin.`,
      C: `Rəyi başqa həmkarların eşidəcəyi şəkildə açıq şəraitdə bildirin.`,
      D: `Davranışı qeyd edib həll yolunu birlikdə axtarın.`,
    },
    correct: { A: 2, B: 4, C: 1, D: 3 },
    explanation: `Effektiv rəy konkret davranışa və onun nəticəsinə əsaslanır (B, 4). Davranışı qeyd edib həlli birgə axtarmaq da güclüdür, sadəcə nəticəyə bağlılığı bir az zəifdir (D, 3). "Daha diqqətli ol" kimi ümumi qeyd konkretlik vermir (A, 2). Rəyi başqalarının yanında açıq vermək isə qarşı tərəfi müdafiəyə keçirir və ən az faydalıdır (C, 1).`,
  },
  {
    id: 'smt-m1-q25', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Seysmik monitorinq mərkəzində komanda üzvü gündəlik hesabatları natamam təqdim edir və bu, digər mərhələləri çətinləşdirir. İlk addım kimi ən effektiv davranış hansıdır?`,
    options: {
      A: `Hesabatların natamam hissəsini özünüz tamamlayıb işi davam etdirin.`,
      B: `Növbəti yığıncaqda natamam hesabatların nümunəsini göstərib komandaya standartı xatırladın.`,
      C: `Onunla təkbətək görüşüb hesabatların niyə natamam qaldığını aydınlaşdırın.`,
      D: `Hesabat şablonunu sərtləşdirib bütün komandaya icbari edin.`,
    },
    correct: 'C',
    explanation: `Problemin kökünü tapmaq üçün əvvəlcə həmin şəxslə birbaşa danışıb səbəbi aydınlaşdırmaq lazımdır (C). Natamam hissəni özünüz tamamlamaq işi qısamüddətli xilas etsə də problemi gizlədir (A). Yığıncaqda nümunə göstərmək dolayı təsir edir və şəxsə birbaşa çatmır (B). Şablonu bütün komandaya sərtləşdirmək isə bir nəfərin səbəbini həll etmədən hamıya yük gətirir (D).`,
  },
  {
    id: 'smt-m1-q26', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Taxıl anbarında rütubət göstəricisi gözlənilmədən qalxıb. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `İlk ağla gələn səbəbi qəbul edib dərhal tədbir görün.`,
      B: `Göstəricinin öz-özünə sabitləşəcəyini gözləyib müşahidəni davam etdirin.`,
      C: `Bir neçə mümkün izahı yoxlayıb məlumatı müqayisə edin.`,
      D: `Yalnız bir izaha uyğun məlumat toplayıb onu təsdiqləyin.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Gözlənilməz dəyişikliyin səbəbini tələsmədən, bir neçə ehtimalı müqayisə edərək tapmaq düzgündür (C). Göstəricinin öz-özünə düzələcəyini gözləmək rütubət riskini böyüdə bilər, ən zəif seçimdir (B). İlk səbəbə görə dərhal tədbir görmək yoxlanmamış qərardır (A); yalnız bir izahı təsdiqləyən məlumat toplamaq isə qərəzli nəticəyə aparır (D).`,
  },
  {
    id: 'smt-m1-q27', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Komandanızın iki üzvü ortaq bir tapşırığın vaxtında bitməməsində bir-birini günahlandırır və aralarındakı gərginlik işə təsir edir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Lazım olduqda məsələni yuxarı rəhbərə eskalasiya edin.`,
      B: `İkisini neytral, strukturlaşdırılmış vasitəçilik görüşündə bir araya gətirin.`,
      C: `Tərəfləri öz aralarında sakit və birbaşa söhbətə yönləndirin və bu söhbəti siz istiqamətləndirin.`,
      D: `Münaqişəni hələlik bir kənara qoyub hər kəsdən yalnız işə fokuslanmağı xahiş edin.`,
    },
    correct: ['C', 'B', 'A', 'D'],
    explanation: `Gərginlik işə artıq təsir edirsə, ən təsirli yol tərəfləri sakit, birbaşa söhbətə yönləndirib bu söhbəti istiqamətləndirməkdir (C). Bu alınmasa, neytral vasitəçilik görüşü növbəti addımdır (B). Yuxarı rəhbərə eskalasiya yalnız zərurət yarananda gəlir (A). Münaqişəni bir kənara qoyub sadəcə işə fokuslanmağı xahiş etmək cəlbedici görünsə də, işə təsir edən gərginlik qalır və gec-tez yenidən üzə çıxır, ona görə ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m1-q28', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Qaz paylama şöbəsində yeni növbə təhvil qaydası tətbiq olunur. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Qaydanı planlaşdırıldığı kimi tətbiq edin və sualları sonradan cavablandırın.`,
      B: `Yalnız yeni qaydanın üstünlüklərini izah edib komandanı inandırmağa çalışın.`,
      C: `Zərurəti faktlarla izah edin və narahatlıqları dinləyin.`,
      D: `Zərurəti izah edin, narahatlıqları dinləyin və ilk tətbiqi yaxından dəstəkləyib tənzimləyin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Ən güclü yanaşma izah, dinləmə və ilk tətbiqin dəstəklənməsini birləşdirir (D, 4). Zərurəti izah edib narahatlıqları dinləmək də yaxşıdır, sadəcə tətbiq dəstəyi yoxdur (C, 3). Yalnız üstünlükləri izah etmək birtərəflidir (B, 2). Qaydanı planlaşdırıldığı kimi tətbiq edib sualları sonraya saxlamaq isə narahatlıqları əvvəldən nəzərə almır, ən az təsirlidir (A, 1).`,
  },
  {
    id: 'smt-m1-q29', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Meteoroloji stansiyada gözlənilməz bir ölçü dəyişikliyi var və komanda dərhal bir səbəb təklif edir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Bir neçə mümkün izahı ayrıca yoxlayıb məlumatı müqayisə edin.`,
      B: `Təklif olunan səbəbi məntiqli sayıb ona uyğun tədbir görün.`,
      C: `Dəyişikliyi avadanlıq xətası kimi qeyd edib sonraya saxlayın.`,
      D: `Yalnız təklif olunan səbəbi dəstəkləyən məlumatı toplayıb təsdiqləyin.`,
    },
    correct: 'A',
    explanation: `Gözlənilməz dəyişikliyin səbəbini bir neçə ehtimalı müqayisə edərək yoxlamaq ən etibarlı yanaşmadır (A). Təklif olunan səbəbi yoxlamadan qəbul edib tədbir görmək tələsik qərardır (B). Dəyişikliyi avadanlıq xətasına yazıb sonraya saxlamaq yoxlanmamış gümandır (C). Yalnız bir səbəbi təsdiqləyən məlumat toplamaq isə qərəzli nəticə verir (D).`,
  },
  {
    id: 'smt-m1-q30', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bir saat ərzində bir neçə iş eyni anda üstünüzə gəlir: təcili müştəri şikayəti, sabaha planlanan adi hesabat, həmkarınızın xahişi və bir sistem bildirişi. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hər işin təsirini və son tarixini qısaca qiymətləndirib həm vacib, həm təcili olanı önə çəkin.`,
      B: `Əvvəlcə ən asan işləri görüb siyahını qısaldın.`,
      C: `Ən yüksək səslə tələb edənin işini birinci görün.`,
      D: `İşləri gəldiyi ardıcıllıqla, fərq qoymadan görün.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Diqqəti işin nəticəyə təsirinə və son tarixinə görə yönəltmək lazımdır. A hər işin təsirini və son tarixini qiymətləndirib həm vacib, həm təcili olanı önə çəkir, ən effektivdir. Ən yüksək səslə tələb edənin işini birinci görmək təzyiqi əhəmiyyətlə qarışdırır, ən az effektivdir (C). Yalnız asanları seçmək vacibləri təxirə salır (B); işləri gəldiyi ardıcıllıqla görmək fərq qoymur (D).`,
  },
  {
    id: 'smt-m1-q31', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Avtomobil qeydiyyatı şöbəsində qısa müddətə bitirilməli yeni, çoxmərhələli bir tapşırıq düşür və komanda üzvləri öz rollarına tam əmin deyil. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Vaxt azdır deyə dərhal işə başlayıb detalları gedişatda həll edin.`,
      B: `Tapşırıqları hər kəsin bacarığına və mövcud resursa görə bölüşdürün.`,
      C: `Aralıq yoxlama nöqtələri qoyub gedişatı izləyin.`,
      D: `Əvvəlcə məqsədi və prioritetləri aydınlaşdırıb komandaya çatdırın.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Rolların qeyri-müəyyən olduğu, vaxtın az olduğu bir tapşırıqda ən təsirli başlanğıc məqsəd və prioritetləri aydınlaşdırıb komandaya çatdırmaqdır (D), çünki bu, qalan addımların istiqamətini verir. Sonra işi bacarıq və resursa görə bölüşdürmək (B) və aralıq yoxlama nöqtələri qoymaq (C) gəlir. Vaxt azdır deyə birbaşa işə atılıb detalları gedişatda həll etmək cəlbedici görünür, lakin qarışıqlıq və yenidən işləmə riski yaradır, ona görə ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m1-q32', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Sürücülük imtahan mərkəzində bir tapşırığı həvalə edirsiniz. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Tapşırığı uyğun bacarığı olan şəxsə verin, gözləntini və səlahiyyət həddini aydın izah edin.`,
      B: `Uyğun şəxsi seçin, lakin izahı qısa saxlayın.`,
      C: `Tapşırığı verin, son tarix və gözləntiləri ətraflı danışmadan.`,
      D: `Tapşırığı özünüz icra edin, çünki həvalə etmək risklidir.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `Yaxşı həvalə bacarığa uyğun seçim, aydın gözlənti və səlahiyyət tələb edir (A, 4). Uyğun şəxsi seçib izahı qısa saxlamaq da işləyir, lakin natamamdır (B, 3). Tapşırığı özünüz görmək həvalədən imtinadır və inkişaf imkanını itirir (D, 2). Gözlənti və son tarixi izah etmədən vermək isə icranı təsadüfə buraxır, ən zəif seçimdir (C, 1).`,
  },
  {
    id: 'smt-m1-q33', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Filialda xidmət rəhbərisiniz. Müştəri sizin təsdiq etmək səlahiyyətinizdə olan məbləğdən böyük geri ödəniş tələb edir və cavabı dərhal gözləyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Məbləğ səlahiyyətinizi aşsa da, müştərini saxlamaq üçün geri ödənişi özünüz təsdiq edin.`,
      B: `Müştəriyə bu gün həll yolu olmadığını deyib sabah yenidən müraciət etməsini xahiş edin.`,
      C: `Bu məbləğin rəhbər təsdiqi tələb etdiyini izah edin və həmin gün rəhbərlə əlaqə saxlayıb cavab verin.`,
      D: `Məsələ ilə məşğul olmamaq üçün müştərini həmkarınıza yönəldib özünüz prosesdən çıxın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Səlahiyyət həddinizi aşan bir tələbdə düzgün yol məsələni vaxtında və lazımi şəxslə həll etməkdir: rəhbər təsdiqinin lazım olduğunu izah edib həmin gün rəhbərlə əlaqə saxlamaq həm qaydaya, həm müştəriyə hörmət edir (C). Müştərini səbəbsiz sabaha yönəltmək lazımsız gecikdirmədir (B); məsələni həmkara ötürüb çıxmaq məsuliyyəti üzərinizdən atmaqdır (D). Motiv nə olursa olsun, səlahiyyətinizi aşıb ödənişi özünüz təsdiqləmək ən riskli və ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m1-q34', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kitabxana kataloqlaşdırma şöbəsində çətin rəy söhbətini aparırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Qarşı tərəfin izahını dinləyin.`,
      B: `Müşahidə etdiyiniz konkret faktı qeyd edin.`,
      C: `Birlikdə həll və növbəti addımı razılaşdırın.`,
      D: `Rəyi ümumi, qeyri-dəqiq ifadələrlə verib konkret nümunə göstərməyin.`,
    },
    correct: ['B', 'A', 'C', 'D'],
    explanation: `Çətin rəy söhbətində ən təsirli başlanğıc müşahidə etdiyiniz konkret faktı qeyd etməkdir (B), sonra qarşı tərəfin izahını dinləmək (A) və birlikdə həll ilə növbəti addımı razılaşdırmaq (C). Rəyi ümumi, qeyri-dəqiq ifadələrlə verib konkret nümunə göstərməmək isə nə öyrədir, nə də inkişaf yolu açır, ona görə ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m1-q35', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Köçürmə şirkətində resurs çatışmazlığı var. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `İşlərin hamısını eyni vaxtda, prioritet qoymadan aparın.`,
      B: `Komandadan əlavə iş saatları tələb edib mövcud həcmi saxlayın.`,
      C: `Mövcud planı saxlayıb işləri sıxışdırmağa çalışın.`,
      D: `Məqsədə görə nəyin təxirə salınacağını şəffaf qərarlaşdırın.`,
    },
    correct: { A: 1, B: 3, C: 2, D: 4 },
    explanation: `Resurs çatışmazlığında ən təsirli addım məqsədə əsaslanıb nəyin təxirə salınacağını şəffaf müəyyən etməkdir (D, 4). Əlavə iş saatları ilə həcmi saxlamaq qısamüddətli kömək edir, lakin davamlı deyil (B, 3). Mövcud planı dəyişmədən işləri sıxışdırmaq gərginliyi artırır (C, 2). İşləri prioritet qoymadan eyni vaxtda aparmaq isə heç birinin tamamlanmamasına gətirir, ən az faydalı seçimdir (A, 1).`,
  },
  {
    id: 'smt-m1-q36', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qan vermə mərkəzində bir könüllü bir tapşırığı çatdıra bilmir və üzr istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Anlayış göstərib səbəbini soruşmadan son tarixi uzadın.`,
      B: `Onunla oturub konkret maneəni anlayın və real bir plan üzərində razılaşın.`,
      C: `Tapşırığı dərhal başqa könüllüyə ötürün.`,
      D: `Rəhbərə bildirib müddətin uzadılmasını xahiş edin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Əvvəlcə maneəni anlayıb real plan qurmaq həm tapşırığı, həm könüllünü qoruyur (B). Səbəbi soruşmadan sadəcə müddəti uzatmaq problemi təkrarlana bilən halda saxlayır, ən zəifdir (A). Tapşırığı dərhal başqasına ötürmək bu könüllünü kənarda qoyur (C); rəhbərdən müddət uzatması istəmək isə əsl maneəyə toxunmur (D).`,
  },
  {
    id: 'smt-m1-q37', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Bələdiyyə işıqlandırma şöbəsində dəyişiklik təşəbbüsünü idarə edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Köhnə üsulu birdən dayandırıb yeni üsula keçidi məcburi edin.`,
      B: `Komandanın narahatlıqlarını dinləyib hər kəsə uyğun dəstək verin.`,
      C: `Dəyişikliyi əvvəlcə kiçik bir hissədə tətbiq edib nəticəyə görə genişləndirin.`,
      D: `Dəyişikliyin zərurətini fakt və empatiya ilə izah edin.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Dəyişiklikdə əvvəlcə zərurəti fakt və empatiya ilə izah etmək təməl addımdır (D). Sonra narahatlıqları dinləyib dəstək vermək gəlir (B). Dəyişikliyi əvvəlcə kiçik bir hissədə tətbiq edib genişləndirmək də faydalıdır (C). Köhnə üsulu birdən dayandırıb keçidi məcburi etmək isə müqaviməti artırır, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m1-q38', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Liman gömrük məntəqəsində göstəricilərdən biri kəskin dəyişib. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Bir neçə izahı yoxlayıb müqayisə edin.`,
      B: `İlk ağla gələn izaha görə dərhal tədbir görün.`,
      C: `Məlumatı cədvələ salıb fərqin harada yarandığını axtarın.`,
      D: `Dəyişikliyi adi mövsümi dalğalanma sayıb növbəti hesabata qədər araşdırmayın.`,
    },
    correct: { A: 4, B: 2, C: 3, D: 1 },
    explanation: `Göstəricidəki kəskin dəyişikliyin səbəbini bir neçə izahı müqayisə edərək tapmaq ən doğru yanaşmadır (A, 4). Məlumatı cədvəlləşdirib fərqin harada yarandığını axtarmaq da güclü analitik addımdır (C, 3). İlk ağla gələn izaha görə dərhal tədbir görmək yoxlanmamış reaksiyadır (B, 2). Dəyişikliyi mövsümi dalğalanma sayıb araşdırmanı sonraya saxlamaq isə real problemin gözardı edilməsinə apara bilər, ən zəif seçimdir (D, 1).`,
  },
  {
    id: 'smt-m1-q39', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Daş karxanasında bacarıqlı bir üzvün icrası son vaxtlar zəifləyib. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Növbəti rəsmi qiymətləndirməyə qədər gözləyib sonra qaldırın.`,
      B: `Məsələni komanda müzakirəsində ümumi şəkildə qaldırın.`,
      C: `İşin bir hissəsini müvəqqəti olaraq başqasına verib izləyin.`,
      D: `Erkən, təkbətək və konkret nümunələrlə mehriban söhbət edib dəstək təklif edin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Bacarıqlı bir üzvün düşən performansına erkən, təkbətək və konkret nümunələrlə yanaşmaq ən effektivdir (D). Məsələni komanda müzakirəsində ümumi qaldırmaq həm şəxsə birbaşa çatmır, həm onu narahat edə bilər, ən az faydalı seçimdir (B). Rəsmi qiymətləndirməyə qədər gözləmək problemi gecikdirir (A); işin bir hissəsini başqasına vermək isə səbəbi həll etmədən simptomu örtür (C).`,
  },
  {
    id: 'smt-m1-q40', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Robot klubunda təkrarlanan bir problemə yeni həll axtarırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ideyanı tam şəkildə dərhal tətbiq edin.`,
      B: `Rəhbəri fayda və risklərlə inandırıb dəstək alın.`,
      C: `Bir neçə alternativ yaradıb kiçik miqyasda sınaqdan keçirin.`,
      D: `Problemə yeni baxış bucağından baxıb əsl səbəbi yenidən təhlil edin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `İnnovasiyada əvvəlcə problemə yeni baxışla yanaşıb əsl səbəbi təhlil etmək güclü başlanğıcdır (D). Sonra bir neçə alternativ qurub kiçik miqyasda sınamaq gəlir (C). Rəhbəri fayda və risklərlə inandırmaq dəstək qazandırır, ancaq həll hələ sınaqdan keçməyib (B). İlk ideyanı dərhal tam tətbiq etmək isə yoxlanmamış risk daşıyır, ən zəifdir (A).`,
  },
  {
    id: 'smt-m1-q41', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Universitet maliyyə şöbəsində rəhbərin göstərişi qismən qeyri-aydındır. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Göstərişi öz anladığınız kimi yozub işə başlayın.`,
      B: `İşi rəhbər əlavə izah verənə qədər saxlayın.`,
      C: `Bir-iki konkret sualla yalnız ən qeyri-aydın hissəni dəqiqləşdirin.`,
      D: `Anladığınızı qısaca təsdiqləyin və qeyri-aydın məqamları həll yönümlü dəqiqləşdirin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Ən güclü yanaşma anladığınızı təsdiqləyib qeyri-aydın məqamları həll yönümlü dəqiqləşdirməkdir (D, 4). Yalnız ən qaranlıq hissəni qısa sualla aydınlaşdırmaq da faydalıdır, sadəcə tam deyil (C, 3). İşi rəhbərin əlavə izahına qədər saxlamaq vaxt itirir (B, 2). Göstərişi öz yozumunuza görə başlamaq isə yanlış istiqamətə aparma riski yaradır, ən az təsirlidir (A, 1).`,
  },
  {
    id: 'smt-m1-q42', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kabel provayderində bir tanışınız qaydadan kiçik güzəşt istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Eyni qərarı tanışınız olmayan biri üçün də verib-verməyəcəyinizi düşünün və ona görə davranın.`,
      B: `Güzəşti sənədləşdirmədən, qeyri-rəsmi şəkildə yerinə yetirin.`,
      C: `Tanışınıza qaydanı dəyişdirmədən kömək edə biləcəyiniz başqa yol axtarın.`,
      D: `Güzəşti yerinə yetirin, çünki məsələ kiçikdir və kimsəyə zərər vermir.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Ən güclü yanaşma qərarı şəxsi tanışlıqdan asılı etməməkdir: eyni qərarı tanış olmayan biri üçün də verərdinizmi (A). Qaydanı pozmadan başqa yolla kömək axtarmaq da məqbuldur (C). Güzəşti kiçik sayıb yerinə yetirmək qaydanı şəxsi münasibətə görə əyir (D). Güzəşti sənədsiz, qeyri-rəsmi etmək isə şəffaflığı tamamilə pozur, ən zəif seçimdir (B).`,
  },
  {
    id: 'smt-m1-q43', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Qan analiz laboratoriyasında gözlənilməz vəziyyətdə qərar verməlisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ağla gələn variantı dərhal tətbiq edin.`,
      B: `Lazım gələrsə yuxarı səviyyəyə müraciət edin.`,
      C: `Variantları və onların təsirlərini müqayisə edin.`,
      D: `Qərar üçün kifayət qədər məlumat toplayıb vəziyyəti qiymətləndirin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Gözlənilməz vəziyyətdə əvvəlcə kifayət qədər məlumat toplayıb qiymətləndirmək lazımdır (D), sonra variantları və təsirlərini müqayisə etmək (C). Lazım olanda yuxarı səviyyəyə müraciət etmək də yerindədir, ancaq ilk addım deyil (B). İlk ağla gələn variantı dərhal tətbiq etmək isə yoxlanmamış risk daşıyır, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m1-q44', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Təqaüd ofisində bir göstəricinin yeni metodla yoxlanmasını sınamaq istəyirsiniz. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Kiçik bir nümunədə sınaqdan keçirib nəticəyə görə genişləndirin.`,
      B: `Metodu dərhal bütün hesablamalara tətbiq edin.`,
      C: `Köhnə və yeni metodu bir müddət paralel işlədib nəticələri tutuşdurun.`,
      D: `Metodu sınamadan birbaşa rəhbərə təqdim edin.`,
    },
    correct: { A: 4, B: 1, C: 3, D: 2 },
    explanation: `Yeni metodu əvvəlcə kiçik nümunədə sınayıb nəticəyə görə genişləndirmək riski idarə edir (A, 4). Köhnə və yeni metodu paralel işlədib tutuşdurmaq da güclü yoxlamadır, sadəcə daha çox resurs tələb edir (C, 3). Metodu sınamadan rəhbərə təqdim etmək yoxlama mərhələsini atlayır (D, 2). Metodu heç sınamadan bütün hesablamalara tətbiq etmək isə ən böyük riski yaradır (B, 1).`,
  },
  {
    id: 'smt-m1-q45', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yol təmiri briqadasında müxtəlif tərəflər fərqli nəticələr istəyir. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hər tərəflə ayrıca danışıb gözləntilərini idarə etməyə çalışın.`,
      B: `Ən nüfuzlu tərəfin istəyini qəbul edib qərarı ona görə verin.`,
      C: `Bütün tərəflərin maraqlarını şəffaf nəzərə alıb ortaq, ədalətli həll qurun.`,
      D: `Qərarı tərəflər öz aralarında razılığa gələnə qədər təxirə salın.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Fərqli maraqlar olan vəziyyətdə ən uyğun yanaşma bütün tərəfləri şəffaf və ədalətli prosesdə birləşdirməkdir (C). Tərəflərlə ayrıca danışıb gözləntiləri idarə etmək qismən kömək edir, lakin ortaq həll qurmur (A). Qərarı tərəflərin öz razılığına qədər təxirə salmaq prosesi dayandırır (D). Ən nüfuzlu tərəfin istəyini əsas götürmək isə ədaləti pozur və digər tərəfləri kənarda qoyur, ən zəifdir (B).`,
  },
  {
    id: 'smt-m1-q46', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `3D çap laboratoriyasında çoxşaxəli vəziyyətdə bacarıqlarınızı inteqrasiya edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Vəziyyətin tələb etdiyi bacarıqları müəyyən edin.`,
      B: `Yalnız ən güclü bacarığınıza güvənib onunla həll etməyə çalışın.`,
      C: `Uyğun bacarıqları birləşdirib həll qurun.`,
      D: `Nəticəni qiymətləndirib lazım olsa düzəliş edin.`,
    },
    correct: ['A', 'C', 'D', 'B'],
    explanation: `Çoxşaxəli vəziyyətdə əvvəlcə hansı bacarıqların lazım olduğunu müəyyən etmək lazımdır (A), sonra uyğun bacarıqları birləşdirib həll qurmaq (C) və nəticəni qiymətləndirib düzəliş etmək (D). Yalnız ən təsirli bacarığınıza güvənmək isə vəziyyətin digər tələblərini qarşılamır, ən az təsirlidir (B).`,
  },
  {
    id: 'smt-m1-q47', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `İmtahan nəzarəti komandasında bir maraqlar toqquşması görünüşü var. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Toqquşmanı açıqlayıb həmin işdən kənarlaşın.`,
      B: `Toqquşmanı rəsmiləşdirmədən işdə davam edin, qərarlarınızda obyektiv qalacağınıza güvənin.`,
      C: `Toqquşmanı yalnız özünüz üçün qeyd edin, lakin işdə davam edin.`,
      D: `Toqquşmanı rəhbərə bildirib necə davranacağınız barədə məsləhət alın.`,
    },
    correct: { A: 4, B: 1, C: 2, D: 3 },
    explanation: `Maraqlar toqquşmasında ən doğru addım onu açıqlayıb həmin işdən kənarlaşmaqdır (A, 4). Toqquşmanı rəhbərə bildirib məsləhət almaq da düzgündür, sadəcə kənarlaşma qərarını açıq saxlayır (D, 3). Toqquşmanı yalnız özünüz üçün qeyd edib işdə qalmaq açıqlama vermir (C, 2). Toqquşmanı rəsmiləşdirmədən obyektivliyinizə güvənmək isə onu açıqlamadan saxlayır, ən zəif seçimdir (B, 1).`,
  },
  {
    id: 'smt-m1-q48', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Marina idarəsində bir üzv etdiyi səhvi bildirməyə qorxur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səhvi indilik qeyd etməyib işin davam etməsinə imkan verin.`,
      B: `Səhvlərin açıq danışıldığı, öyrənmə fürsətinə çevrildiyi mühit yaradın.`,
      C: `Standartı qəti şəkildə xatırladın, lakin səhvin səbəbini ayrıca araşdırmadan söhbəti bağlayın.`,
      D: `Səhvləri yalnız özünüz aşkar edib səssizcə düzəldin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Üzv səhvini bildirməyə qorxursa, məqsəd açıq danışıla bilən, öyrənməyə çevrilən mühit yaratmaqdır (B). Səhvi indilik qeyd etməmək problemi həll etmir (A). Səhvləri yalnız özünüz tapıb səssizcə düzəltmək davamlı deyil və üzvün öyrənməsinə kömək etmir (D). Səbəbi araşdırmadan yalnız qəti xatırlatma ilə söhbəti bağlamaq isə qorxunu daha da artırır və bildirişi tam dayandırır, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'smt-m1-q49', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Avtobus deposunun idarəsində zəif performans göstərən bacarıqlı üzvə yanaşırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Performans məsələsini komanda toplantısında ümumi şəkildə qaldırın.`,
      B: `Birlikdə dəstək və inkişaf planı qurun.`,
      C: `Razılaşdırılmış nöqtələrlə irəliləyişi izləyin.`,
      D: `Erkən, təkbətək, konkret söhbət edin.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Düşən performansa əvvəlcə erkən, təkbətək və konkret söhbətlə yanaşmaq lazımdır (D), sonra birlikdə dəstək və inkişaf planı qurmaq (B) və razılaşdırılmış nöqtələrlə irəliləyişi izləmək (C). Məsələni komanda toplantısında ümumi qaldırmaq isə şəxsə birbaşa çatmır və onu narahat edə bilər, ən zəifdir (A).`,
  },
  {
    id: 'smt-m1-q50', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Elektrik billinq şöbəsində nəticələri çətin dəyişdirilən qərarla üzləşmisiniz, vaxt məhduddur. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Təsiri qiymətləndirib mümkünsə kiçik sınaqla riski azaldın.`,
      B: `Geri dönüşü çətin addımı yoxlamadan dərhal atın.`,
      C: `Qərarı daha çox məlumat toplanana qədər təxirə salın.`,
      D: `Qərarı səlahiyyəti olan başqa birinə ötürün.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Geri dönüşü çətin və vaxtın məhdud olduğu qərarda təsiri qiymətləndirib mümkünsə kiçik sınaqla riski azaltmaq ən uyğun yanaşmadır (A). Daha çox məlumat üçün təxirə salmaq vaxt məhdudiyyəti ilə ziddiyyət təşkil edir (C). Qərarı səlahiyyətli başqa birinə ötürmək bəzən yerinə düşür, lakin məsələ sizin həll edə biləcəyiniz çərçivədədir (D). Geri dönüşü çətin addımı yoxlamadan dərhal atmaq isə ən böyük riski yaradır (B).`,
  },
  {
    id: 'smt-m1-q51', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Su sayğacları idarəsində bir rəy söhbətini aparırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Müşahidə etdiyiniz konkret faktı qeyd edin.`,
      B: `Qarşı tərəfin izahını dinləyin.`,
      C: `Birlikdə həll yolunu razılaşdırın.`,
      D: `Konkret nümunə əvəzinə ümumi xarakteristika verin.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Yaxşı rəy söhbəti konkret müşahidə ilə başlayır (A), qarşı tərəfin izahı dinlənilir (B) və həll birlikdə razılaşdırılır (C). Konkret nümunə əvəzinə ümumi xarakteristika vermək isə nə dəqiq məlumat verir, nə də inkişafa yol açır, ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m1-q52', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Dron çatdırılması pilot layihəsində nəticəsi qeyri-müəyyən yeni bir marşrut sınamaq istəyirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yeni marşrutu mövcud marşrutlarla müqayisə edib fərqi qiymətləndirin.`,
      B: `Marşrutu sınamadan, nəticəsi qeyri-müəyyən olduğu üçün rədd edin.`,
      C: `Marşrutu dərhal tam miqyasda işə salın.`,
      D: `Hesablanmış risklə kiçik miqyasda sınaqdan keçirib nəticəyə görə qərar verin.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Nəticəsi qeyri-müəyyən yeni marşrutda ən güclü yanaşma hesablanmış risklə kiçik miqyasda sınamaq və nəticəyə görə qərar verməkdir (D). Marşrutu mövcud variantlarla müqayisə edib qiymətləndirmək də faydalıdır (A). Sınamadan rədd etmək potensial yaxşı həlli itirir (B). Marşrutu heç sınamadan dərhal tam miqyasda işə salmaq isə qeyri-müəyyən riski bütün əməliyyata yayır, ən zəif seçimdir (C).`,
  },
  {
    id: 'smt-m1-q53', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sənəd arxivləşdirmə layihəsində innovativ bir ideyanı reallaşdırırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ideyanı dərhal tam tətbiq edin.`,
      B: `Problemə yeni baxış bucağından baxıb əsl ehtiyacı dəqiqləşdirin.`,
      C: `Rəhbəri fayda və riskləri göstərərək inandırın.`,
      D: `Bir neçə alternativ qurub kiçik miqyasda sınaqdan keçirin.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `İnnovativ ideyada əvvəlcə problemə yeni baxışla yanaşıb əsl ehtiyacı dəqiqləşdirmək lazımdır (B). Sonra bir neçə alternativ qurub kiçik miqyasda sınamaq (D) və rəhbəri fayda-risklə inandırıb dəstək almaq gəlir (C). İlk ideyanı dərhal tam tətbiq etmək isə yoxlanmamış risk daşıyır, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m1-q54', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Su təmizləmə zavodunda iki üzv fərqli amillərlə motivasiya olur. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hər ikisinə öz işlədiyiniz motivasiya üsulunu tətbiq edin.`,
      B: `Hər birinin fərdi motivasiyasını anlayıb yanaşmanı uyğunlaşdırın.`,
      C: `Hər ikisinə eyni mükafat sistemini tətbiq edin.`,
      D: `Motivasiya fərqini əhəmiyyətsiz sayıb iş bölgüsünü dəyişmədən saxlayın.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `İki nəfər fərqli amillərlə motivasiya olunursa, ən təsirli yanaşma hər birinin motivasiyasını anlayıb yanaşmanı uyğunlaşdırmaqdır (B). Hər ikisinə eyni mükafat sistemini tətbiq etmək fərqi qismən nəzərə almır (C). Yalnız öz üslubunuzu tətbiq etmək başqasına uyğun gəlməyə bilər (A). Motivasiya fərqini əhəmiyyətsiz sayıb iş bölgüsünü dəyişməz saxlamaq isə ən zəifdir (D).`,
  },
  {
    id: 'smt-m1-q55', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Külək turbini sahəsində tərəfdaşa göndərilən hesabatda təkrarlanan xəta aşkar etdiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Xətanı səssizcə düzəldib tərəfdaşa və komandaya bildirməyin.`,
      B: `Növbəti rüblük hesabata qədər gözləyib sonra bildirin.`,
      C: `Xətanı erkən, şəffaf bildirib düzəliş yolunu təklif edin.`,
      D: `Məsələni dərhal yuxarı rəhbərliyə ötürün.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Təkrarlanan xətada ən doğru addım onu erkən, şəffaf bildirib düzəliş yolu təklif etməkdir (C). Növbəti rüblük hesabata qədər gözləmək bildirişi gecikdirir (B). Məsələni dərhal yuxarı rəhbərliyə ötürmək birbaşa düzəliş addımını atlayır (D). Xətanı səssizcə düzəldib heç kimə bildirməmək isə təkrarlanan problemi gizli saxlayır, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m1-q56', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Torpaq qeydiyyatı ofisində bir vətəndaş gecikmədən narazıdır və səsini qaldırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Növbə qaydasını qısaca deyib söhbəti tez yekunlaşdırın.`,
      B: `Vəziyyəti tez həll etmək üçün çatdıra bilməyəcəyiniz vədlər verin.`,
      C: `Sakit dinləyin, narahatlığını qəbul edin, vəziyyəti aydınlaşdırıb konkret addım bildirin.`,
      D: `Özünüzü haqlı çıxarmaq üçün vətəndaşla mübahisəyə girin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Narazı və səsini qaldıran vətəndaşla ən uyğun yanaşma sakit dinləyib narahatlığı qəbul etmək, vəziyyəti aydınlaşdırıb konkret addım bildirməkdir (C). Növbə qaydasını qısaca deyib söhbəti tez yekunlaşdırmaq narahatlığı arxa plana atır (A). Çatdıra bilməyəcəyiniz vədlər anlıq sakitləşdirsə də sonra etimadı pozur (B). Özünüzü haqlı çıxarmaq üçün vətəndaşla mübahisəyə girmək isə gərginliyi birbaşa artırıb vəziyyəti kəskinləşdirir, ən zəif seçimdir (D).`,
  },
  {
    id: 'smt-m1-q57', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Zavod uçotunda bir göstəricinin niyə dəyişdiyini araşdırırsınız. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Bir nəfərin təxmininə əsaslanıb səbəb barədə qərar verin.`,
      B: `Dəyişənləri nəzarətdə tutub strukturlu müqayisə aparın.`,
      C: `Məlumatı cədvələ salıb fərqin harada yarandığını axtarın.`,
      D: `Yalnız üstünlük verdiyiniz izaha uyğun məlumat toplayın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Dəyişikliyin səbəbini tapmaq üçün dəyişənləri nəzarətdə tutub strukturlu müqayisə aparmaq ən güclüsüdür (B). Məlumatı cədvəlləşdirib fərqin yerini axtarmaq da yaxşı analitik addımdır (C). Yalnız üstünlük verdiyiniz izaha uyğun məlumat toplamaq qərəzli nəticəyə aparır (D). Bir nəfərin təxmininə əsaslanıb qərar vermək isə heç bir təhlilə söykənmir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m1-q58', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Vergi apellyasiya şöbəsində komanda üzvünə tapşırıq həvalə edirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Tapşırığı uyğun bacarığı olan şəxsə verin, kontekst və səlahiyyəti aydın izah edin.`,
      B: `Tapşırığı kontekst və gözlənti vermədən həvalə edin.`,
      C: `Tapşırığı özünüz görün, çünki həvalə etmək risklidir.`,
      D: `İcraçını seçin, lakin izahı qısa saxlayın.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Effektiv həvalə uyğun bacarıq, aydın kontekst və səlahiyyət tələb edir (A). Uyğun şəxsi seçib izahı qısa saxlamaq qismən işləyir (D). Tapşırığı özünüz görmək həvalədən imtinadır, sizi yükləyir (C). Heç bir kontekst və gözlənti vermədən həvalə etmək isə icranı uğursuzluğa açıq qoyur, ən zəifdir (B).`,
  },
  {
    id: 'smt-m1-q59', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Komandanız yeni iş üsuluna keçidə soyuq yanaşır və narazılığını bildirir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Narazılığı eşitmədən keçidi birtərəfli elan edib müzakirəni bağlayın.`,
      B: `Narahatlığı dinləyib səbəbini anlayın, izah verin və keçidi addım-addım dəstəkləyin.`,
      C: `Narazılığı qeyd edib keçidi planlaşdırıldığı kimi davam etdirin.`,
      D: `Komandanın narazılığına görə keçidi bütövlükdə dayandırın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Yeni üsula soyuq yanaşan komanda ilə ən güclü yanaşma narahatlığı dinləyib səbəbini anlamaq, izah vermək və keçidi addım-addım dəstəkləməkdir (B). Narazılığı qeyd edib keçidi dəyişmədən davam etdirmək narahatlığa cavab vermir (C). Narazılığa görə keçidi tam dayandırmaq isə həddən artıq geri çəkilmədir (D). Narazılığı eşitmədən keçidi birtərəfli elan etmək isə müqaviməti gizlədib dərinləşdirir, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m1-q60', course: 'smt', mock_num: 1, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Səyyar laboratoriyada çoxşaxəli problem həm təhlil, həm ünsiyyət tələb edir. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yalnız ən təsirli bacarığınıza güvənib problemi onunla həll etməyə çalışın.`,
      B: `Bir neçə bacarığı səthi şəkildə, dərinə getmədən tətbiq edin.`,
      C: `Situasiyanın tələbinə görə uyğun bacarıqları tarazlı şəkildə birləşdirin.`,
      D: `Problemi hissələrə bölüb hər hissəni ayrıca başqasına ötürün.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Həm təhlil, həm ünsiyyət tələb edən çoxşaxəli problemdə ən doğru yanaşma situasiyanın tələbinə görə uyğun bacarıqları tarazlı birləşdirməkdir (C). Bir neçə bacarığı səthi tətbiq etmək heç birindən tam fayda vermir (B). Problemi hissələrə bölüb hər birini başqasına ötürmək bütövlüyü itirir (D). Yalnız ən uyğun bacarığınıza güvənmək isə problemin digər tərəflərini açıq qoyur, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m2-q1', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Hava limanı yer xidmətində bir komanda üzvü son günlər baqaj etiketlərini səhv yapışdırır və bu, gecikmələrə səbəb olur. Ən effektiv və ən az effektiv ilk addımı seçin.`,
    options: {
      A: `Səhvləri özünüz aşkar etdikcə səssizcə düzəldib işi davam etdirin.`,
      B: `Onunla təkbətək görüşüb səhvin niyə təkrarlandığını birlikdə aydınlaşdırın.`,
      C: `Düzgün etiketləmə qaydasını bütün komandaya yenidən izah edin.`,
      D: `Səhvlərin öz-özünə azalacağını gözləyib bir müddət müşahidə edin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Təkrarlanan səhvin kökünü tapmaq üçün əvvəlcə həmin üzvlə təkbətək danışıb səbəbi aydınlaşdırmaq lazımdır (B). Səhvləri özünüz səssizcə düzəltmək problemi gizlədir və gecikmələri saxlayır (A). Qaydanı bütün komandaya yenidən izah etmək konkret üzvə birbaşa təsir etmir (C). Səhvlərin öz-özünə azalacağını gözləmək isə davam edən gecikmələri uzadır, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'smt-m2-q2', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dəniz limanında gözlənilməz bir gecikmə yaranıb və qərar verməlisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ağla gələn variantı dərhal tətbiq edin.`,
      B: `Lazım olduqda rəhbərə eskalasiya edin.`,
      C: `Kifayət qədər məlumat toplayıb vəziyyəti qiymətləndirin.`,
      D: `Mümkün variantları və onların təsirini müqayisə edin.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `Gözlənilməz gecikmədə əvvəlcə kifayət qədər məlumat toplayıb vəziyyəti qiymətləndirmək lazımdır (C), sonra mümkün variantları və təsirlərini müqayisə etmək (D). Lazım olduqda rəhbərə eskalasiya etmək də yerindədir, ancaq ilk addım deyil (B). İlk ağla gələn variantı dərhal tətbiq etmək isə tələskənlikdir, ən zəifdir (A).`,
  },
  {
    id: 'smt-m2-q3', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Sığorta ofisində həmkarınıza rəy vermək istəyirsiniz. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Ümumi "daha diqqətli ol" qeydini edin, konkret nümunə göstərmədən.`,
      B: `Konkret bir hadisəyə, davranışa və onun nəticəsinə əsaslanan rəy verin.`,
      C: `Rəyi başqa həmkarların eşidəcəyi şəkildə açıq şəraitdə bildirin.`,
      D: `Davranışı qeyd edib həll yolunu birlikdə axtarın.`,
    },
    correct: { A: 2, B: 4, C: 1, D: 3 },
    explanation: `Güclü rəy konkret hadisəyə, davranışa və nəticəyə əsaslanır (B, 4). Davranışı qeyd edib həlli birgə axtarmaq da yaxşıdır (D, 3). "Daha diqqətli ol" kimi ümumi qeyd konkretlik vermir (A, 2). Rəyi başqalarının yanında açıq vermək isə qarşı tərəfi müdafiəyə keçirir, ən az təsirlidir (C, 1).`,
  },
  {
    id: 'smt-m2-q4', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kiçik komandaya rəhbərlik edirsiniz. İmza səlahiyyətinizdən böyük məbləğli təchizat müqaviləsi son tarixədək imzalanmalıdır, direktorunuz isə ezamiyyətdədir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səlahiyyətinizi aşsa da, müqaviləni özünüz imzalayın və direktora sonra məlumat verin.`,
      B: `Heç nə etməyib son tarixin ötməsinə imkan verin.`,
      C: `Məbləğin imza səlahiyyətinizdən yuxarı olduğunu qeyd edin, direktora əsas detalları göndərin və imzadan əvvəl yazılı təsdiq alın.`,
      D: `Narahatlıqdan bütün məsələni həmkarınızın üzərinə ötürün.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Ən güclü davranış nə səlahiyyəti aşmaq, nə də məsuliyyətdən qaçmaqdır: C imza hüdudunu tanıyır, direktora əsas detalları göndərib yazılı təsdiq alır. A müqaviləni özbaşına imzalamaq səlahiyyəti aşır və ən zəifdir. B son tarixin ötməsinə imkan vermək passivlikdir; D bütün məsələni həmkara ötürmək isə həddən artıq geri çəkilmədir.`,
  },
  {
    id: 'smt-m2-q5', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Süd zavodunda bir göstəricinin kəskin dəyişdiyini görürsünüz və komanda dərhal bir səbəb irəli sürür. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Təklif olunan səbəbi məntiqli sayıb ona uyğun tədbir görün.`,
      B: `Dəyişikliyi adi ölçü dalğalanması sayıb sonraya saxlayın.`,
      C: `Yalnız bu səbəbi dəstəkləyən məlumatı toplayıb təsdiqləyin.`,
      D: `Bir neçə mümkün izahı ayrıca yoxlayıb məlumatı müqayisə edin.`,
    },
    correct: 'D',
    explanation: `Kəskin dəyişikliyin səbəbini bir neçə ehtimalı müqayisə edərək yoxlamaq ən etibarlı yanaşmadır (D). Təklif olunan səbəbi yoxlamadan qəbul etmək tələsik qərardır (A). Dəyişikliyi adi dalğalanma sayıb saxlamaq yoxlanmamış gümandır (B). Yalnız bir səbəbi təsdiqləyən məlumat toplamaq isə qərəzli nəticə verir (C).`,
  },
  {
    id: 'smt-m2-q6', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bazar ertəsi səhəri qarşınızda dörd iş var: idarə heyətinə sabah çatdırılmalı sənəd, kiçik formatlaşdırma düzəlişi, qəzəbli müştəri məktubu və həmkarınızın sualı. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `İşləri vaciblik və vaxt həssaslığına görə çəkib ən kritik olanı birinci həll edin.`,
      B: `Əvvəlcə kiçik, asan işləri bitirib siyahını tez qısaldın.`,
      C: `Ən çox təzyiq göstərənin işini birinci görün.`,
      D: `İşləri gəldiyi ardıcıllıqla, fərq qoymadan icra edin.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `İşləri həm vacibliyə, həm vaxt həssaslığına görə çəkmək lazımdır. A iki meyar üzrə şüurlu prioritet qurduğu üçün ən təsirlidir. C qərarı təzyiqə görə verir, ən az təsirlidir. B yalnız rahatlığı seçir, D isə kortəbii yanaşmadır.`,
  },
  {
    id: 'smt-m2-q7', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dağ-xizək kurortunda iki həmkar arasında münaqişə yaranıb. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Tərəfləri öz aralarında sakit və birbaşa söhbətə yönləndirin və söhbəti istiqamətləndirin.`,
      B: `Neytral vasitəçiliklə hər ikisini bir masaya gətirin.`,
      C: `Lazım olduqda məsələni rəhbərə eskalasiya edin.`,
      D: `Daha haqlı gördüyünüz tərəfin mövqeyini qəbul edib məsələni bağlayın.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Əvvəlcə tərəfləri öz aralarında sakit, birbaşa söhbətə yönləndirib söhbəti istiqamətləndirmək ən effektivdir (A). Bu alınmazsa, neytral vasitəçilik gəlir (B), sonra lazım olduqda eskalasiya (C). Daha haqlı gördüyünüz tərəfi seçib məsələni bağlamaq isə araşdırmadan tərəf tutmaqdır, ən zəif seçimdir (D).`,
  },
  {
    id: 'smt-m2-q8', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Səsyazma studiyasında bacarıqlı bir üzvün performansı son vaxtlar zəifləyib. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Növbəti rəsmi qiymətləndirməyə qədər gözləyib sonra qaldırın.`,
      B: `Məsələni komanda müzakirəsində ümumi şəkildə qaldırın.`,
      C: `İşin bir hissəsini müvəqqəti başqasına verib izləyin.`,
      D: `Erkən, təkbətək və konkret nümunələrlə mehriban söhbət edib dəstək təklif edin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Düşən performansa erkən, təkbətək və konkret nümunələrlə yanaşmaq ən effektivdir (D). Məsələni komanda müzakirəsində ümumi qaldırmaq həm şəxsə birbaşa çatmır, həm onu narahat edə bilər, ən az faydalı seçimdir (B). Rəsmi qiymətləndirməyə qədər gözləmək problemi gecikdirir (A); işin bir hissəsini başqasına vermək isə səbəbi həll etmədən simptomu örtür (C).`,
  },
  {
    id: 'smt-m2-q9', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Peyvənd mərkəzində yeni qəbul proseduru tətbiq olunur və əməkdaşlar narahatdır. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Proseduru planlaşdırıldığı kimi tətbiq edin və sualları sonra cavablandırın.`,
      B: `Yalnız yeni prosedurun üstünlüklərini izah edib komandanı inandırmağa çalışın.`,
      C: `Zərurəti faktlarla izah edin və narahatlıqları dinləyin.`,
      D: `Zərurəti izah edin, narahatlıqları dinləyin və ilk tətbiqi yaxından dəstəkləyib tənzimləyin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Ən güclü yanaşma izah, dinləmə və ilk tətbiqin dəstəklənməsini birləşdirir (D, 4). Zərurəti izah edib narahatlıqları dinləmək də yaxşıdır, sadəcə tətbiq dəstəyi yoxdur (C, 3). Yalnız üstünlükləri izah etmək birtərəflidir (B, 2). Proseduru planlaşdırıldığı kimi tətbiq edib sualları sonraya saxlamaq isə narahatlıqları əvvəldən nəzərə almır, ən zəifdir (A, 1).`,
  },
  {
    id: 'smt-m2-q10', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bərə xidmətində bir tanışınız qaydadan kiçik güzəşt istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Eyni qərarı tanışınız olmayan biri üçün də verərdinizmi deyə düşünün və ona görə davranın.`,
      B: `Güzəşti sənədləşdirmədən, qeyri-rəsmi şəkildə yerinə yetirin.`,
      C: `Qaydanı pozmadan tanışınıza kömək edə biləcəyiniz başqa yol axtarın.`,
      D: `Güzəşti yerinə yetirin, çünki məsələ kiçikdir.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Ən güclü yanaşma qərarı şəxsi tanışlıqdan asılı etməməkdir (A). Qaydanı pozmadan başqa yolla kömək axtarmaq da məqbuldur (C). Güzəşti kiçik sayıb yerinə yetirmək qaydanı şəxsi münasibətə görə əyir (D). Güzəşti sənədsiz, qeyri-rəsmi etmək isə şəffaflığı tamamilə pozur, ən az təsirlidir (B).`,
  },
  {
    id: 'smt-m2-q11', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dulusçuluq emalatxanasında təkrarlanan bir problemə yeni həll axtarırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ideyanı tam şəkildə dərhal tətbiq edin.`,
      B: `Rəhbəri fayda və risklərlə əsaslandıraraq inandırıb dəstək alın.`,
      C: `Bir neçə alternativ yaradıb kiçik miqyasda sınaqdan keçirin.`,
      D: `Problemə yeni baxış bucağından baxıb əsl səbəbi yenidən təhlil edin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Əvvəlcə problemə yeni baxışla yanaşıb əsl səbəbi təhlil etmək güclü başlanğıcdır (D). Sonra bir neçə alternativ qurub kiçik miqyasda sınamaq gəlir (C). Rəhbəri fayda-risklə inandırmaq dəstək qazandırır, ancaq həll hələ sınanmayıb (B). İlk ideyanı dərhal tam tətbiq etmək isə yoxlanmamış risk daşıyır, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m2-q12', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Akvariumda müxtəlif şöbələr eyni resurs üçün fərqli tələblər irəli sürür. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hər şöbəyə ayrıca fərqli söz verin ki, hər biri razı qalsın.`,
      B: `Ən nüfuzlu şöbənin tələbini qəbul edib qərarı ona görə verin.`,
      C: `Bütün şöbələrin maraqlarını şəffaf nəzərə alıb ortaq, ədalətli həll qurun.`,
      D: `Qərarı şöbələr öz aralarında razılığa gələnə qədər təxirə salın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Fərqli tələblər olan vəziyyətdə bütün şöbələri şəffaf və ədalətli prosesdə birləşdirmək ən güclüdür (C). Ən nüfuzlu şöbənin tələbini qəbul etmək ədaləti pozur (B). Qərarı razılığa qədər təxirə salmaq prosesi dayandırır (D). Hər şöbəyə ayrıca ziddiyyətli söz vermək isə sonra etimadı bütövlükdə dağıdır, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m2-q13', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Botanika bağında bir tapşırığı komanda üzvünə həvalə edirsiniz. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Tapşırığı uyğun bacarığı olan şəxsə verin, kontekst və səlahiyyəti aydın izah edin.`,
      B: `Tapşırığı kontekst və gözlənti vermədən həvalə edin.`,
      C: `İcraçını düzgün seçin, lakin izahı qısa saxlayın.`,
      D: `Tapşırığı özünüz görün, etibar etmək risklidir.`,
    },
    correct: { A: 4, B: 1, C: 3, D: 2 },
    explanation: `Yaxşı həvalə uyğun bacarıq, aydın kontekst və səlahiyyət tələb edir (A, 4). Uyğun şəxsi seçib izahı qısa saxlamaq da işləyir, lakin natamamdır (C, 3). Tapşırığı özünüz görmək həvalədən imtinadır (D, 2). Heç bir kontekst və gözlənti vermədən həvalə etmək isə icranı uğursuzluğa açıq qoyur, ən zəifdir (B, 1).`,
  },
  {
    id: 'smt-m2-q14', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Rəsədxanada nəticələri çətin dəyişdirilən bir qərarla üzləşmisiniz və vaxt məhduddur. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Təsiri qiymətləndirib mümkünsə kiçik miqyaslı sınaqla riski azaldın.`,
      B: `Düzəldilməsi çətin nəticələr yaradan addımı yoxlamadan dərhal atın.`,
      C: `Qərarı daha çox məlumat toplanana qədər təxirə salın.`,
      D: `Qərarı səlahiyyəti olan başqa birinə ötürün.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Geri dönüşü çətin və vaxtın məhdud olduğu qərarda təsiri qiymətləndirib mümkünsə kiçik sınaqla riski azaltmaq ən güclü yanaşmadır (A). Daha çox məlumat üçün təxirə salmaq vaxt məhdudiyyəti ilə ziddiyyət təşkil edir (C). Qərarı səlahiyyətli başqa birinə ötürmək bəzən yerinə düşür, lakin məsələ sizin çərçivənizdədir (D). Geri dönüşü çətin addımı yoxlamadan dərhal atmaq isə ən böyük riski yaradır (B).`,
  },
  {
    id: 'smt-m2-q15', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Gəmiqayırma sahəsində çətin bir rəy söhbətini aparırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Qarşı tərəfin izahını dinləyin.`,
      B: `Müşahidə etdiyiniz konkret faktı qeyd edin.`,
      C: `Birlikdə həll yolu və növbəti addımı razılaşdırın.`,
      D: `Konkret nümunə əvəzinə ümumi xarakteristika verib söhbəti bitirin.`,
    },
    correct: ['B', 'A', 'C', 'D'],
    explanation: `Söhbət konkret faktın qeyd edilməsi ilə başlayır (B), sonra qarşı tərəfin izahı dinlənilir (A) və həll birlikdə razılaşdırılır (C). Konkret nümunə əvəzinə ümumi xarakteristika verib söhbəti bitirmək isə nə öyrədir, nə həll göstərir, ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m2-q16', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Soyuducu anbarda tərəfdaş təşkilata göndərilən sənəddə təkrarlanan xəta aşkar etdiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Xətanı səssizcə düzəldib tərəfdaşa və komandaya bildirməyin.`,
      B: `Növbəti rüblük hesabata qədər gözləyib sonra bildirin.`,
      C: `Məsələni dərhal ən yuxarı rəhbərliyə ötürün.`,
      D: `Xətanı erkən, şəffaf bildirib düzəliş yolunu təklif edin.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Təkrarlanan xətada ən təsirli addım onu erkən, şəffaf bildirib düzəliş yolu təklif etməkdir (D). Növbəti rüblük hesabata qədər gözləmək bildirişi gecikdirir (B). Məsələni dərhal ən yuxarı rəhbərliyə ötürmək birbaşa düzəliş addımını atlayır (C). Xətanı səssizcə düzəldib heç kimə bildirməmək isə təkrarlanan sistemli problemi gizli saxlayır, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m2-q17', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Taksi parkının yenidən təşkili eyni anda dəqiq təhlil, aydın ünsiyyət və planlaşdırma tələb edir. Güclü tərəfiniz təhlildir. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Yalnız ən doğru bacarığınıza, təhlilə güvənin.`,
      B: `Bir neçə bacarığı səthi tətbiq edib heç birinə dərinləşməyin.`,
      C: `Situasiyanın tələbinə uyğun olaraq təhlil, ünsiyyət və planlaşdırmanı birləşdirin.`,
      D: `Təhlili özünüz aparın, ünsiyyət və planlaşdırmanı isə tam başqalarına ötürün.`,
    },
    correct: 'C',
    explanation: `Çoxtərəfli iş situasiyanın tələbinə görə təhlil, ünsiyyət və planlaşdırmanın birləşdirilməsini tələb edir (C). Yalnız ən uyğun tərəfinizə güvənmək digər tələbləri qarşılamır (A). Bir neçə bacarığı səthi tətbiq etmək heç birindən tam fayda vermir (B). Təhlili özünüz görüb qalanını tamamilə başqalarına ötürmək isə işin bütövlüyünü itirir (D).`,
  },
  {
    id: 'smt-m2-q18', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çay emalı sexində bir üzv etdiyi səhvi bildirməyə qorxur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səhvi indilik qeyd etməyib işin davam etməsinə imkan verin.`,
      B: `Səhvlərin açıq danışıldığı, öyrənmə fürsətinə çevrildiyi mühit yaradın.`,
      C: `Standartı qəti şəkildə xatırladın, lakin səhvin səbəbini ayrıca araşdırmadan söhbəti bağlayın.`,
      D: `Səhvləri yalnız özünüz aşkar edib səssizcə düzəldin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Üzv səhvini bildirməyə qorxursa, məqsəd açıq danışıla bilən, öyrənməyə çevrilən mühit yaratmaqdır (B). Səhvi indilik qeyd etməmək problemi həll etmir (A). Səhvləri yalnız özünüz tapıb düzəltmək davamlı deyil (D). Səbəbi araşdırmadan yalnız qəti xatırlatma ilə söhbəti bağlamaq isə qorxunu daha da artırır və bildirişi dayandırır, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'smt-m2-q19', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Bir əməkdaşınız yeni iş üsuluna keçməyə qarşı çıxır. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Etirazı eşitmədən keçidi birtərəfli tətbiq edib müzakirəni bağlayın.`,
      B: `Etirazı qismən dinləyib keçin.`,
      C: `Narahatlığın səbəbini soruşub anlayın.`,
      D: `Səbəbi anlayıb fərdi dəstək verin və keçidi kiçik, izlənən addımlarla başladın.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Keçidə narazılıqda əsas məsələ narahatlığın səbəbini anlamaqdır. D səbəbi anlayır, fərdi dəstək verir və keçidi kiçik, izlənən addımlarla başladır, ona görə ən təsirlidir. C səbəbi soruşmaq baxımından düzgündür, lakin dəstək və addım planı əlavə etmir. B qismən dinləmədir. A etirazı eşitmədən birtərəfli tətbiq etdiyi üçün ən zəifdir.`,
  },
  {
    id: 'smt-m2-q20', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kağız fabrikində komanda üzvü Vüsal bir tapşırığı çatdıra bilmir və üzr istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Anlayış göstərib səbəbini soruşmadan son tarixi uzadın.`,
      B: `Tapşırığı dərhal başqasına ötürün, vaxt itirmək olmaz.`,
      C: `Vüsalla oturub konkret maneəni anlayın və real həll planı qurun.`,
      D: `Rəhbərə bildirib son tarixin uzadılmasını xahiş edin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Əvvəlcə konkret maneəni anlayıb real plan qurmaq həm tapşırığı, həm Vüsalı qoruyur (C). Səbəbi soruşmadan sadəcə müddəti uzatmaq problemi təkrarlana bilən halda saxlayır, ən zəifdir (A). Tapşırığı dərhal başqasına ötürmək Vüsalı kənarda qoyur (B); rəhbərdən müddət uzatması istəmək isə əsl maneəyə toxunmur (D).`,
  },
  {
    id: 'smt-m2-q21', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `İstixanada yeni bir təşkilati tapşırığı planlaşdırırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İşə dərhal başlayıb detalları gedişat zamanı həll edin.`,
      B: `Tapşırıqları komandanın resurs və bacarığına uyğun bölüşdürün.`,
      C: `Aralıq yoxlama nöqtələri qoyub icranı izləyin.`,
      D: `Məqsədi və prioritetləri aydınlaşdırın.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Yaxşı plan məqsəd və prioritetlərin aydınlaşdırılması ilə başlayır (D), sonra işin komandanın resurs və bacarığına görə bölüşdürülməsi (B) və aralıq nöqtələrlə izlənməsi (C) gəlir. Plansız dərhal başlayıb detalları gedişatda həll etmək isə yenidən işləmə riski yaradır, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m2-q22', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Heyvan sığınacağında bir göstəricinin niyə dəyişdiyini araşdırırsınız. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Bir iştirakçının ötəri fikrinə əsaslanıb səbəb barədə qərar verin.`,
      B: `Yalnız ən çox güvəndiyiniz izaha uyğun məlumatı toplayın.`,
      C: `Dəyişənləri nəzarətdə tutub strukturlu müqayisə aparın.`,
      D: `Məlumatı cədvələ salıb fərqin harada yarandığını axtarın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Səbəbi tapmaq üçün dəyişənləri nəzarətdə tutub strukturlu müqayisə aparmaq ən güclüsüdür (C). Məlumatı cədvəlləşdirib fərqin yerini axtarmaq da yaxşı addımdır (D). Yalnız güvəndiyiniz izaha uyğun məlumat toplamaq qərəzli nəticə verir (B). Bir iştirakçının ötəri fikrinə əsaslanıb qərar vermək isə heç bir təhlilə söykənmir, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m2-q23', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Ərzaq bankında həmkarınız problemini sizinlə paylaşır. Aşağıdakı reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Öz oxşar təcrübənizi danışmağa başlayıb söhbəti öz üzərinizə çəkin.`,
      B: `"Bu o qədər də ciddi deyil" deyib narahatlığı kiçildin.`,
      C: `Dərhal hazır həll təklif edib məsələni tez bağlayın.`,
      D: `Diqqətlə dinləyin, anladığınızı təsdiqləyin, sonra birlikdə həll axtarın.`,
    },
    correct: { A: 2, B: 1, C: 3, D: 4 },
    explanation: `Həmkar problemini paylaşanda ən güclü reaksiya diqqətlə dinləyib anladığını təsdiqləmək, sonra birlikdə həll axtarmaqdır (D, 4). Dərhal hazır həll təklif etmək niyyət yaxşı olsa da tələsikdir (C, 3). Söhbəti öz təcrübənizə çevirmək diqqəti yayındırır (A, 2). Narahatlığı "ciddi deyil" deyə kiçiltmək isə qarşı tərəfi bağlayır, ən az faydalı seçimdir (B, 1).`,
  },
  {
    id: 'smt-m2-q24', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qrant komitəsində qiymətləndirməli olduğunuz layihələrdən biri yaxın tanışınızındır və onunla şəxsi əlaqəniz qərarınıza təsir edə bilər. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Maraqlar toqquşmasını açıqlayıb həmin layihənin qiymətləndirilməsindən kənarlaşın.`,
      B: `Tanışınızın layihəsini qiymətləndirib ona üstünlük verin.`,
      C: `Heç nə bildirmədən qiymətləndirin, obyektiv qalacağınıza əminsiniz.`,
      D: `Etiraz əlaməti olaraq komitədəki bütün layihələri qiymətləndirməkdən imtina edin.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Şəxsi əlaqə qərara təsir edə bilirsə, maraqlar toqquşması realdır və kənarlaşmaq tələb olunur: onu açıqlayıb həmin layihədən çəkilmək ən düzgündür (A). Heç nə bildirmədən qiymətləndirmək toqquşmanı gizli saxlayır (C). Bütün layihələri rədd etmək həddən artıq, işi pozan reaksiyadır (D). Tanışınızın layihəsinə üstünlük vermək isə qərarın ədalətini birbaşa korlayır, ən zəifdir (B).`,
  },
  {
    id: 'smt-m2-q25', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Soyuq zəncir laboratoriyasında qəfil bir avadanlıq nasazlığı nümunələri riskə atır. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Nasazlığın əsl səbəbini tapmadan ilk ağla gələn düzəlişi tətbiq edin.`,
      B: `Təsirə məruz qalan nümunələri dərhal qoruyub riski məhdudlaşdırın.`,
      C: `Aidiyyəti şəxsləri və növbəni vəziyyətdən xəbərdar edin.`,
      D: `Nasazlığın səbəbini araşdırıb təkrarlanmaması üçün tədbir görün.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Qəfil nasazlıqda əvvəlcə təsirə məruz qalanı qoruyub riski məhdudlaşdırmaq lazımdır (B), sonra aidiyyəti şəxsləri xəbərdar etmək (C), ardınca səbəbi araşdırıb təkrarın qarşısını almaq (D). Səbəbi tapmadan ilk ağla gələn düzəlişi tətbiq etmək isə problemi gizlədib təkrarlana bilər, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m2-q26', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çilingər xidmətində iki üzv fərqli amillərlə motivasiya olur. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hər ikisinə öz işlədiyiniz motivasiya üsulunu tətbiq edin.`,
      B: `Hər birinin fərdi motivasiyasını anlayıb yanaşmanı uyğunlaşdırın.`,
      C: `Hər ikisinə eyni mükafat sistemini tətbiq edin.`,
      D: `Motivasiya fərqini əhəmiyyətsiz sayıb yanaşmanı dəyişməyin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `İki nəfər fərqli amillərlə motivasiya olunursa, ən təsirli yanaşma hər birinin motivasiyasını anlayıb yanaşmanı uyğunlaşdırmaqdır (B). Eyni mükafat sistemi fərqi qismən nəzərə almır (C). Yalnız öz üslubunuzu tətbiq etmək başqasına uyğun gəlməyə bilər (A). Motivasiya fərqini əhəmiyyətsiz sayıb yanaşmanı dəyişməmək isə ən zəif seçimdir (D).`,
  },
  {
    id: 'smt-m2-q27', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Şüşə emalı sahəsində nəticəsi qeyri-müəyyən yeni üsul sınamaq istəyirsiniz. Aşağıdakı yanaşmaları effektivlik səviyyəsinə görə 1-dən 4-ə qədər qiymətləndirin. 1 - ən zəif, 4 - ən güclü.`,
    options: {
      A: `Yeni üsulu mövcud üsulla yan-yana sınayıb nəticələri tutuşdurun.`,
      B: `Kiçik miqyasda sınayıb nəticəyə görə tətbiqi genişləndirin.`,
      C: `Yeni üsulu dərhal bütün sahədə tətbiq edin.`,
      D: `Üsulu özünüz sınamadan rəhbərə təsdiq üçün təqdim edin.`,
    },
    correct: { A: 3, B: 4, C: 1, D: 2 },
    explanation: `Nəticəsi qeyri-müəyyən üsulda ən doğru yanaşma kiçik miqyasda sınayıb nəticəyə görə genişləndirməkdir (B, 4). Yeni üsulu mövcud üsulla yan-yana sınayıb tutuşdurmaq da güclü yoxlamadır (A, 3). Üsulu özünüz sınamadan rəhbərə təqdim etmək yoxlama mərhələsini atlayır (D, 2). Yeni üsulu dərhal bütün sahədə tətbiq etmək isə yoxlanmamış riski hər yerə yayır, ən az faydalı seçimdir (C, 1).`,
  },
  {
    id: 'smt-m2-q28', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bələdiyyə xidmət mərkəzində bir vətəndaş gecikmədən narazıdır və səsini qaldırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Vətəndaşa növbə qaydasını qısaca deyib əlavə suallarına vaxt ayırmayın.`,
      B: `Vəziyyəti tez bağlamaq üçün çatdıra bilməyəcəyiniz vədlər verin.`,
      C: `Sakit dinləyin, narahatlığını qəbul edin, vəziyyəti aydınlaşdırıb konkret addım bildirin.`,
      D: `Özünüzü haqlı çıxarmaq üçün vətəndaşla mübahisəyə girin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Narazı və səsini qaldıran vətəndaşla ən uyğun yanaşma sakit dinləyib narahatlığı qəbul etmək və konkret addım bildirməkdir (C). Növbə qaydasını qısaca deyib əlavə suala vaxt ayırmamaq narahatlığı arxa plana atır (A). Çatdıra bilməyəcəyiniz vədlər anlıq sakitləşdirsə də sonra etimadı pozur (B). Özünüzü haqlı çıxarmaq üçün vətəndaşla mübahisəyə girmək isə gərginliyi birbaşa artırıb vəziyyəti kəskinləşdirir, ən zəifdir (D).`,
  },
  {
    id: 'smt-m2-q29', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Rəqəmsal arxiv xidmətində bir istifadəçi getdikcə artan narazılıqla problemini bildirir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İstifadəçini sakit dinləyib narahatlığını qəbul edin.`,
      B: `Özünüzü haqlı çıxarmaq üçün izahlara keçib mövqeyinizi müdafiə edin.`,
      C: `Problemin konkret nə olduğunu dəqiqləşdirin.`,
      D: `Həll təklif edin və ya real gözlənti bildirib növbəti addımı razılaşdırın.`,
    },
    correct: ['A', 'C', 'D', 'B'],
    explanation: `Artan narazılıqda əvvəlcə istifadəçini dinləyib narahatlığı qəbul etmək lazımdır (A), sonra problemin konkret nə olduğunu dəqiqləşdirmək (C) və həll təklif edib və ya real gözlənti bildirib növbəti addımı razılaşdırmaq (D). Özünüzü müdafiəyə keçib izah verməyə başlamaq isə gərginliyi artırır, ən az təsirlidir (B).`,
  },
  {
    id: 'smt-m2-q30', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Gömrük terminalında gözlənilməz bir anomaliyanı araşdırırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ağla gələn izahı doğru sayıb işi bağlayın.`,
      B: `Sualı dəqiqləşdirib mövcud məlumatı toplayın.`,
      C: `Ən güclü görünən izahı yalnız onu təsdiqləyən məlumatla möhkəmləndirin.`,
      D: `Bir neçə mümkün izah qurub hər birini ayrıca yoxlayın.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `Araşdırma sualı dəqiqləşdirib məlumat toplamaqla başlayır (B), sonra bir neçə izahı qurub hər birini yoxlamaq gəlir (D). Yalnız ən güclü izahı təsdiqləyən məlumatla möhkəmləndirmək təsdiq qərəzinə aparır (C). İlk izahı doğru sayıb işi bağlamaq isə yoxlanmamış nəticə riski yaradır, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m2-q31', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Mebel fabrikində bir usta təhlükəsizlik qaydasını ardıcıl pozur. Ən effektiv və ən az effektiv ilk addımı seçin.`,
    options: {
      A: `Bütün sexə təhlükəsizlik qaydalarını yenidən danışıb hamıya eyni xəbərdarlığı edin.`,
      B: `Usta ilə təkbətək görüşüb pozuntunun səbəbini birlikdə anlayın və maneəni aradan qaldırın.`,
      C: `Qaydanı bir müddət ustadan gizli, özünüz onun yerinə yoxlayın.`,
      D: `Ustaya pozuntunun yol verilməz olduğunu birbaşa, qəti bildirin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Təkrarlanan təhlükəsizlik pozuntusunda usta ilə təkbətək danışıb səbəbi anlamaq və maneəni aradan qaldırmaq ən effektivdir (B). Bütün sexə ümumi xatırlatma konkret ustaya birbaşa təsir etmir (A). Qəti birbaşa xəbərdarlıq pozuntunu dayandıra bilər, ancaq səbəbi açmır (D). Qaydanı gizli, ustanın əvəzinə özünüz yoxlamaq isə onun davranışını dəyişmir və problemi sizdən asılı saxlayır, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'smt-m2-q32', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Keramika sexində son tarix yaxındır, lakin resurs çatışmır və hər işi vaxtında bitirmək mümkün deyil. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Bütün işləri eyni anda aparıb hamısını çatdırmağa çalışın.`,
      B: `Hansı işlərin əsas, hansının təxirəsalına bilən olduğunu müəyyən edin.`,
      C: `Resursu ən vacib nəticəyə təsir edən işlərə yönəldin.`,
      D: `Hansı işlərin gecikəcəyini aidiyyəti tərəflərə əvvəlcədən şəffaf bildirin.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Resurs çatışmazlığında əvvəlcə nəyin əsas, nəyin təxirəsalına bilən olduğunu müəyyən etmək lazımdır (B), sonra resursu ən vacib nəticəyə yönəltmək (C) və hansı işlərin gecikəcəyini əvvəlcədən şəffaf bildirmək (D). Bütün işləri eyni anda aparıb hamısını çatdırmağa çalışmaq isə qüvvəni dağıdır, ən zəifdir (A).`,
  },
  {
    id: 'smt-m2-q33', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Dizayn studiyasında rəhbəriniz işinizlə bağlı tənqidi rəy verir. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Nəzakətlə qəbul edin, amma heç bir dəqiqləşdirici sual vermədən keçin.`,
      B: `Diqqətlə dinləyin, konkret nümunələri aydınlaşdırın və nəyi necə dəyişəcəyinizi soruşun.`,
      C: `Dərhal özünüzü müdafiə edib rəyi rədd edin.`,
      D: `Rəyi qəbul edib təşəkkür edin, lakin sonra üzərində düşünməyin.`,
    },
    correct: { A: 3, B: 4, C: 1, D: 2 },
    explanation: `Tənqidi rəy alanda ən təsirli reaksiya diqqətlə dinləyib konkret nümunələri aydınlaşdırmaq və nəyi necə dəyişəcəyinizi soruşmaqdır (B, 4). Rəyi nəzakətlə qəbul etmək, dəqiqləşdirici sual verməsəniz də, onu rədd etmədiyiniz üçün məqbuldur (A, 3). Rəyi qəbul edib təşəkkür etmək, lakin sonra üzərində düşünməmək nəzakətli görünsə də boşdur (D, 2). Dərhal müdafiəyə keçib rəyi rədd etmək isə inkişaf yolunu bağlayır, ən az təsirlidir (C, 1).`,
  },
  {
    id: 'smt-m2-q34', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Muzey inzibatında komanda üzvü hesabatları natamam təqdim edir və bu, digər işləri çətinləşdirir. İlk addım kimi ən effektiv davranış hansıdır?`,
    options: {
      A: `Natamam hissəni özünüz tamamlayıb işi davam etdirin.`,
      B: `Növbəti yığıncaqda natamam hesabatların nümunəsini göstərib standartı xatırladın.`,
      C: `Onunla təkbətək görüşüb hesabatların niyə natamam qaldığını aydınlaşdırın.`,
      D: `Hesabat şablonunu sərtləşdirib bütün komandaya icbari edin.`,
    },
    correct: 'C',
    explanation: `Problemin kökünü tapmaq üçün əvvəlcə həmin şəxslə təkbətək danışıb səbəbi aydınlaşdırmaq lazımdır (C). Natamam hissəni özünüz tamamlamaq problemi gizlədir (A). Yığıncaqda nümunə göstərmək dolayı təsir edir (B). Şablonu bütün komandaya sərtləşdirmək isə bir nəfərin səbəbini həll etmədən hamıya yük gətirir (D).`,
  },
  {
    id: 'smt-m2-q35', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çörək zavodunda bir partiyanın keyfiyyəti gözlənilmədən düşüb, lakin sifariş son tarixi yaxındır. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `İstehsalı dərhal bütövlükdə dayandırıb səbəbi tapana qədər heç nə buraxmayın.`,
      B: `Son tarixə görə düşüşü qeyd etməyib partiyanı olduğu kimi göndərin.`,
      C: `Düşüşün ciddiliyini tez qiymətləndirib buna görə davam etmək və ya dayandırmaq qərarını verin.`,
      D: `Partiyanı göndərib problemi sonrakı partiyalarda araşdırın.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Keyfiyyət düşüb, lakin son tarix yaxındırsa, ən doğru yanaşma düşüşün ciddiliyini tez qiymətləndirib buna uyğun davam və ya dayanma qərarı verməkdir (C). İstehsalı tam dayandırmaq ciddiliyi yoxlamadan həddən artıq reaksiya ola bilər (A). Partiyanı göndərib sonra araşdırmaq riski növbəti partiyalara keçirir (D). Düşüşü qeyd etməyib partiyanı olduğu kimi göndərmək isə keyfiyyəti son tarixə qurban verir, ən zəif seçimdir (B).`,
  },
  {
    id: 'smt-m2-q36', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `İki həmkarınız layihənin gedişatı barədə kəskin fikir ayrılığındadır və mübahisə hər görüşdə təkrarlanır. Ən effektiv ardıcıllıqla sıralayın.`,
    options: {
      A: `Lazım olduqda məsələni rəhbərliyə ötürün.`,
      B: `Neytral vasitəçi ilə hər ikisini bir masa arxasına dəvət edin.`,
      C: `Hər iki tərəfi sakit, birbaşa söhbətə yönləndirib mövqelərini aydınlaşdırmağa kömək edin.`,
      D: `Daha haqlı saydığınız tərəfin mövqeyini seçib digərinə qəbul etdirin.`,
    },
    correct: ['C', 'B', 'A', 'D'],
    explanation: `Təkrarlanan mübahisədə əvvəlcə tərəfləri sakit, birbaşa söhbətə yönləndirib mövqeləri aydınlaşdırmaq ən effektivdir (C). Alınmasa, neytral vasitəçilik (B), sonra lazım olduqda eskalasiya (A). Daha haqlı saydığınız tərəfi seçib digərinə qəbul etdirmək isə araşdırmadan tərəf tutmaqdır, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'smt-m2-q37', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Mühasibatlıqda gözlənilməz bir problem layihəni gecikdirir və komandanı məlumatlandırmalısınız. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Problemi komandadan gizlədib özünüz həll etməyə çalışın.`,
      B: `Yalnız müsbət tərəfləri deyib gecikməni kiçildin.`,
      C: `Gecikməni açıq deyin, lakin necə davam edəcəyinizi izah etmədən.`,
      D: `Gecikməni açıq deyin, səbəbini izah edin və növbəti addım planını paylaşın.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Gecikməni komandaya çatdırmağın ən uyğun yolu onu açıq demək, səbəbini izah etmək və növbəti addım planını paylaşmaqdır (D, 4). Gecikməni açıq demək, lakin planı izah etməmək komandanı qeyri-müəyyənlikdə saxlayır (C, 3). Yalnız müsbət tərəfləri deyib gecikməni kiçiltmək etibarı zədələyir (B, 2). Problemi gizlədib tək həll etməyə çalışmaq isə sonradan daha böyük problem yaradır, ən zəifdir (A, 1).`,
  },
  {
    id: 'smt-m2-q38', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Zərər tələblərinə baxan rəhbər kimi qarşınızda var: tənzimləyici orqanın son tarixi olan iş, çoxlu adi tələb yığını, VIP müştəri şikayəti və həmkar xahişi. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hər işin nəticəsini və son tarixini qiymətləndirib həm vacib, həm təxirəsalınmaz olanı önə çəkin.`,
      B: `Əvvəlcə adi, asan tələbləri seçib siyahını qısaldın.`,
      C: `Ən çox təzyiq edənin işini birinci görün.`,
      D: `İşləri gəldiyi sıra ilə, fərq qoymadan görün.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Çoxlu iş eyni anda gələndə hər birinin nəticəyə təsirini və son tarixini qiymətləndirib həm vacib, həm təxirəsalınmazı önə çəkmək ən effektivdir (A). Asan tələbləri əvvəl seçmək vacibləri gecikdirir (B). İşləri gəldiyi sıra ilə görmək fərq qoymur (D). Ən çox təzyiq edənin işini birinci görmək isə təzyiqi əhəmiyyətlə qarışdırır, ən az təsirlidir (C).`,
  },
  {
    id: 'smt-m2-q39', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Tekstil sexində özünüzün buraxdığı bir səhvin partiyaya təsir etdiyini fərq edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Səhvi gizlədib heç kimə bildirmədən davam edin.`,
      B: `Səhvi vaxtında etiraf edib aidiyyəti şəxsləri xəbərdar edin.`,
      C: `Səhvin təsirini qiymətləndirib düzəliş yolunu təklif edin.`,
      D: `Təkrarlanmaması üçün nəyi dəyişəcəyinizi müəyyən edin.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Öz səhvinizi fərq edəndə əvvəlcə onu vaxtında etiraf edib aidiyyəti şəxsləri xəbərdar etmək lazımdır (B), sonra təsiri qiymətləndirib düzəliş təklif etmək (C) və təkrarlanmaması üçün nəyi dəyişəcəyinizi müəyyən etmək (D). Səhvi gizlədib davam etmək isə problemi böyüdür və etimadı pozur, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m2-q40', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Məktəb inzibatında komanda üzvü çətin bir işi uğurla bitirib. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Konkret nəyi yaxşı etdiyini qeyd edib töhfəsini açıq tanıyın.`,
      B: `Komanda qarşısında ümumi "afərin" deyin.`,
      C: `Bunu birbaşa onun vəzifəsi sayıb ayrıca rəy bildirməyin.`,
      D: `Töhfəni qeyd edin, lakin əməyi öz adınıza və ya komandanın ümumi nəticəsinə yazın.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `Uğurlu işi tanımağın ən güclü yolu konkret nəyi yaxşı etdiyini qeyd edib töhfəni açıq tanımaqdır (A, 4). Ümumi "afərin" demək də müsbətdir, lakin konkretlikdən məhrumdur (B, 3). Töhfəni qeyd edib əməyi öz adınıza yazmaq tanınmanı zəiflədir (D, 2). Bunu birbaşa onun vəzifəsi sayıb rəy bildirməmək isə motivasiyanı azaldır, ən az faydalı seçimdir (C, 1).`,
  },
  {
    id: 'smt-m2-q41', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Komanda rəhbərisiniz. Əməkdaşlardan biri ciddi qayda pozur və buna uyğun rəsmi tənbeh sizin təkbaşına verə biləcəyiniz səlahiyyətdən kənardadır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Rəsmi tənbehi öz səlahiyyətinizi aşaraq özünüz tətbiq edin, sonra məlumat verin.`,
      B: `Pozuntunu qeyd etsəniz də, tənbeh məsələsini açmadan saxlayın.`,
      C: `Hadisəni qeydə alıb tənbeh qərarını öz rolunuz daxilində insan resurslarına və ya səlahiyyətli rəhbərə ötürün.`,
      D: `Məsələ ilə bağlı qərarı tamamilə həmkarınıza həvalə edib geri çəkilin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Tənbeh səlahiyyətinizdən kənardırsa, ən təsirli davranış hadisəni qeydə alıb qərarı öz rolunuz daxilində səlahiyyətli tərəfə ötürməkdir (C). Pozuntunu qeyd edib tənbeh məsələsini açmamaq problemi həll etmir (B). Qərarı bütövlükdə həmkara həvalə etmək məsuliyyətdən qaçmaqdır (D). Tənbehi səlahiyyətinizi aşaraq özünüz tətbiq etmək isə həddi pozur, ən zəifdir (A).`,
  },
  {
    id: 'smt-m2-q42', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Bank əməliyyat şöbəsində çətin bir rəy söhbətini aparırsınız. Ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Qarşı tərəfin izahını dinləyin.`,
      B: `Müşahidə etdiyiniz konkret faktı qeyd edin.`,
      C: `Birlikdə həll yolu və növbəti addımı razılaşdırın.`,
      D: `Söhbəti təxirə salıb rəyi yalnız yazılı mesajla bildirin.`,
    },
    correct: ['B', 'A', 'C', 'D'],
    explanation: `Söhbət konkret faktın qeyd edilməsi ilə başlayır (B), sonra qarşı tərəfin izahı dinlənilir (A) və həll birlikdə razılaşdırılır (C). Çətin rəyi söhbətdən qaçıb yalnız yazılı mesajla bildirmək isə anlaşılmazlığı artırır və izah imkanı vermir, ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m2-q43', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `İT dəstək komandasında resurs çatışmazlığı var. Qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `İşlərin hamısını eyni vaxtda, prioritet qoymadan aparın.`,
      B: `Komandadan əlavə iş saatları tələb edib mövcud həcmi saxlayın.`,
      C: `Mövcud planı saxlayıb işləri sıxışdırmağa çalışın.`,
      D: `Məqsədə görə nəyin təxirə salınacağını şəffaf qərarlaşdırın.`,
    },
    correct: { A: 1, B: 3, C: 2, D: 4 },
    explanation: `Resurs çatışmazlığında ən doğru addım məqsədə görə nəyin təxirə salınacağını şəffaf müəyyən etməkdir (D, 4). Əlavə saatlarla həcmi saxlamaq qısamüddətli kömək edir (B, 3). Planı dəyişmədən işləri sıxışdırmaq gərginliyi artırır (C, 2). İşləri prioritet qoymadan eyni vaxtda aparmaq isə heç birinin tamamlanmamasına gətirir, ən zəif seçimdir (A, 1).`,
  },
  {
    id: 'smt-m2-q44', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tibb mərkəzində bir üzv tapşırığı çatdıra bilmir və üzr istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səbəbini soruşmadan sadəcə müddəti uzadın.`,
      B: `Onunla konkret maneəni anlayıb real bir plan qurun.`,
      C: `Tapşırığı dərhal başqasına ötürün.`,
      D: `Rəhbərə müddətin uzadılması üçün müraciət edin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Əvvəlcə konkret maneəni anlayıb real plan qurmaq həm tapşırığı, həm üzvü qoruyur (B). Tapşırığı dərhal başqasına ötürmək bu üzvü kənarda qoyur (C); rəhbərdən müddət istəmək əsl maneəyə toxunmur (D). Səbəbini soruşmadan sadəcə müddəti uzatmaq isə problemi təkrarlana bilən halda saxlayır, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m2-q45', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Çağrı mərkəzində rəhbərinizin verdiyi qərarla əsaslı şəkildə razı deyilsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Qərarı komanda qarşısında açıq tənqid edib öz bildiyiniz kimi davam edin.`,
      B: `Narazılığınızı rəhbərə dəlillərlə, sakit şəkildə bildirin.`,
      C: `Alternativ bir yanaşma təklif edin.`,
      D: `Əvvəlcə qərarın arxasındakı səbəbi və konteksti anlamağa çalışın.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Rəhbərin qərarı ilə razı olmayanda əvvəlcə qərarın arxasındakı səbəbi anlamaq lazımdır (D), sonra narazılığı dəlillərlə sakit bildirmək (B) və alternativ təklif etmək (C). Qərarı komanda qarşısında açıq tənqid edib öz bildiyinizcə davam etmək isə həm etimadı, həm komanda nizamını pozur, ən zəifdir (A).`,
  },
  {
    id: 'smt-m2-q46', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Anbar uçotunda göstərici dəyişib. Qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Bir neçə izahı yoxlayıb müqayisə edin.`,
      B: `İlk ağla gələn izaha görə dərhal tədbir görün.`,
      C: `Fərqin harada yarandığını cədvəldə axtarın.`,
      D: `Dəyişikliyi adi dalğalanma sayıb qeyd etmədən keçin.`,
    },
    correct: { A: 4, B: 2, C: 3, D: 1 },
    explanation: `Dəyişikliyin səbəbini bir neçə izahı müqayisə edərək tapmaq ən güclüsüdür (A, 4). Fərqin harada yarandığını cədvəldə axtarmaq da yaxşı analitik addımdır (C, 3). İlk izaha görə dərhal tədbir görmək yoxlanmamış reaksiyadır (B, 2). Dəyişikliyi adi dalğalanma sayıb keçmək isə real problemi gözardı edə bilər, ən az təsirlidir (D, 1).`,
  },
  {
    id: 'smt-m2-q47', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Mətbəə sexində bacarıqlı bir üzvün performansı zəifləyib. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Növbəti rəsmi qiymətləndirməyə qədər gözləyib sonra qaldırın.`,
      B: `Performans məsələsini komanda yığıncağında ümumi şəkildə qaldırın.`,
      C: `İşin bir hissəsini müvəqqəti başqasına verib izləyin.`,
      D: `Erkən, təkbətək, konkret nümunələrlə mehribanca söhbət edib dəstək təklif edin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Düşən performansa erkən, təkbətək və konkret nümunələrlə yanaşmaq ən effektivdir (D). Rəsmi qiymətləndirməyə qədər gözləmək problemi gecikdirir (A); işin bir hissəsini başqasına vermək səbəbi həll etmədən simptomu örtür (C). Məsələni komanda yığıncağında ümumi qaldırmaq isə şəxsə birbaşa çatmır və onu narahat edə bilər, ən zəif seçimdir (B).`,
  },
  {
    id: 'smt-m2-q48', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `QA komandasında bir neçə alət variantından birini seçməlisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk baxışda bəyəndiyiniz variantı seçib qərarı bağlayın.`,
      B: `Variantları müəyyən etdiyiniz meyarlara görə müqayisə edin.`,
      C: `Hər variant haqqında lazımi məlumatı toplayın.`,
      D: `Seçim üçün əsas meyarları, məsələn qiymət, etibarlılıq və uyğunluğu müəyyən edin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Variant seçimində əvvəlcə əsas meyarları müəyyən etmək lazımdır (D), sonra hər variant haqqında məlumat toplamaq (C) və variantları meyarlara görə müqayisə etmək (B). İlk baxışda bəyəndiyiniz variantı seçib qərarı bağlamaq isə yoxlanmamış seçimdir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m2-q49', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `İnstitut layihəsində rəhbərin göstərişi qeyri-aydındır. Qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Göstərişi öz anladığınız kimi yozub işə başlayın.`,
      B: `İşi rəhbər əlavə izah verənə qədər saxlayın.`,
      C: `Yalnız ən qaranlıq hissəni qısa bir sualla aydınlaşdırın.`,
      D: `Anladığınızı təsdiqləyin və qeyri-aydın məqamları həll yönümlü dəqiqləşdirin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Ən güclü yanaşma anladığınızı təsdiqləyib qeyri-aydın məqamları həll yönümlü dəqiqləşdirməkdir (D, 4). Yalnız ən qaranlıq hissəni qısa sualla aydınlaşdırmaq da faydalıdır (C, 3). İşi rəhbərin əlavə izahına qədər saxlamaq vaxt itirir (B, 2). Göstərişi öz yozumunuza görə başlamaq isə yanlış istiqamət riski yaradır, ən zəifdir (A, 1).`,
  },
  {
    id: 'smt-m2-q50', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Sertifikat ofisində tanışınız qaydadan güzəşt istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Eyni qərarı tanışınız olmayan biri üçün də verərdinizmi deyə şəffaflıq testini tətbiq edin.`,
      B: `Güzəşti sənədsiz, qeyri-rəsmi yerinə yetirin.`,
      C: `Qaydanı pozmadan tanışınıza kömək edə biləcəyiniz başqa yol axtarın.`,
      D: `Güzəşti yerinə yetirin, çünki məsələ kiçikdir.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Ən güclü yanaşma qərarı şəxsi tanışlıqdan asılı etməməkdir (A). Qaydanı pozmadan başqa yolla kömək axtarmaq da məqbuldur (C). Güzəşti kiçik sayıb yerinə yetirmək qaydanı şəxsi münasibətə görə əyir (D). Güzəşti sənədsiz, qeyri-rəsmi etmək isə şəffaflığı tam pozur, ən az təsirlidir (B).`,
  },
  {
    id: 'smt-m2-q51', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Su idarəsində gözlənilməz vəziyyətdə qərar verməlisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk ağla gələn variantı dərhal tətbiq edin.`,
      B: `Lazım olduqda yuxarı səviyyəyə müraciət edin.`,
      C: `Variantları və təsirlərini müqayisə edin.`,
      D: `Qərar üçün kifayət qədər məlumat toplayıb vəziyyəti qiymətləndirin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Gözlənilməz vəziyyətdə əvvəlcə kifayət qədər məlumat toplayıb qiymətləndirmək (D), sonra variantları və təsirlərini müqayisə etmək lazımdır (C). Lazım olanda yuxarı səviyyəyə müraciət etmək də yerindədir, ancaq ilk addım deyil (B). İlk ağla gələn variantı dərhal tətbiq etmək isə yoxlanmamış riskdir, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m2-q52', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `İncəsənət fondunda müxtəlif tərəflər fərqli nəticə istəyir. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hər tərəflə ayrıca danışıb gözləntilərini idarə etməyə çalışın.`,
      B: `Ən nüfuzlu tərəfin istəyini qəbul edib qərarı ona görə verin.`,
      C: `Bütün tərəflərin maraqlarını şəffaf nəzərə alıb ortaq, ədalətli həll qurun.`,
      D: `Qərarı tərəflər razılığa gələnə qədər təxirə salın.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Fərqli maraqlar olan vəziyyətdə bütün tərəfləri şəffaf və ədalətli prosesdə birləşdirmək ən güclüdür (C). Tərəflərlə ayrıca danışıb gözləntiləri idarə etmək qismən kömək edir (A). Qərarı razılığa qədər təxirə salmaq prosesi dayandırır (D). Ən nüfuzlu tərəfin istəyini əsas götürmək isə ədaləti pozur, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'smt-m2-q53', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Tədbir agentliyində eyni anda həddən çox işiniz var və hamısına çatdırmaq mümkün görünmür. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Siyahını dəyişdirmədən bütün işləri eyni anda görməyə çalışın.`,
      B: `Az dəyərli və ya təxirəsalına bilən işləri yenidən danışın və ya təxirə salın.`,
      C: `Bütün işləri yığıb hər birinin təsirini və təcilliyini qiymətləndirin.`,
      D: `Ən yüksək təsirli işlərə fokuslanıb onları irəli çəkin.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `Həddən çox iş olanda əvvəlcə bütün işləri yığıb təsir və təcilliyini qiymətləndirmək lazımdır (C), sonra ən yüksək təsirli işlərə fokuslanmaq (D) və az dəyərli işləri yenidən danışıb və ya təxirə salmaq (B). Siyahını dəyişdirmədən hər şeyi eyni anda görməyə çalışmaq isə qüvvəni dağıdır, ən zəifdir (A).`,
  },
  {
    id: 'smt-m2-q54', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Logistika mərkəzində bir üzv etdiyi səhvi bildirməyə qorxur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səhvi indilik qeyd etməyib işin davam etməsinə imkan verin.`,
      B: `Səhvlərin açıq danışıldığı, öyrənməyə çevrildiyi mühit yaradın.`,
      C: `Standartı qəti şəkildə xatırladın, lakin səhvin səbəbini ayrıca araşdırmadan söhbəti bağlayın.`,
      D: `Səhvləri yalnız özünüz aşkar edib səssizcə düzəldin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Üzv səhvini bildirməyə qorxursa, məqsəd açıq danışıla bilən, öyrənməyə çevrilən mühit yaratmaqdır (B). Səhvi indilik qeyd etməmək problemi həll etmir (A). Səhvləri yalnız özünüz tapıb düzəltmək davamlı deyil (D). Səbəbi araşdırmadan yalnız qəti xatırlatma ilə söhbəti bağlamaq isə qorxunu artırıb bildirişi dayandırır, ən az təsirlidir (C).`,
  },
  {
    id: 'smt-m2-q55', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Maliyyə şöbəsində nəticələri çətin dəyişdirilən bir qərarla üzləşmisiniz və vaxt məhduddur. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Təsiri qiymətləndirib mümkünsə kiçik miqyaslı sınaqla riski azaldın.`,
      B: `Geri dönüşü çətin addımı yoxlamadan dərhal icra edin.`,
      C: `Qərarı daha çox məlumat toplanana qədər təxirə salın.`,
      D: `Qərarı səlahiyyəti olan başqa birinə ötürün.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Geri dönüşü çətin və vaxtın məhdud olduğu qərarda təsiri qiymətləndirib mümkünsə kiçik sınaqla riski azaltmaq ən güclüdür (A). Daha çox məlumat üçün təxirə salmaq vaxt məhdudiyyəti ilə ziddiyyət təşkil edir (C). Qərarı səlahiyyətli başqa birinə ötürmək bəzən yerinə düşür, lakin məsələ sizin çərçivənizdədir (D). Geri dönüşü çətin addımı yoxlamadan dərhal icra etmək isə ən böyük riski yaradır (B).`,
  },
  {
    id: 'smt-m2-q56', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Geyim istehsal xəttində nəticəsi qeyri-müəyyən yeni üsul sınamaq istəyirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yeni üsulu mövcud üsulla müqayisə edib fərqi qiymətləndirin.`,
      B: `Üsulu sınamadan, nəticəsi qeyri-müəyyən olduğu üçün rədd edin.`,
      C: `Üsulu dərhal tam miqyasda istehsala salın.`,
      D: `Kiçik miqyasda sınayıb nəticəyə görə qərar verin.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Nəticəsi qeyri-müəyyən üsulda ən uyğun yanaşma kiçik miqyasda sınayıb nəticəyə görə qərar verməkdir (D). Üsulu mövcud üsulla müqayisə edib qiymətləndirmək də faydalıdır (A). Sınamadan rədd etmək potensial yaxşı həlli itirir (B). Üsulu dərhal tam miqyasda istehsala salmaq isə qeyri-müəyyən riski hər yerə yayır, ən zəif seçimdir (C).`,
  },
  {
    id: 'smt-m2-q57', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kollec inzibatında iki üzv fərqli motivasiya ilə işləyir. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yalnız öz işlədiyiniz üsulu hər ikisinə tətbiq edin.`,
      B: `Hər birinin fərdi motivasiyasını anlayıb yanaşmanı uyğunlaşdırın.`,
      C: `Hər ikisinə eyni mükafat sistemini tətbiq edin.`,
      D: `Motivasiya fərqini əhəmiyyətsiz sayıb yanaşmanı dəyişməyin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `İki nəfər fərqli amillərlə motivasiya olunursa, hər birinin motivasiyasını anlayıb yanaşmanı uyğunlaşdırmaq ən güclüdür (B). Eyni mükafat sistemi fərqi qismən nəzərə almır (C). Yalnız öz üslubunuzu tətbiq etmək başqasına uyğun gəlməyə bilər (A). Motivasiya fərqini əhəmiyyətsiz sayıb yanaşmanı dəyişməmək isə ən az faydalı seçimdir (D).`,
  },
  {
    id: 'smt-m2-q58', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tədqiqat institutunda tərəfdaşa göndərilən hesabatda təkrarlanan xəta gördünüz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Xətanı səssizcə düzəldib heç kimə bildirməyin.`,
      B: `Növbəti hesabata qədər gözləyib sonra bildirin.`,
      C: `Xətanı erkən, şəffaf bildirib düzəliş yolunu təklif edin.`,
      D: `Məsələni dərhal ən yuxarı rəhbərliyə ötürün.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Təkrarlanan xətada ən güclü addım onu erkən, şəffaf bildirib düzəliş yolu təklif etməkdir (C). Növbəti hesabata qədər gözləmək bildirişi gecikdirir (B). Məsələni dərhal ən yuxarı rəhbərliyə ötürmək birbaşa düzəliş addımını atlayır (D). Xətanı səssizcə düzəldib heç kimə bildirməmək isə təkrarlanan problemi gizli saxlayır, ən zəifdir (A).`,
  },
  {
    id: 'smt-m2-q59', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qeydiyyat şöbəsində bir vətəndaş gecikmədən narazıdır və səsini qaldırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Vətəndaşa növbə qaydasını qısaca deyib əlavə suallarına vaxt ayırmayın.`,
      B: `Yerinə yetirilməsi mümkün olmayan vədlər verin.`,
      C: `Dinləyin, narahatlığı qəbul edin, vəziyyəti aydınlaşdırıb konkret addım bildirin.`,
      D: `Özünüzü haqlı çıxarmaq üçün mübahisəyə girin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Narazı vətəndaşla ən təsirli yanaşma sakit dinləyib narahatlığı qəbul etmək və konkret addım bildirməkdir (C). Növbə qaydasını qısaca deyib əlavə suala vaxt ayırmamaq narahatlığı arxa plana atır (A). Çatdıra bilməyəcəyiniz vədlər sonra etimadı pozur (B). Özünüzü haqlı çıxarmaq üçün mübahisəyə girmək isə gərginliyi birbaşa artırır, ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m2-q60', course: 'smt', mock_num: 2, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çoxşaxəli bir proqram müxtəlif mərhələlərdə fərqli güclü tərəflər tələb edir, sizin ən doğru tərəfiniz isə yalnız bir sahədədir. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yalnız ən uyğun olduğunuz sahəyə güvənib proqramı onunla aparın.`,
      B: `Bir neçə sahəyə səthi toxunub heç birinə dərinləşməyin.`,
      C: `Hər mərhələdə hansı yanaşmanın lazım olduğunu görüb ona uyğun davranın.`,
      D: `Çətin hissələri tamamilə başqalarına ötürüb yalnız rahat hissələri saxlayın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Fərqli güclü tərəflər tələb edən proqramda hər mərhələdə hansı yanaşmanın lazım olduğunu görüb ona uyğun davranmaq ən effektivdir (C). Bir neçə sahəyə səthi toxunmaq heç birindən tam fayda vermir (B). Çətin hissələri bütövlükdə başqalarına ötürmək məsuliyyəti və bütövlüyü itirir (D). Yalnız ən güclü sahənizə güvənmək isə proqramın digər tələblərini açıq qoyur, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q1', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tikinti şirkətində yeni komanda üzvü Toğrul bir prosedurda dəfələrlə çətinlik çəkir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Proseduru hər dəfə onun yerinə özünüz icra edib gedişi sürətləndirin.`,
      B: `Çətinləşdirən konkret addımı birlikdə müəyyən edib həmin hissədə hədəfli məşq verin.`,
      C: `Toğrulu daimi olaraq təcrübəli bir həmkarın yanına verib özünüz izləyin.`,
      D: `Proseduru bir dəfə şifahi izah edib qalanını öz təcrübəsinə buraxın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Yeni üzvün çətinliyini aşmaq üçün ən təsirli yol çətinləşdirən konkret addımı tapıb həmin hissədə hədəfli məşq verməkdir (B). Daimi olaraq başqasının yanına vermək asılılıq yaradır (C). Bir dəfə izah edib qalanını təcrübəyə buraxmaq dəstəyi yetərincə vermir (D). Proseduru hər dəfə onun yerinə özünüz icra etmək isə öyrənməyə imkan vermir və sizi darboğaza çevirir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m3-q2', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Restoran mətbəxində iki etibarlı mənbə eyni göstərici barədə bir-birinə zidd məlumat verir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Daha çox bəyəndiyiniz mənbəni seçib digərini yoxlamadan davam edin.`,
      B: `Ziddiyyəti açıq qeyd edib hər iki mənbənin nəyə əsaslandığını yoxlayın.`,
      C: `Fərqin haradan gəldiyini müəyyən edib mənbələri uzlaşdırmağa çalışın.`,
      D: `Uzlaşmazlıq qalsa, üçüncü etibarlı yoxlama ilə həll edin.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Zidd məlumatda əvvəlcə ziddiyyəti qeyd edib hər mənbənin nəyə əsaslandığını yoxlamaq lazımdır (B), sonra fərqin haradan gəldiyini tapıb uzlaşdırmaq (C) və qalan uzlaşmazlığı üçüncü yoxlama ilə həll etmək (D). Daha çox bəyəndiyiniz mənbəni seçib digərini yoxlamamaq isə qərəzli nəticəyə aparır, ən zəifdir (A).`,
  },
  {
    id: 'smt-m3-q3', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Şəhər kitabxanasında həmkarınız başqa bir həmkarından şikayətlənir. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Onun tərəfini tutub digər həmkar barədə mənfi fikir bildirin.`,
      B: `"Bu səni maraqlandırmamalıdır" deyib mövzunu bağlayın.`,
      C: `Dinləyin, hisslərini qəbul edin, lakin tərəf tutmadan onu birbaşa həll yoluna yönəldin.`,
      D: `Diqqətlə dinləyib hisslərini qəbul edin, sonra mövzunu açıq saxlayın.`,
    },
    correct: { A: 2, B: 1, C: 4, D: 3 },
    explanation: `Həmkar başqası barədə şikayətlənəndə ən doğru reaksiya dinləyib hissləri qəbul etmək, lakin tərəf tutmadan onu birbaşa həll yoluna yönəltməkdir (C, 4). Dinləyib hissləri qəbul etmək, ancaq həllə yönəltməmək yarımçıqdır (D, 3). Onun tərəfini tutub digəri barədə mənfi fikir bildirmək münaqişəni dərinləşdirir (A, 2). "Bu səni maraqlandırmamalıdır" deyib mövzunu bağlamaq isə həmkarı tam rədd edir, ən az təsirlidir (B, 1).`,
  },
  {
    id: 'smt-m3-q4', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Avtoservisdə artıq tam yüklü olduğunuz halda sizə daha bir təcili iş həvalə olunur. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Heç nə deməyib bütün işləri eyni anda görməyə çalışın.`,
      B: `Yeni işi qəbul etmədən, hazırkı yükünüzü səbəb göstərib imtina edin.`,
      C: `Mövcud işlərinizi və yeni işi prioritetə görə müzakirə edib nəyin önə keçəcəyini rəhbərlə razılaşdırın.`,
      D: `Yeni işi qəbul edin, lakin hazırkı işlərdən birini xəbər vermədən yarımçıq saxlayın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Artıq tam yüklü olanda ən uyğun yanaşma mövcud və yeni işi prioritetə görə müzakirə edib nəyin önə keçəcəyini rəhbərlə razılaşdırmaqdır (C). Yeni işi yükünüzə görə tamamilə rədd etmək çevik deyil (B). Bir işi xəbərsiz yarımçıq saxlamaq gizli risk yaradır (D). Heç nə deməyib hər şeyi eyni anda görməyə çalışmaq isə qüvvəni dağıdır, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q5', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Ayaqqabı emalatxanasında adətən fəal olan bir komanda üzvü son vaxtlar səssizləşib və işə marağı azalıb. İlk addım kimi ən effektiv davranış hansıdır?`,
    options: {
      A: `Onunla təkbətək, qayğı ilə söhbət edib nəyin dəyişdiyini soruşun.`,
      B: `Heç nə soruşmadan ona daha az iş verib özünə gəlməsinə imkan verin.`,
      C: `Komanda qarşısında onu yenidən fəallaşmağa çağırın.`,
      D: `Performansı açıq düşənə qədər müdaxilə etməyin.`,
    },
    correct: 'A',
    explanation: `Adətən fəal birinin geri çəkilməsində ən güclü ilk addım onunla təkbətək, qayğı ilə söhbət edib nəyin dəyişdiyini soruşmaqdır (A). Səbəbi öyrənmədən iş yükünü azaltmaq səhv fərziyyəyə əsaslanır (B). Komanda qarşısında çağırış onu narahat edə bilər (C). Performans açıq düşənə qədər müdaxilə etməmək isə problemi böyüməyə buraxır (D).`,
  },
  {
    id: 'smt-m3-q6', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Quşçuluq ferması müdiri kimi təcili qərar verməlisiniz, lakin adətən məsləhətləşdiyiniz mütəxəssis bu gün əlçatan deyil. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Mütəxəssis əlçatan olana qədər qərarı tam saxlayın.`,
      B: `Mövcud məlumatla səlahiyyətiniz daxilində qərar verin, fərziyyələri qeyd edin və mütəxəssisi sonra məlumatlandırın.`,
      C: `İlk ağla gələn variantı yoxlamadan dərhal tətbiq edin.`,
      D: `Qərarı bütövlükdə başqa bir həmkara ötürün.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Məsləhətçi əlçatan olmadıqda ən təsirli yanaşma mövcud məlumatla səlahiyyət daxilində qərar verib fərziyyələri qeyd etmək və mütəxəssisi sonra məlumatlandırmaqdır (B). Qərarı tam saxlamaq təcili işdə gecikmə yaradır (A). Qərarı tam başqasına ötürmək məsuliyyətdən qaçmaqdır (D). İlk variantı yoxlamadan dərhal tətbiq etmək isə ən böyük riski yaradır (C).`,
  },
  {
    id: 'smt-m3-q7', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Universitet kafedrasında yeni bir əməkdaş işə başlayır. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Onu ilk gündən təkbaşına buraxın, hər şeyi özü öyrənsin.`,
      B: `Rolunu, gözləntiləri və əsas qaydaları aydın izah edin.`,
      C: `Onu komanda və əsas resurslarla tanış edin.`,
      D: `İlk olaraq dəstəklə icra edə biləcəyi idarəolunan bir tapşırıq verin.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Yeni əməkdaşı işə salmağın ən doğru ardıcıllığı rolu, gözləntiləri və qaydaları aydın izah etməklə başlayır (B), sonra komanda və resurslarla tanışlıq (C) və dəstəklə icra edə biləcəyi idarəolunan ilk tapşırıq (D) gəlir. Onu ilk gündən təkbaşına buraxıb hər şeyi özünə öyrətdirmək isə uğursuzluq riskini artırır, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m3-q8', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Pərakəndə mağaza şəbəkəsində sizə əsassız bir ittiham yönəlib. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Faktlara və sənədlərə əsaslanan sakit izah verin.`,
      B: `Heç nə deməyib məsələni olduğu kimi buraxın.`,
      C: `Yalnız ümumi sözlərlə, konkret fakt göstərmədən izah verin.`,
      D: `Emosional reaksiya verib ittihamı başqalarının üzərinə yönəldin.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Əsassız ittihamda ən uyğun davranış faktlara və sənədlərə əsaslanan sakit izah verməkdir (A). Konkret fakt göstərmədən ümumi izah inandırıcı deyil (C). Heç nə deməyib məsələni buraxmaq ittihamı yerində qoyur (B). Emosional reaksiya verib ittihamı başqalarına yönəltmək isə vəziyyəti daha da kəskinləşdirir, ən zəifdir (D).`,
  },
  {
    id: 'smt-m3-q9', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Elektrik təmiri briqadasında bir tapşırığı bacarıqlı bir üzvə həvalə etdiniz. İcra zamanı nəzarət üslubunu qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Razılaşdırılmış aralıq nöqtələrdə irəliləyişi yoxlayın, qalanını ona buraxın.`,
      B: `Hər addımı yaxından izləyib tez-tez müdaxilə edin.`,
      C: `İş tam bitənə qədər heç yoxlamayın, problem çıxsa müdaxilə edərsiniz.`,
      D: `Yalnız başlanğıcda və sonda yoxlayın, aralıqda toxunmayın.`,
    },
    correct: { A: 4, B: 2, C: 1, D: 3 },
    explanation: `Bacarıqlı üzvə həvalədən sonra ən güclü nəzarət üslubu razılaşdırılmış aralıq nöqtələrdə yoxlayıb qalanını ona buraxmaqdır (A, 4). Başlanğıc və son yoxlama da işləyir, lakin aralıq görünüş azdır (D, 3). Hər addımı yaxından izləmək mikroidarəetmədir və həvalənin faydasını azaldır (B, 2). İş tam bitənə qədər heç yoxlamamaq isə problemi gec aşkar etmə riski yaradır, ən az təsirlidir (C, 1).`,
  },
  {
    id: 'smt-m3-q10', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Turizm agentliyində bir müştəri ona digər müştərilərin hesabına üstünlük verilməsini tələb edir. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Münaqişədən qaçmaq üçün tələbi gizlicə yerinə yetirin.`,
      B: `Tələbi birbaşa, izah vermədən rədd edin.`,
      C: `Niyə hamıya eyni qaydanın tətbiq olunduğunu sakit izah edib mümkün olan ədalətli alternativi təklif edin.`,
      D: `Qərarı qeyri-müəyyən müddətə təxirə salıb müştərini gözlədin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Başqalarının hesabına üstünlük tələbində ən təsirli yanaşma hamıya eyni qaydanın niyə tətbiq olunduğunu sakit izah edib ədalətli alternativ təklif etməkdir (C). Tələbi izah vermədən birbaşa rədd etmək münasibəti gərginləşdirir (B). Qərarı qeyri-müəyyən saxlamaq problemi həll etmir (D). Tələbi gizlicə yerinə yetirmək isə digər müştərilərə qarşı ədalətsizdir, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q11', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Fotostudiyada vacib bir təqdimata hazırlaşırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hazırlıqsız gedib təqdimatı yerində improvizasiya edin.`,
      B: `Əsas mesajı hazırlayıb gözlənilən sualları əvvəlcədən düşünün.`,
      C: `Təqdimatın məqsədini və auditoriyanın nə gözlədiyini dəqiqləşdirin.`,
      D: `Təqdimatı bir dəfə məşq edib zəif yerləri düzəldin.`,
    },
    correct: ['C', 'B', 'D', 'A'],
    explanation: `Vacib təqdimata hazırlıq məqsədi və auditoriyanın gözləntisini dəqiqləşdirməklə başlayır (C), sonra əsas mesajı hazırlayıb sualları əvvəlcədən düşünmək (B) və bir dəfə məşq edib zəif yerləri düzəltmək (D) gəlir. Hazırlıqsız gedib improvizasiya etmək isə nəticəni təsadüfə buraxır, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m3-q12', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Şirniyyat sexində komanda üzvü Aybəniz son bir neçə tapşırığı ardıcıl olaraq gecikdirir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hər dəfə olduğu kimi müddəti bir də uzadıb davam edin.`,
      B: `Təkrarlanan gecikmənin səbəbini birlikdə araşdırıb davam etməsinin qarşısını alacaq razılaşma qurun.`,
      C: `Gecikmələri qeyd etməyib komanda nəticəsinə təsirini gözardı edin.`,
      D: `Tapşırıqları sakitcə başqalarına yönəldib Aybənizi yükdən çıxarın.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Ardıcıl gecikmə bir nümunə olduğu üçün ən doğru yanaşma səbəbini birlikdə araşdırıb təkrarın qarşısını alacaq razılaşma qurmaqdır (B). Hər dəfə müddəti uzatmaq nümunəni davam etdirir (A). Tapşırıqları sakitcə başqalarına yönəltmək əsl problemi həll etmir (D). Gecikmələri qeyd etməyib təsirini gözardı etmək isə problemi tamamilə açıq buraxır, ən zəifdir (C).`,
  },
  {
    id: 'smt-m3-q13', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Mebel mağazasında təcrübəli, sizdən yuxarı mövqedə olan bir həmkarın işində problem görürsünüz və rəy vermək istəyirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Mövqe fərqinə görə heç nə deməyib susun.`,
      B: `Təkbətək, hörmətlə, konkret müşahidəyə əsaslanıb narahatlığınızı bildirin və onun baxışını soruşun.`,
      C: `Problemi başqa həmkarlarla müzakirə edin, lakin ona birbaşa deməyin.`,
      D: `Ona birbaşa deyin, lakin yalnız ümumi, qeyri-konkret şəkildə.`,
    },
    correct: { A: 1, B: 4, C: 2, D: 3 },
    explanation: `Yuxarı mövqedəki həmkara rəy verməyin ən uyğun yolu təkbətək, hörmətlə, konkret müşahidəyə əsaslanıb narahatlığı bildirmək və onun baxışını soruşmaqdır (B, 4). Birbaşa, lakin ümumi şəkildə demək konkretlikdən məhrumdur (D, 3). Problemi ona deyil, başqaları ilə müzakirə etmək arxadan danışmağa çevrilir (C, 2). Mövqe fərqinə görə bütövlükdə susmaq isə problemi həll edilməmiş qoyur, ən az təsirlidir (A, 1).`,
  },
  {
    id: 'smt-m3-q14', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Avtobus parkında bir üzv səhv etdiyini özü sizə bildirir. Bu anda ən effektiv və ən az effektiv reaksiya hansıdır?`,
    options: {
      A: `Səbəbini araşdırmadan sadəcə bir daha diqqətli olmağı tələb edib keçin.`,
      B: `Bildirdiyinə görə dəyər verin, birlikdə düzəlişə və təkrarın qarşısını almağa fokuslanın.`,
      C: `Səhvi qeyd edib keçin, amma gələcəkdə daha diqqətli olmasını quru şəkildə xatırladın.`,
      D: `Səhvi özünüz sakitcə düzəldib mövzunu bir daha açmayın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Üzv səhvini özü bildirəndə ən güclü reaksiya bildirdiyinə dəyər verib birlikdə düzəlişə və təkrarın qarşısını almağa fokuslanmaqdır (B). Səhvi qeyd edib qısa və formal xatırlatma vermək keçərlidir, lakin öyrənməni zəif dəstəkləyir (C). Səhvi sakitcə özünüz düzəldib mövzunu açmamaq öyrənmə imkanını itirir (D). Səbəbini araşdırmadan yalnız diqqətli olmağı tələb etmək isə gələcəkdə səhvlərin bildirilməsini zəiflədir, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q15', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Komandanızın iki üzvündən biri digərini hamının yanında tənqid etdikdən sonra əməkdaşlığı dayanıb. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Lazım olduqda məsələni yuxarı rəhbərə eskalasiya edin.`,
      B: `Neytral şəraitdə hər ikisini bir araya gətirib baş verəni və təsirini açıq müzakirə edin.`,
      C: `Əvvəlcə hər tərəflə ayrıca danışıb baxışlarını və narahatlıqlarını anlayın.`,
      D: `Tənqid edən tərəfin haqlı olub-olmadığını qərarlaşdırıb məsələni bağlayın.`,
    },
    correct: ['C', 'B', 'A', 'D'],
    explanation: `Açıq tənqiddən sonra yaranan gərginlikdə əvvəlcə hər tərəflə ayrıca danışıb baxışlarını anlamaq ən effektivdir (C), sonra neytral şəraitdə baş verəni açıq müzakirə etmək (B), ardınca lazım olduqda eskalasiya (A). Tənqid edənin haqlı olub-olmadığını qərarlaşdırıb məsələni bağlamaq isə əsl münasibət problemini həll etmir, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'smt-m3-q16', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Üzgüçülük hovuzu idarəsində partnyor hesabatda bir xətanı sizə göstərir, lakin xətanın sizdən qaynaqlandığına əmin deyilsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Xətanı yoxlayıb, sizdən qaynaqlanıbsa etiraf edin və düzəliş təklif edin.`,
      B: `Xətanın sizdən olmadığını yoxlamadan bildirib məsələni bağlayın.`,
      C: `Məsuliyyəti yoxlamadan partnyorun öz tərəfinə yıxın.`,
      D: `Xətanı qeyd edib düzəlişi növbəti dövrə saxlayın.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Xətanın mənbəyi qeyri-müəyyəndirsə, ən təsirli davranış onu yoxlayıb sizdən qaynaqlanıbsa etiraf etmək və düzəliş təklif etməkdir (A). Düzəlişi növbəti dövrə saxlamaq problemi gecikdirir (D). Yoxlamadan xətanın sizdən olmadığını bildirmək tələsik nəticədir (B). Məsuliyyəti yoxlamadan partnyorun üzərinə yıxmaq isə həm yanlış, həm münasibəti pozan addımdır, ən zəifdir (C).`,
  },
  {
    id: 'smt-m3-q17', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Teatrın yeni mövsümə hazırlığında bir məsələ sizin təcrübənizdən kənar bir sahəyə aiddir. Ən effektiv yanaşma hansıdır?`,
    options: {
      A: `Təcrübəniz olmasa da, kömək istəmədən özünüz həll etməyə çalışın.`,
      B: `Məsələnin təcrübənizdən kənar olduğunu erkən tanıyıb uyğun mütəxəssisi cəlb edin.`,
      C: `Məsələni tam başqasına ötürüb nəticədən kənar qalın.`,
      D: `Qərar verməyi qeyri-müəyyən müddətə təxirə salın.`,
    },
    correct: 'B',
    explanation: `Məsələ təcrübənizdən kənardırsa, ən doğru yanaşma bunu erkən tanıyıb uyğun mütəxəssisi cəlb etməkdir (B). Kömək istəmədən özünüz həll etməyə çalışmaq səhv riskini artırır (A). Məsələni tamamilə ötürüb nəticədən kənar qalmaq məsuliyyəti buraxır (C). Qərarı qeyri-müəyyən təxirə salmaq isə işi dayandırır (D).`,
  },
  {
    id: 'smt-m3-q18', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yeni iş sistemi tətbiq olunur və bir təcrübəli əməkdaş buna qarşı çıxır; etirazında haqlı ola biləcək bir məqam da var. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Etirazı dinləmədən sistemi olduğu kimi tətbiq edin.`,
      B: `Bir etiraza görə sistemi bütövlükdə geri çəkin.`,
      C: `Narahatlığını dinləyib haqlı məqamı sistemə daxil edin, qalan hissəni izahla davam etdirin.`,
      D: `Etirazını qeyd edin, lakin heç bir dəyişiklik etmədən davam edin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Etirazda haqlı bir məqam varsa, ən uyğun davranış narahatlığı dinləyib həmin məqamı sistemə daxil etmək və qalanını izahla davam etdirməkdir (C). Etirazı qeyd edib heç nə dəyişdirməmək haqlı məqamı itirir (D). Bir etiraza görə sistemi tam geri çəkmək həddən artıq reaksiyadır (B). Etirazı dinləmədən tətbiq etmək isə həm haqlı məqamı, həm etimadı itirir, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m3-q19', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Dərman distribusiya mərkəzində yuxarıdan gələn, populyar olmayan bir qaydanı komandaya çatdırmalısınız. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `"Belə qərar verilib" deyib detallara girməyin.`,
      B: `Qaydanı və arxasındakı səbəbi izah edin, narahatlıqları dinləyib mümkün olanı yuxarıya çatdırın.`,
      C: `Qaydanı izah edin və narahatlıqları dinləyin, lakin yuxarıya heç nə çatdırmayın.`,
      D: `Qayda ilə şəxsən razı olmadığınızı deyib məsuliyyəti yuxarıya atın.`,
    },
    correct: { A: 2, B: 4, C: 3, D: 1 },
    explanation: `Populyar olmayan qaydanı çatdırmağın ən güclü yolu qaydanı və səbəbini izah etmək, narahatlıqları dinləyib mümkün olanı yuxarıya çatdırmaqdır (B, 4). İzah edib dinləmək, lakin yuxarıya heç nə çatdırmamaq qismən güclüdür (C, 3). "Belə qərar verilib" deyib detallara girməmək quru və natamamdır (A, 2). Qayda ilə razı olmadığınızı deyib məsuliyyəti yuxarıya atmaq isə qaydanı və öz mövqeyinizi zəiflədir, ən zəif seçimdir (D, 1).`,
  },
  {
    id: 'smt-m3-q20', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Təcili avadanlıq alışı sizin təsdiq səlahiyyətinizin sərhədindədir: məbləğ həddə yaxındır, lakin nəticələri şöbənizdən kənara təsir edə bilər. Satıcı bu gün cavab istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səlahiyyətinizdə olduğu üçün geniş təsirini ayrıca yoxlamadan təsdiqləyin.`,
      B: `Qərarı tamamilə yuxarıya ötürün, satıcının vaxtı keçsə də.`,
      C: `Qərarın şöbədənkənar təsirini qısaca aydınlaşdırın, aidiyyəti tərəfdən tez təsdiq alıb satıcıya vaxtında cavab verin.`,
      D: `Satıcını gecikdirib qərarı qeyri-müəyyən müddətə saxlayın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Səlahiyyət sərhədində olan, lakin daha geniş təsiri olan qərarda ən təsirli yanaşma şöbədənkənar təsiri qısaca aydınlaşdırıb aidiyyəti tərəfdən tez təsdiq almaq və satıcıya vaxtında cavab verməkdir (C). Qərarı bütövlükdə yuxarıya ötürüb satıcının vaxtını qaçırmaq çevik deyil (B). Qərarı qeyri-müəyyən saxlamaq imkanı itirir (D). Geniş təsirini ayrıca yoxlamadan təsdiqləmək isə şöbədənkənar nəticələri gözardı edir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m3-q21', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Daşınmaz əmlak agentliyində başa çatmış bir layihədən sonra komanda ilə təhlil aparırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Nə baş verdiyini, faktları və nəticələri birlikdə obyektiv nəzərdən keçirin.`,
      B: `Nəyin yaxşı, nəyin zəif getdiyini komanda ilə açıq müəyyən edin.`,
      C: `Növbəti dəfə üçün konkret təkmilləşdirmələri razılaşdırın.`,
      D: `Nəyin səhv getdiyini bir nəfərin üzərinə yıxıb məsələni bağlayın.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Layihə təhlili faktları və nəticələri birlikdə obyektiv nəzərdən keçirməklə başlayır (A), sonra nəyin yaxşı, nəyin zəif getdiyini açıq müəyyən etmək (B) və konkret təkmilləşdirmələri razılaşdırmaq (C) gəlir. Səhvi bir nəfərin üzərinə yıxıb məsələni bağlamaq isə öyrənməni dayandırır və komandanı qorxudur, ən zəifdir (D).`,
  },
  {
    id: 'smt-m3-q22', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Mətbəx avadanlığı zavodunda göstəricilər normal görünür, lakin nəsə düz olmadığına dair güclü bir hissiniz var. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hissi əsassız sayıb heç bir yoxlama aparmayın.`,
      B: `Yalnız hissinizə əsaslanıb dərhal istehsalı dayandırın.`,
      C: `Hansı konkret göstəricinin sizi narahat etdiyini müəyyən edib həmin sahəni hədəfli yoxlayın.`,
      D: `Bütün sistemi başdan-ayağa, fərq qoymadan yenidən yoxlayın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Narahat edən hissi konkret bir göstəriciyə çevirib həmin sahəni hədəfli yoxlamaq ən doğru yanaşmadır (C). Bütün sistemi fərq qoymadan yenidən yoxlamaq vaxt və resurs baxımından səmərəsizdir (D). Yalnız hissə əsaslanıb istehsalı dayandırmaq yoxlanmamış həddən artıq reaksiyadır (B). Hissi tam əsassız sayıb heç yoxlama aparmamaq isə real problemi gözardı edə bilər, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m3-q23', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Konsaltinq şirkətində başqa bir komandanın uğurla istifadə etdiyi bir üsulu öz komandanıza gətirmək istəyirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Üsulun nəyə görə işlədiyini anlayıb öz komandanızın şəraitinə uyğunlaşdıraraq tətbiq edin.`,
      B: `Üsulu olduğu kimi, heç bir uyğunlaşdırma olmadan dərhal köçürün.`,
      C: `Əvvəlcə kiçik bir hissədə sınayıb komandanıza uyğunluğunu yoxlayın.`,
      D: `Üsul başqasında işlədiyi üçün öz komandanıza uyğun olmadığını düşünüb rədd edin.`,
    },
    correct: { A: 4, B: 1, C: 3, D: 2 },
    explanation: `Ən güclü yanaşma üsulun nəyə görə işlədiyini anlayıb öz şəraitinizə uyğunlaşdırmaqdır (A, 4). Kiçik bir hissədə sınayıb uyğunluğu yoxlamaq da güclüdür (C, 3). Başqasında işlədiyi üçün öz komandanıza uyğunsuz sayıb rədd etmək imkanı itirir (D, 2). Üsulu heç uyğunlaşdırmadan olduğu kimi köçürmək isə fərqli şəraitdə uğursuz ola bilər, ən zəif seçimdir (B, 1).`,
  },
  {
    id: 'smt-m3-q24', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Təchizatçı seçimi qərarını verdiyiniz dövrdə namizədlərdən biri sizə şəxsi bir hədiyyə təklif edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hədiyyəni nəzakətlə rədd edin və qərar prosesinə təsir etməməsi üçün təklifi qeyd edib açıqlayın.`,
      B: `Hədiyyəni qəbul edin, lakin qərarda obyektiv qalacağınıza söz verin.`,
      C: `Hədiyyəni qəbul etməyin, lakin bu barədə heç kimə bildirməyin.`,
      D: `Hədiyyəni qəbul edib həmin təchizatçıya üstünlük verin.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Qərar verdiyiniz dövrdə təklif olunan şəxsi hədiyyəni nəzakətlə rədd edib açıqlamaq ən düzgün davranışdır (A). Hədiyyəni rədd etmək, lakin açıqlamamaq qismən kömək edir, ancaq şəffaflıq vermir (C). Hədiyyəni qəbul edib obyektivliyə söz vermək toqquşmanı saxlayır (B). Hədiyyəni qəbul edib həmin təchizatçıya üstünlük vermək isə qərarı birbaşa korlayır, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'smt-m3-q25', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kafe idarəsində planlaşdırmadığınız gözlənilməz bir imkan yaranır. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İmkanın xərc və icra imkanını yoxlayın.`,
      B: `İmkanı həyəcanla, yoxlamadan dərhal qəbul edin.`,
      C: `İmkanın məqsədlərinizə uyğun olub-olmadığını qiymətləndirin.`,
      D: `Qərar verib mövcud planı buna görə tənzimləyin.`,
    },
    correct: ['C', 'A', 'D', 'B'],
    explanation: `Gözlənilməz imkanda əvvəlcə onun məqsədlərinizə uyğunluğunu qiymətləndirmək lazımdır (C), sonra xərc və icra imkanını yoxlamaq (A) və qərar verib planı tənzimləmək (D). İmkanı yoxlamadan, həyəcanla dərhal qəbul etmək isə yoxlanmamış riskdir, ən zəifdir (B).`,
  },
  {
    id: 'smt-m3-q26', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Velosiped mağazasında əvvəllər həvəsli olan bir üzvün motivasiyası açıq şəkildə düşüb. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Motivasiyanı qaldırmaq üçün dərhal əlavə mükafat və ya bonus təklif edin.`,
      B: `Onunla danışıb motivasiyanın niyə düşdüyünü anlayın və səbəbə uyğun addım atın.`,
      C: `Daha çox iş verib məşğul olmasını təmin edin.`,
      D: `Motivasiyanın öz-özünə qayıdacağını düşünüb heç nə etməyin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Motivasiya düşəndə ən uyğun yanaşma onunla danışıb səbəbi anlamaq və ona uyğun addım atmaqdır (B). Səbəbi bilmədən dərhal bonus təklif etmək problemi səhv ünvanlaya bilər (A). Daha çox iş vermək vəziyyəti pisləşdirə bilər (C). Öz-özünə qayıdacağını düşünüb heç nə etməmək isə problemi dərinləşdirir, ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m3-q27', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Saat təmiri emalatxanasında rəhbərin verdiyi göstəriş sizə səhv və riskli görünür. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Göstəriş səhv görünsə də, sual vermədən olduğu kimi icra edin.`,
      B: `Göstərişi gizlicə özünüzcə dəyişib icra edin.`,
      C: `Narahatlığınızı bildirib göstərişin icrasını dayandırın.`,
      D: `Narahatlığınızı konkret səbəblə rəhbərə bildirib birlikdə dəqiqləşdirin, sonra hərəkət edin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Göstəriş riskli görünürsə, ən güclü yanaşma narahatlığı konkret səbəblə rəhbərə bildirib birlikdə dəqiqləşdirmək, sonra hərəkət etməkdir (D, 4). Narahatlığı bildirib icranı dayandırmaq düzgündür, lakin dəqiqləşdirmə hissəsi natamamdır (C, 3). Göstərişi gizlicə özünüzcə dəyişmək koordinasiyanı pozur (B, 2). Səhv görünən göstərişi sual vermədən icra etmək isə riski reallaşdıra bilər, ən zəif seçimdir (A, 1).`,
  },
  {
    id: 'smt-m3-q28', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bağban mərkəzində bir müştəri sizin komandanızın etdiyi səhvə görə narazıdır və haqlıdır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səhvi komandanın üzərinə yıxıb özünüzü kənara çəkin.`,
      B: `Səhvi inkar edib müştərini sakitləşdirməyə çalışın.`,
      C: `Səhvi etiraf edin, üzr istəyin və konkret düzəliş addımını bildirin.`,
      D: `Müştəriyə kompensasiya təklif edib səbəbi izah etmədən keçin.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Komandanızın haqlı səbəb olduğu narazılıqda ən təsirli davranış səhvi etiraf etmək, üzr istəmək və konkret düzəliş addımını bildirməkdir (C). Kompensasiya təklif edib səbəbi izah etməmək problemin kökünə toxunmur (D). Səhvi komandanın üzərinə yıxmaq məsuliyyətdən qaçmaqdır (A). Səhvi inkar etmək isə müştərinin haqlı narazılığını daha da artırır, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'smt-m3-q29', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Tərəvəz bazarının idarəsində növbənizi başqa bir məsula təhvil verirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Heç nə izah etmədən növbəni buraxıb gedin.`,
      B: `Cari vəziyyəti və yarımçıq qalan işləri qısaca xülasə edin.`,
      C: `Onun başa düşdüyünü təsdiqləyib suallarını cavablandırın.`,
      D: `Risklər və yaxın son tarixlər barədə xəbərdar edin.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `Növbə təhvilində əvvəlcə cari vəziyyəti və yarımçıq işləri qısaca xülasə etmək lazımdır (B), sonra risklər və yaxın son tarixlər barədə xəbərdar etmək (D) və onun başa düşdüyünü təsdiqləyib suallarını cavablandırmaq (C). Heç nə izah etmədən növbəni buraxıb getmək isə növbəti məsulu hazırlıqsız qoyur, ən zəifdir (A).`,
  },
  {
    id: 'smt-m3-q30', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sığorta zərər şöbəsində nəticələri yaxşı olan, lakin davranışı ilə komandanı incidən bir üzvlə işləyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Nəticələri yaxşı olduğu üçün davranışı gözardı edin.`,
      B: `Davranışın komandaya konkret təsirini ona aydın göstərin.`,
      C: `Onunla təkbətək, konkret nümunələrlə davranış barədə danışın.`,
      D: `Gözlənilən davranış dəyişikliyini birlikdə razılaşdırın.`,
    },
    correct: ['C', 'B', 'D', 'A'],
    explanation: `Nəticələri yaxşı, davranışı problemli üzvlə əvvəlcə təkbətək, konkret nümunələrlə danışmaq lazımdır (C), sonra davranışın komandaya təsirini aydın göstərmək (B) və gözlənilən dəyişikliyi birlikdə razılaşdırmaq (D). Nəticələri yaxşı deyə davranışı gözardı etmək isə komandaya zərəri davam etdirir, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m3-q31', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Gəmi təmiri dokunda bir işçinin təhlükəsiz olmayan bir qısayolu məhz indi etdiyini görürsünüz. Ən effektiv və ən az effektiv ilk addımı seçin.`,
    options: {
      A: `Heç nə deməyib işin tamamlanmasını izləyin.`,
      B: `Təhlükəsiz olmayan addımı dərhal, sakitcə dayandırıb düzgün qaydanı göstərin.`,
      C: `İşçiyə sonra deyəcəyinizi qeyd edib indi müdaxilə etməyin.`,
      D: `Bütün komandaya ümumi təhlükəsizlik xəbərdarlığı göndərin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Təhlükəsiz olmayan hərəkət məhz indi baş verirsə, ən doğru ilk addım onu sakitcə dayandırıb düzgün qaydanı göstərməkdir (B). Sonra deyəcəyinizi qeyd edib indi müdaxilə etməmək aktiv riski açıq saxlayır (C). Bütün komandaya ümumi xəbərdarlıq bu konkret hərəkəti dayandırmır (D). Heç nə deməyib işin tamamlanmasını izləmək isə birbaşa təhlükəyə imkan verir, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q32', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Şüşə sexində müştərilərdən təkrarlanan oxşar şikayətlər gəlir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Tapılan əsl səbəbi aradan qaldırıb nəticəni izləyin.`,
      B: `Hər şikayəti ayrıca həll edib ümumi səbəbi axtarmayın.`,
      C: `Şikayətlərdəki ortaq nümunəni müəyyən edin.`,
      D: `Konkret şikayət hallarını toplayıb təfərrüatları qeyd edin.`,
    },
    correct: ['D', 'C', 'A', 'B'],
    explanation: `Təkrarlanan şikayətlərdə əvvəlcə konkret halları toplayıb təfərrüatları qeyd etmək lazımdır (D), sonra ortaq nümunəni müəyyən etmək (C) və tapılan əsl səbəbi aradan qaldırıb nəticəni izləmək (A). Hər şikayəti ayrıca həll edib ümumi səbəbi axtarmamaq isə problemin təkrarlanmasına yol verir, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'smt-m3-q33', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Reklam bürosunda müdafiəyə meylli bir həmkara rəy verməlisiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Müdafiə reaksiyasından qaçmaq üçün rəyi yumşaldıb əsas məqamı demədən keçin.`,
      B: `Konkret müşahidə ilə başlayın, təsirini izah edin və onu həll axtarışına cəlb edin.`,
      C: `Bir neçə problemi eyni anda sadalayıb tənqidlə başlayın.`,
      D: `Konkret bir məqamı deyin, lakin onun baxışını soruşmadan keçin.`,
    },
    correct: { A: 2, B: 4, C: 1, D: 3 },
    explanation: `Müdafiəyə meylli həmkara ən uyğun yanaşma konkret müşahidə ilə başlamaq, təsirini izah etmək və onu həll axtarışına cəlb etməkdir (B, 4). Konkret bir məqamı demək, lakin baxışını soruşmamaq qismən işləyir (D, 3). Əsas məqamı deməyib rəyi həddən artıq yumşaltmaq fayda vermir (A, 2). Bir neçə problemi sadalayıb tənqidlə başlamaq isə dərhal müdafiə reaksiyası yaradır, ən zəifdir (C, 1).`,
  },
  {
    id: 'smt-m3-q34', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Çağrı mərkəzində iki komanda üzvünün xəbərsiz şəkildə eyni işi ayrıca gördüyünü fərq edirsiniz. İlk addım kimi ən effektiv davranış hansıdır?`,
    options: {
      A: `Hər ikisinə işi dayandırmağı deyib özünüz yenidən bölüşdürün.`,
      B: `Hər ikisi ilə danışıb işi əlaqələndirin və kimin nəyə cavabdeh olduğunu aydınlaşdırın.`,
      C: `Daha sürətli işləyənin nəticəsini saxlayıb digərininkini ləğv edin.`,
      D: `Heç nə deməyib işlərin necə birləşəcəyinə baxın.`,
    },
    correct: 'B',
    explanation: `Təkrarlanan işdə ən güclü ilk addım hər ikisi ilə danışıb işi əlaqələndirmək və cavabdehliyi aydınlaşdırmaqdır (B). İşi dayandırıb özünüz yenidən bölüşdürmək onları prosesdən kənarlaşdırır (A). Birinin nəticəsini ləğv etmək əməyi və motivasiyanı itirir (C). Heç nə deməyib gözləmək isə təkrarlanan israfı davam etdirir (D).`,
  },
  {
    id: 'smt-m3-q35', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Mineral su zavodunda bir ölçü qəfildən həyəcan doğuran səviyyəyə çatır, lakin bu, ölçü xətası da ola bilər. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Ölçüyə inanmayıb onu kənara ataraq davam edin.`,
      B: `Ölçünün doğruluğunu yoxlamadan dərhal geniş tədbirlər görün.`,
      C: `Ölçünü tez bir yolla yenidən yoxlayıb həqiqi olub-olmadığını təsdiqləyin, sonra hərəkət edin.`,
      D: `Növbəti ölçüyə qədər heç nə etməyin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Həyəcan doğuran, lakin xəta da ola bilən ölçüdə ən təsirli yanaşma onu tez yenidən yoxlayıb həqiqi olduğunu təsdiqləmək, sonra hərəkət etməkdir (C). Növbəti ölçüyə qədər heç nə etməmək passivdir, lakin ən azı problemi tam inkar etmir (D). Ölçünü yoxlamadan dərhal geniş tədbirlər görmək bahalı və səmərəsizdir (B). Su keyfiyyəti kontekstində isə ölçünü xəta sayıb kənara ataraq davam etmək real çirklənmə və ya keyfiyyət probleminin keçməsinə imkan verə bilər, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m3-q36', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Redaksiyada iki həmkar bir iş qərarı üzərində fikir ayrılığındadır və hər ikisinin mövqeyində məntiq var. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hər iki mövqeyin əsaslarını və faktlarını açıq müqayisə edin.`,
      B: `Faktlara əsaslanan ümumi qərara gəlib hər ikisinin dəstəyini alın.`,
      C: `Mövqelərə baxmadan birinin tərəfini tutub qərarı verin.`,
      D: `Ortaq məqsədi xatırladıb hansı variantın ona daha yaxşı xidmət etdiyini birlikdə qiymətləndirin.`,
    },
    correct: ['A', 'D', 'B', 'C'],
    explanation: `Hər iki tərəfin məntiqli olduğu iş fikir ayrılığında əvvəlcə mövqelərin əsaslarını və faktlarını açıq müqayisə etmək lazımdır (A), sonra ortaq məqsədi xatırladıb hansı variantın ona daha yaxşı xidmət etdiyini qiymətləndirmək (D) və faktlara əsaslanan ümumi qərara gəlib dəstək almaq (B). Mövqelərə baxmadan birinin tərəfini tutmaq isə düzgün qərarı və etimadı itirir, ən zəif seçimdir (C).`,
  },
  {
    id: 'smt-m3-q37', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Vergi ofisində komandaya həm faydası, həm də real çətinlikləri olan bir dəyişikliyi təqdim edirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Yalnız faydaları deyib çətinlikləri gizlədin.`,
      B: `Yalnız çətinlikləri deyib "qərar belədir" mövqeyində qalın.`,
      C: `Həm faydanı, həm çətinlikləri açıq deyin, lakin necə dəstək verəcəyinizi izah etməyin.`,
      D: `Faydanı və çətinlikləri dürüst izah edin və çətinliklərdə necə dəstək olacağınızı bildirin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Çətinlikləri də olan dəyişikliyi ən doğru təqdim etmək yolu faydanı və çətinlikləri dürüst izah edib çətinliklərdə necə dəstək olacağınızı bildirməkdir (D, 4). Hər ikisini açıq demək, lakin dəstək planı verməmək komandanı qeyri-müəyyənlikdə saxlayır (C, 3). Yalnız çətinlikləri deyib "qərar belədir" mövqeyi ruhdan salır (B, 2). Yalnız faydaları deyib çətinlikləri gizlətmək isə sonra etibarı zədələyir, ən az faydalı seçimdir (A, 1).`,
  },
  {
    id: 'smt-m3-q38', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Rübün sonunda qarşınızda var: sabah təqdim olunmalı rəhbər hesabatı, bir neçə xırda inzibati iş, xahişini ucadan təkrarlayan həmkar və gecikmiş sənədləşmə. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `İşləri nəticəyə təsir və son tarix üzrə çəkib ən kritik olanı birinci görün.`,
      B: `Əvvəlcə xırda işləri bitirib siyahını qısaldın.`,
      C: `Ucadan və təkrar tələb edən həmkarın işini birinci görün.`,
      D: `İşləri gəldiyi sıra ilə, fərq qoymadan görün.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Çoxlu iş eyni anda gələndə hər birinin nəticəyə təsirini və son tarixini çəkib ən kritik olanı birinci görmək ən effektivdir (A). Xırda işləri əvvəl bitirmək kritik hesabatı gecikdirir (B). İşləri gəldiyi sıra ilə görmək fərq qoymur (D). Ən ucadan tələb edənin işini birinci görmək isə təzyiqi əhəmiyyətlə qarışdırır, ən zəifdir (C).`,
  },
  {
    id: 'smt-m3-q39', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `İstixanada böyük və mürəkkəb bir tapşırığı idarə edilə bilən hala salırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Son məqsədi və nəyin tələb olunduğunu dəqiqləşdirin.`,
      B: `Addımları asılılıq və prioritetə görə sıralayın.`,
      C: `Tapşırığı daha kiçik, idarəolunan addımlara bölün.`,
      D: `Tapşırığı bölmədən, harasından gəldi başlayın.`,
    },
    correct: ['A', 'C', 'B', 'D'],
    explanation: `Böyük tapşırığı idarə edilə bilən hala salmaq son məqsədi dəqiqləşdirməklə başlayır (A), sonra tapşırığı kiçik, idarəolunan addımlara bölmək (C) və addımları asılılıq və prioritetə görə sıralamaq (B). Tapşırığı bölmədən harasından gəldi başlamaq isə qarışıqlıq və yenidən işləmə yaradır, ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m3-q40', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Universitet şöbəsində iş yükünüz artıb və bəzi işləri həvalə etmək istəyirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Başqasının da görə biləcəyi, inkişaf imkanı verən işləri həvalə edin, kritik qərarları özünüzdə saxlayın.`,
      B: `Yalnız ən cansıxıcı işləri həvalə edib maraqlıları özünüzdə saxlayın.`,
      C: `Yalnız ən kritik, yüksək riskli işləri həvalə edib qalanını özünüz görün.`,
      D: `Heç nə həvalə etməyib hamısını özünüz görün.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `Yük artanda ən uyğun yanaşma başqasının da görə biləcəyi, inkişaf imkanı verən işləri həvalə edib kritik qərarları özünüzdə saxlamaqdır (A, 4). Yalnız cansıxıcı işləri vermək qismən kömək edir, ancaq ədalətli görünməyə bilər (B, 3). Heç nə həvalə etməyib hamısını özünüz görmək yükü azaltmır (D, 2). Ən kritik, yüksək riskli işləri həvalə edib xırdanı özünüzdə saxlamaq isə tərsinədir və risk yaradır, ən zəif seçimdir (C, 1).`,
  },
  {
    id: 'smt-m3-q41', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Müştəri sizdən söz verə biləcəyiniz səlahiyyətdən kənar bir çatdırılma tarixi və endirim tələb edir və dərhal razılıq istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səlahiyyətinizdən kənar olsa da, tarixi və endirimi yerindəcə vəd edin.`,
      B: `Tələbi qarşılaya bilməyəcəyinizi deyib müştəri ilə əlaqəni qısa kəsin.`,
      C: `Müştəriyə qısa müddətdə dəqiq cavab verəcəyinizi bildirin, şərtləri səlahiyyətli şəxslə razılaşdırın və təsdiqlənmiş cavabla qayıdın.`,
      D: `Qərar verməmək üçün müştərini tamamilə başqasının üzərinə ötürün.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Səlahiyyətdən kənar tələbdə ən güclü davranış müştəriyə qısa müddətdə dəqiq cavab verəcəyinizi bildirib şərtləri səlahiyyətli şəxslə razılaşdırmaq və təsdiqlənmiş cavabla qayıtmaqdır (C). Müştərini bütövlükdə başqasına ötürmək məsuliyyətdən qaçmaqdır (D). Əlaqəni qısa kəsmək zəif xidmətdir (B). Səlahiyyətinizdən kənar tarixi və endirimi yerindəcə vəd etmək isə yerinə yetirilə bilməyən öhdəlik yaradır, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m3-q42', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kassa şöbəsində bir müştəri əməkdaşınızın ona kobud davrandığını bildirir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Müştərinin nə baş verdiyini öz dilindən dinləyin.`,
      B: `Əməkdaşın da öz izahını dinləyin.`,
      C: `Varsa qeydləri və ya digər şahidləri yoxlayın.`,
      D: `Daha çox səs çıxaran tərəfin sözünə əsasən qərar verin.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Şikayətdə əvvəlcə müştərini öz dilindən dinləmək lazımdır (A), sonra əməkdaşın izahını dinləmək (B) və varsa qeyd və şahidləri yoxlamaq (C). Daha çox səs çıxaran tərəfin sözünə əsasən qərar vermək isə ədalətsiz və yoxlanmamış nəticədir, ən zəifdir (D).`,
  },
  {
    id: 'smt-m3-q43', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Texniki briqadada bir üzv hazırkı səviyyəsindən bir az yuxarı, çətin bir tapşırığı könüllü götürmək istəyir. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `İmkan verin, lakin aydın hədəflər, yoxlama nöqtələri və dəstəklə müşayiət edin.`,
      B: `İmkan verin, lakin heç bir dəstək və ya izləmə olmadan tək buraxın.`,
      C: `Səviyyəsindən yuxarı olduğu üçün tapşırığı ona ümumiyyətlə verməyin.`,
      D: `İmkan verin, lakin əsas hissələri özünüz görüb ona kiçik hissə buraxın.`,
    },
    correct: { A: 4, B: 2, C: 1, D: 3 },
    explanation: `İnkişaf imkanı verən çətin tapşırıqda ən təsirli yanaşma imkan vermək, lakin aydın hədəflər, yoxlama nöqtələri və dəstəklə müşayiət etməkdir (A, 4). Əsas hissələri özünüz görüb ona kiçik hissə buraxmaq da kömək edir, ancaq inkişafı məhdudlaşdırır (D, 3). Heç bir dəstək olmadan tək buraxmaq uğursuzluq riskini artırır (B, 2). Səviyyəsindən yuxarı olduğu üçün tapşırığı ümumiyyətlə verməmək isə inkişaf imkanını tam bağlayır, ən az təsirlidir (C, 1).`,
  },
  {
    id: 'smt-m3-q44', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Klinikada bir üzv həddən çox işə "yox" deyə bilmədiyi üçün yüklənib və işin keyfiyyəti düşür. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Daha çox səy göstərməsini deyib yükü olduğu kimi saxlayın.`,
      B: `Onunla birlikdə yükü nəzərdən keçirib prioritetləşdirin və lazımsız öhdəlikləri azaldın.`,
      C: `Bir neçə işini xəbər vermədən başqalarına paylayın.`,
      D: `Ona daha yaxşı vaxt idarəçiliyi öyrənməsini tövsiyə edin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Yüklənmiş üzvlə ən doğru yanaşma yükü birlikdə nəzərdən keçirib prioritetləşdirmək və lazımsız öhdəlikləri azaltmaqdır (B). Vaxt idarəçiliyi tövsiyə etmək kömək edir, lakin əsl yük problemini həll etmir (D). İşləri xəbərsiz başqalarına paylamaq onu prosesdən kənarlaşdırır (C). Daha çox səy istəyib yükü olduğu kimi saxlamaq isə keyfiyyət düşüşünü davam etdirir, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q45', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dəstək xəttində bir neçə komanda eyni məhdud resursa ehtiyac duyur. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hər ehtiyacın təsirini və təcilliyini aydınlaşdırın.`,
      B: `Resursu ilk istəyən komandaya verib məsələni bağlayın.`,
      C: `Şəffaf bölüşdürmə meyarları müəyyən edin.`,
      D: `Resursu meyarlara görə bölüb qərarı komandalara izah edin.`,
    },
    correct: ['A', 'C', 'D', 'B'],
    explanation: `Məhdud resursun bölüşdürülməsi hər ehtiyacın təsirini və təcilliyini aydınlaşdırmaqla başlayır (A), sonra şəffaf meyarlar müəyyən etmək (C) və resursu meyarlara görə bölüb qərarı izah etmək (D). Resursu sadəcə ilk istəyənə verib məsələni bağlamaq isə ən vacib ehtiyacı gözardı edə bilər, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'smt-m3-q46', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Terminal uçotunda nəticələr gözləniləndən qat-qat yaxşı görünür və bu, şübhə doğurur. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Nəticəni təqdim etməzdən əvvəl doğruluğunu yoxlayıb mənbəyini təsdiqləyin.`,
      B: `Nəticəni yaxşı olduğu üçün sorğusuz qəbul edib irəli ötürün.`,
      C: `Nəticəni qeyd edin, lakin yoxlamanı sonraya saxlayıb hələlik istifadə edin.`,
      D: `Nəticəni dərhal uğur kimi rəhbərliyə təqdim edin.`,
    },
    correct: { A: 4, B: 2, C: 3, D: 1 },
    explanation: `Həddən artıq yaxşı görünən nəticədə ən uyğun yanaşma onu təqdim etməzdən əvvəl yoxlayıb mənbəyini təsdiqləməkdir (A, 4). Nəticəni qeyd edib yoxlamanı sonraya saxlamaq qismən ehtiyatlıdır (C, 3). Yaxşı olduğu üçün sorğusuz qəbul edib ötürmək yoxlamasız etibardır (B, 2). Nəticəni dərhal uğur kimi rəhbərliyə təqdim etmək isə yanlış çıxsa etibarı zədələyir, ən zəifdir (D, 1).`,
  },
  {
    id: 'smt-m3-q47', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çap evində adətən güclü olan bir üzv ciddi, birdəfəlik bir səhv edib. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səhvi onun ümumi performansının göstəricisi sayıb rəsmi tənbeh tətbiq edin.`,
      B: `Səhvin necə baş verdiyini birlikdə araşdırıb təkrarın qarşısını alacaq dərsi çıxarın.`,
      C: `Güclü performansçı olduğu üçün səhvə heç bir reaksiya verməyin.`,
      D: `Səhvi qeyd edib gələcəkdə daha diqqətli olmasını quru şəkildə xatırladın.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Güclü bir üzvün birdəfəlik ciddi səhvində ən təsirli davranış səhvin necə baş verdiyini birlikdə araşdırıb dərs çıxarmaqdır (B). Səhvi qeyd edib qısa və formal xatırlatma vermək keçərlidir, lakin öyrənməni zəif dəstəkləyir (D). Səhvi onun ümumi performansının göstəricisi sayıb rəsmi tənbeh tətbiq etmək həddən artıq reaksiyadır (A). Güclü performansçı olduğu üçün ciddi səhvə heç bir reaksiya verməmək isə həm məsuliyyəti, həm öyrənməni itirir, ən az təsirlidir (C).`,
  },
  {
    id: 'smt-m3-q48', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dizayn bürosunda davam etdirdiyiniz bir layihə gözlənilən nəticəni vermir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Artıq sərf etdiyiniz vaxta görə layihəni nəyin bahasına olursa-olsun davam etdirin.`,
      B: `Faktlara əsasən davam, dəyişiklik və ya dayandırma qərarını verin.`,
      C: `Qalan xərc və gözlənilən faydanı tutuşdurun.`,
      D: `Cari nəticələri məqsədlə obyektiv müqayisə edin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Nəticə verməyən layihədə əvvəlcə cari nəticələri məqsədlə obyektiv müqayisə etmək lazımdır (D), sonra qalan xərc və gözlənilən faydanı tutuşdurmaq (C) və faktlara əsasən davam, dəyişiklik və ya dayandırma qərarını vermək (B). Artıq sərf etdiyiniz vaxta görə layihəni nəyin bahasına olursa-olsun davam etdirmək isə itkini böyüdə bilər, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q49', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Layihə ofisində iki rəhbərdən bir-birinə zidd göstərişlər alırsınız. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Birinin göstərişini seçib digərini nəzərə almadan icra edin.`,
      B: `İkisini də qismən edib hər ikisini razı salmağa çalışın.`,
      C: `Bir rəhbərə ziddiyyəti deyib onun göstərişinə əməl edin.`,
      D: `Ziddiyyəti hər iki rəhbərə nəzakətlə bildirib aralarında uzlaşma istəyin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Zidd göstərişlərdə ən doğru yanaşma ziddiyyəti hər iki rəhbərə nəzakətlə bildirib aralarında uzlaşma istəməkdir (D, 4). Bir rəhbərə ziddiyyəti deyib onun göstərişinə əməl etmək qismən kömək edir (C, 3). İkisini də qismən edib hər ikisini razı salmağa çalışmaq qüvvəni dağıdır (B, 2). Birinin göstərişini seçib digərini nəzərə almadan icra etmək isə ziddiyyəti gizli saxlayır və sonra problem yaradır, ən az faydalı seçimdir (A, 1).`,
  },
  {
    id: 'smt-m3-q50', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Akkreditasiya qurumunda bir həmkarınızın qaydanı kiçik şəkildə, lakin açıq pozaraq işi sürətləndirdiyini görürsünüz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Onunla danışıb qaydanın niyə vacib olduğunu izah edin və düzgün yolu birlikdə tapın.`,
      B: `Heç nə deməyin, çünki nəticə yaxşıdır.`,
      C: `Məsələni dərhal yuxarıya rəsmi şikayət kimi ötürün.`,
      D: `Eyni qısayolu özünüz də tətbiq etməyə başlayın.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Həmkarın kiçik, lakin açıq qayda pozuntusunda ən uyğun davranış onunla danışıb qaydanın niyə vacib olduğunu izah etmək və düzgün yolu birlikdə tapmaqdır (A). Məsələni dərhal rəsmi şikayət kimi ötürmək kiçik məsələ üçün həddən artıqdır (C). Nəticə yaxşıdır deyə heç nə deməmək pozuntunu davam etdirir (B). Eyni qısayolu özünüz də tətbiq etməyə başlamaq isə pozuntunu normallaşdırır, ən zəifdir (D).`,
  },
  {
    id: 'smt-m3-q51', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dispetçer mərkəzində bir neçə komandaya təsir edən bir qərar verməlisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Onların məlumat və narahatlıqlarını toplayın.`,
      B: `Qərarı verib əsaslandırması ilə birlikdə çatdırın.`,
      C: `Qərardan kimin təsirləndiyini müəyyən edin.`,
      D: `Qərarı təkbaşına verib heç bir izah olmadan elan edin.`,
    },
    correct: ['C', 'A', 'B', 'D'],
    explanation: `Bir neçə komandaya təsir edən qərarda əvvəlcə kimin təsirləndiyini müəyyən etmək lazımdır (C), sonra onların məlumat və narahatlıqlarını toplamaq (A) və qərarı verib əsaslandırması ilə çatdırmaq (B). Qərarı təkbaşına verib heç bir izah olmadan elan etmək isə dəstəyi və anlayışı itirir, ən az təsirlidir (D).`,
  },
  {
    id: 'smt-m3-q52', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Festival təşkilatında komandanızın iki üzvü eyni inkişaf imkanını, bir təlim yerini istəyir. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `İmkanı sizinlə daha rahat işləyən, münasibətdə daha yaxın üzvə verin.`,
      B: `Qərardan qaçmaq üçün imkanı qeyri-müəyyən müddətə təxirə salın.`,
      C: `Şəffaf, ədalətli meyarlar əsasında qərar verin və hər ikisinə əsaslandırmanı izah edin.`,
      D: `İmkanı bölüb hər ikisinə yarımçıq verin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Bir inkişaf imkanını iki nəfər istəyəndə ən güclü yanaşma şəffaf, ədalətli meyarlar əsasında qərar verib hər ikisinə əsaslandırmanı izah etməkdir (C). Qərarı təxirə salmaq imkanı və hər ikisinin vaxtını itirir (B). İmkanı bölüb yarımçıq vermək heç birinə tam fayda vermir (D). İmkanı sadəcə özünüzə daha yaxın, daha rahat işlədiyiniz üzvə vermək isə ədaləti pozur, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q53', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Rəqəmsallaşdırma layihəsində müştəri komandanızın işi barədə mənfi rəy bildirir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Rəyi əsassız sayıb müdafiəyə keçin.`,
      B: `Əsaslı məqamları komanda ilə müzakirə edib düzəliş edin.`,
      C: `Rəyi diqqətlə dinləyib konkret narazılıqları anlayın.`,
      D: `Hansı məqamların əsaslı olduğunu yoxlayın.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `Müştərinin mənfi rəyində əvvəlcə diqqətlə dinləyib konkret narazılıqları anlamaq lazımdır (C), sonra hansı məqamların əsaslı olduğunu yoxlamaq (D) və əsaslı məqamları komanda ilə müzakirə edib düzəliş etmək (B). Rəyi əsassız sayıb müdafiəyə keçmək isə həm faydalı məlumatı, həm münasibəti itirir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'smt-m3-q54', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Anbarda bir səhv bütün yoxlamalardan keçib problem yaradıb. Komanda ilə davranışda ən effektiv və ən az effektiv yanaşma hansıdır?`,
    options: {
      A: `Səhvə kimin yol verdiyini tapıb komanda qarşısında məsul tutun.`,
      B: `Səhvin sistemli səbəbini birlikdə araşdırıb prosesi gücləndirin.`,
      C: `Səhvi qeyd edib hamıya daha diqqətli olmağı tapşırın.`,
      D: `Səhvi sakitcə düzəldib komanda ilə müzakirə etməyin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Yoxlamalardan keçən səhvdə ən təsirli yanaşma sistemli səbəbi birlikdə araşdırıb prosesi gücləndirməkdir (B). Səhvi qeyd edib hamıya "diqqətli olun" demək konkret deyil (C). Səhvi sakitcə düzəldib müzakirə etməmək öyrənmə imkanını itirir (D). Səhvə yol vereni tapıb komanda qarşısında məsul tutmaq isə qorxu yaradır və gələcəkdə səhvlərin gizlədilməsinə gətirir, ən zəifdir (A).`,
  },
  {
    id: 'smt-m3-q55', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Audit şöbəsində qərarın nəticələrini sonradan asanlıqla düzəltmək mümkündür, lakin siz qərarı uzun müddət təhlil edirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Qərar geri dönümlü olduğu üçün tez bir əsaslı seçim edib lazım olsa sonra düzəldin.`,
      B: `Hər ehtimalı tükənənə qədər təhlil edib qərarı uzun müddət yubadın.`,
      C: `Qərarı başqasının verməsinə buraxıb özünüz çəkilin.`,
      D: `Geri dönümlü olsa da, qərarı çətin dəyişdirilə bilən kimi yanaşıb hədsiz ehtiyatla davranın.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Asanlıqla düzəldilə bilən qərarda ən doğru yanaşma tez bir əsaslı seçim edib lazım olsa sonra düzəltməkdir (A). Geri dönümlü qərara çətin dəyişdirilə bilən kimi yanaşmaq lazımsız ehtiyatdır (D). Qərarı başqasının verməsinə buraxıb çəkilmək məsuliyyətdən qaçmaqdır (C). Hər ehtimalı tükənənə qədər təhlil edib qərarı uzun müddət yubatmaq isə geri dönümlü işdə vaxt itkisidir, ən az təsirlidir (B).`,
  },
  {
    id: 'smt-m3-q56', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qablaşdırma xəttində bir komanda üzvü yaradıcı, lakin riskli bir ideya təklif edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `İdeyanı yoxlamadan dərhal bütün xəttə tam tətbiq edin.`,
      B: `İdeyanı riskli olduğu üçün dərhal rədd edin.`,
      C: `İdeyanı dəyərləndirib kiçik, nəzarətli sınaqla riski idarə edərək yoxlayın.`,
      D: `İdeyanı bəyənib sınamadan rəhbərə təqdim edin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Yaradıcı, lakin riskli ideyada ən uyğun davranış onu dəyərləndirib kiçik, nəzarətli sınaqla riski idarə edərək yoxlamaqdır (C). İdeyanı sınamadan rəhbərə təqdim etmək yoxlama mərhələsini atlayır (D). İdeyanı riskli olduğu üçün dərhal rədd etmək təşəbbüsü söndürür (B). İdeyanı yoxlamadan dərhal bütün xəttə tam tətbiq etmək isə riski hər yerə yayır, ən zəif seçimdir (A).`,
  },
  {
    id: 'smt-m3-q57', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Akademiyada komanda böyük səy göstərib, lakin töhfələr qeyri-bərabər olub. Mükafatlandırmada ən effektiv və ən az effektiv yanaşma hansıdır?`,
    options: {
      A: `Hamıya tam eyni mükafat verin, töhfə fərqinə baxmayın.`,
      B: `Komandanın ümumi səyini tanıyın, lakin fərqli töhfələri də ədalətli şəkildə qeyd edin.`,
      C: `Yalnız ən görünən bir-iki nəfəri mükafatlandırıb qalanını qeyd etməyin.`,
      D: `Mükafatı heç bir əsas olmadan, növbə ilə bölün.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Töhfələr qeyri-bərabər olanda ən güclü yanaşma komandanın ümumi səyini tanımaq, lakin fərqli töhfələri də ədalətli qeyd etməkdir (B). Hamıya tam eyni mükafat vermək ən çox töhfə verənləri ruhdan sala bilər (A). Mükafatı heç bir əsas olmadan növbə ilə bölmək ədalətsizdir (D). Yalnız ən görünən bir-iki nəfəri mükafatlandırıb qalanını qeyd etməmək isə sakit töhfə verənləri tamamilə gözardı edir, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'smt-m3-q58', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Laboratoriyada bir həmkarınızın işində, kənara getməmişdən əvvəl bir xəta görürsünüz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Xətanı özünüz sakitcə düzəldib həmkarınıza deməyin.`,
      B: `Heç nə deməyib xətanın kənara getməsinə imkan verin.`,
      C: `Həmkarınıza təkbətək bildirib düzəltməsinə kömək təklif edin.`,
      D: `Xətanı birbaşa rəhbərə bildirib həmkarınızla danışmayın.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Həmkarın işində kənara getməmiş xəta görəndə ən təsirli davranış ona təkbətək bildirib düzəltməsinə kömək təklif etməkdir (C). Xətanı özünüz düzəldib deməmək onun öyrənməsinə imkan vermir (A). Birbaşa rəhbərə bildirib həmkarla danışmamaq münasibəti pozur (D). Heç nə deməyib xətanın kənara getməsinə imkan vermək isə real problemə yol açır, ən zəifdir (B).`,
  },
  {
    id: 'smt-m3-q59', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Xidmət mərkəzində bir vətəndaş yalnız narazı deyil, həm də kobud davranır və əsassız tələblər irəli sürür. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Onun tonuna eyni ilə cavab verib özünüz də sərtləşin.`,
      B: `Əsassız tələbi sakitləşdirmək üçün yerinə yetirin.`,
      C: `Sakit və hörmətli qalın, narahatlığı qəbul edin, lakin nəyin mümkün olduğuna dair aydın hədd qoyun.`,
      D: `Heç nə demədən vətəndaşın hirsini boşaltmasına imkan verin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Kobud və əsassız tələbli vətəndaşla ən doğru davranış sakit, hörmətli qalmaq, narahatlığı qəbul etmək, lakin nəyin mümkün olduğuna aydın hədd qoymaqdır (C). Heç nə demədən hirsini boşaltmasına imkan vermək qismən işləyir, ancaq həll vermir (D). Əsassız tələbi sakitləşdirmək üçün yerinə yetirmək ədalətsiz presedent yaradır (B). Onun tonuna eyni ilə cavab verib sərtləşmək isə vəziyyəti daha da kəskinləşdirir, ən az təsirlidir (A).`,
  },
  {
    id: 'smt-m3-q60', course: 'smt', mock_num: 3, topic: 'smt',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çoxşaxəli bir layihədə tez qərar vermək lazımdır, lakin komanda ilə məsləhətləşmək daha yaxşı dəstək qazandıra bilər. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Həmişə tək, sürətli qərar verib komandanı heç vaxt cəlb etməyin.`,
      B: `Hər qərar üçün uzun komanda müzakirəsi keçirin, təcili olsa belə.`,
      C: `Qərarın əhəmiyyətinə və təcilliyinə görə nə vaxt tək, nə vaxt komanda ilə qərar verəcəyinizi seçin.`,
      D: `Qərarı komandaya tam həvalə edib özünüz kənarda qalın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Tezlik və dəstək arasında ən uyğun yanaşma qərarın əhəmiyyətinə və təcilliyinə görə nə vaxt tək, nə vaxt komanda ilə qərar verəcəyinizi seçməkdir (C). Hər qərar üçün uzun müzakirə keçirmək təcili işdə gecikmə yaradır (B). Qərarı bütövlükdə komandaya həvalə edib kənarda qalmaq məsuliyyəti buraxır (D). Həmişə tək qərar verib komandanı heç vaxt cəlb etməmək isə dəstəyi və daha yaxşı qərar imkanını itirir, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m1-q1', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qocalar evində həmkarınız çətin bir növbədən sonra narahatlığını paylaşır, lakin vəziyyəti dəyişdirmək sizin əlinizdə deyil. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Diqqətlə dinləyin, hissini adlandırın və yanında olduğunuzu bildirin.`,
      B: `Vəziyyəti dəyişə bilməsəniz də, bir neçə həll yolu sadalayın.`,
      C: `Öz daha çətin təcrübənizi danışıb müqayisə edin.`,
      D: `"Narahat olmağa dəyməz" deyib mövzunu dəyişin.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Vəziyyəti dəyişə bilmədiyiniz halda ən güclü dəstək diqqətlə dinləmək, hissi adlandırmaq və yanında olduğunuzu bildirməkdir (A). Dəyişdirə bilməyəcəyiniz həll yollarını sadalamaq köməksiz qalır (B). Söhbəti öz təcrübənizə çevirmək diqqəti yayındırır (C). "Narahat olmağa dəyməz" deyib mövzunu dəyişmək isə hissini tam rədd edir, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m1-q2', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Musiqi məktəbində bir valideyn gülümsəyir, lakin narahat göründüyünü hiss edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Söz və ifadə arasındakı uyğunsuzluğu diqqətlə müşahidə edin.`,
      B: `Narahatlığı təzyiq etmədən, mehribanca qeyd edin.`,
      C: `Ona açılması üçün rahat şərait və vaxt verin.`,
      D: `Yalnız sözlərinə və gülüşünə inanıb narahatlığı nəzərdən qaçırın.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Gizlədilən narahatlığı oxumaq söz və ifadə arasındakı uyğunsuzluğu müşahidə etməklə başlayır (A), sonra narahatlığı təzyiqsiz, mehribanca qeyd etmək (B) və ona açılması üçün şərait və vaxt vermək (C). Yalnız sözlərinə və gülüşünə inanıb narahatlığı qaçırmaq isə əsl hissi görmür, ən zəifdir (D).`,
  },
  {
    id: 'ez-m1-q3', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Fizioterapiya klinikasında narahat bir həmkarın həyəcanı sizə də keçməyə başlayır. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Onun həyəcanına qoşulub birlikdə narahat olun.`,
      B: `Həyəcanını "böyük məsələ deyil" deyə kiçildib özünüzü qoruyun.`,
      C: `Öz sakitliyinizi qoruyub onu da sakitləşdirəcək tonla dinləyin.`,
      D: `Söhbəti tez bitirib özünüzü həyəcandan uzaqlaşdırın.`,
    },
    correct: { A: 1, B: 2, C: 4, D: 3 },
    explanation: `Həyəcan yoluxanda ən təsirli reaksiya öz sakitliyinizi qoruyub onu da sakitləşdirəcək tonla dinləməkdir (C, 4). Söhbəti tez bitirib uzaqlaşmaq özünüzü qoruyur, lakin ona kömək etmir (D, 3). Həyəcanını "böyük məsələ deyil" deyə kiçiltmək onu rədd edir (B, 2). Onun həyəcanına qoşulub birlikdə narahat olmaq isə hər ikinizi gücdən salır, ən az təsirlidir (A, 1).`,
  },
  {
    id: 'ez-m1-q4', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yay düşərgəsində bir iştirakçı sizinlə kobud danışır və ürəyinizin döyüntüsünün artdığını, qızışdığınızı hiss edirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Bu fiziki siqnalları keçici sayıb birbaşa məsələnin məzmununa keçin.`,
      B: `Bu fiziki siqnalları qızışdığınızın əlaməti kimi tanıyıb cavab verməzdən əvvəl bir an sakitləşin.`,
      C: `Hiss etdiyinizi tamamilə danıb heç nə olmamış kimi davam edin.`,
      D: `Qızğınlığı saxlamaq üçün söhbətdən birdən çıxıb gedin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Artan döyüntü və qızışma kimi fiziki siqnalları öz qızğınlığınızın əlaməti kimi tanıyıb cavabdan əvvəl sakitləşmək ən doğru yanaşmadır (B). Söhbətdən birdən çıxıb getmək qızğınlığı saxlasa da, problemi həll etmir (D). Hiss etdiyinizi bütövlükdə danmaq emosiyanı gizlədir (C). Bu fiziki siqnalları keçici sayıb birbaşa məzmuna keçmək isə öz halınızı gözardı edir və peşman olacağınız reaksiyaya gətirir, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m1-q5', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Dərzi atelyesində bir görüşdə izahsız bir gərginlik hiss edirsiniz, sözlər isə sakit səslənir. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Gərginliyi vacib saymayıb sözlərə güvənərək davam edin.`,
      B: `Görüşü dərhal dayandırın.`,
      C: `Bu hissi bir məlumat siqnalı kimi qəbul edib nəyin arxasında dayandığını anlamağa çalışın.`,
      D: `Hissi şəxsi əhval-ruhiyyənizə yazıb kənara qoyun.`,
    },
    correct: 'C',
    explanation: `İzahsız gərginlik hissini bir məlumat siqnalı kimi qəbul edib nəyin arxasında dayandığını anlamaq ən uyğun davranışdır (C). Hissi şəxsi əhvalınıza yazıb kənara qoymaq dəyərli siqnalı itirə bilər (D). Yalnız sözlərə güvənib hissi vacib saymamaq qeyri-verbal məlumatı gözardı edir (A). Görüşü dərhal dayandırmaq isə yoxlanmamış həddən artıq reaksiyadır (B).`,
  },
  {
    id: 'ez-m1-q6', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bərbərxanada müştəri "hər şey yaxşıdır" deyir, lakin səsi titrəyir və gözünü yayındırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız sözünə inanıb heç nə soruşmadan keçin.`,
      B: `Onu "yalan danışmaqda" ittiham edib uyğunsuzluğu üzünə deyin.`,
      C: `Söz ilə qeyri-verbal siqnal arasındakı fərqi görüb mehribanca dəqiqləşdirin.`,
      D: `Uyğunsuzluğa əsasən onun nə hiss etdiyi barədə qəti nəticə çıxarın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Söz ilə səs və baxış arasındakı fərqi görüb mehribanca dəqiqləşdirmək ən güclü davranışdır (C). Uyğunsuzluğa əsasən qəti nəticə çıxarmaq bir siqnalı həddindən artıq oxumaqdır (D). Onu "yalan danışmaqda" ittiham etmək münasibəti pozur (B). Yalnız sözünə inanıb heç nə soruşmadan keçmək isə aydın siqnalı tam gözardı edir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m1-q7', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Şəkil çərçivələmə emalatxanasında bir nəfərin nə hiss etdiyini dəqiq anlamağa çalışırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Əmin olmasanız, mehribanca dəqiqləşdirin.`,
      B: `Yalnız bir siqnaldan, məsələn üz ifadəsindən qəti hökm verin.`,
      C: `Üz, səs və bədən dili kimi bir neçə kanaldan siqnalları müşahidə edin.`,
      D: `Konteksti və şəxsin adi davranışını nəzərə alın.`,
    },
    correct: ['C', 'D', 'A', 'B'],
    explanation: `Emosiyanı dəqiq oxumaq üz, səs və bədən dili kimi bir neçə kanalı müşahidə etməklə başlayır (C), sonra konteksti və şəxsin adi davranışını nəzərə almaq (D) və əmin olmayanda mehribanca dəqiqləşdirmək (A). Yalnız bir siqnaldan qəti hökm vermək isə səhv oxumağa aparır, ən zəifdir (B).`,
  },
  {
    id: 'ez-m1-q8', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çay evində komanda rəhbərisiniz və bu gün gərginsiniz; əhvalınızın komandaya təsir etdiyini görürsünüz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Gərginliyinizi olduğu kimi komandaya ötürün.`,
      B: `Gərgin əhvalınıza görə komandanı günahlandırın.`,
      C: `Hiss etdiyinizi tamamilə gizlədib süni şəkildə şən görünün.`,
      D: `Öz əhvalınızı tənzimləyin və komandaya sakit ton ötürün, çünki emosiyalar yoluxur.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Əhval yoluxduğu üçün ən təsirli davranış öz əhvalınızı tənzimləyib komandaya sakit ton ötürməkdir (D). Hiss etdiyinizi bütövlükdə gizlədib süni şənlik göstərmək davamlı deyil (C). Gərginliyi olduğu kimi ötürmək komandaya da keçir (A). Gərgin əhvalınıza görə komandanı günahlandırmaq isə həm haqsız, həm zərərlidir, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m1-q9', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `İncəsənət qalereyasında vacib bir açılışdan əvvəl həyəcanlısınız. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Həyəcanı tanıyın, enerjiyə çevirin və hazırlığınızı son dəfə gözdən keçirin.`,
      B: `Həyəcanı inkar edib heç nə hiss etmədiyinizi deyin.`,
      C: `Həyəcanı hazırlığa daha çox diqqət yönəltmək üçün istifadə edin.`,
      D: `Həyəcana görə açılışı təxirə salmağı düşünün.`,
    },
    correct: { A: 4, B: 1, C: 3, D: 2 },
    explanation: `Ən güclü yanaşma həyəcanı tanıyıb enerjiyə çevirmək və hazırlığı son dəfə gözdən keçirməkdir (A, 4). Həyəcanı hazırlığa diqqət üçün istifadə etmək də faydalıdır (C, 3). Həyəcana görə açılışı təxirə salmaq qaçınmadır (D, 2). Həyəcanı inkar edib heç nə hiss etmədiyinizi demək isə hissi gizlədir və idarə etməyi çətinləşdirir, ən zəif seçimdir (B, 1).`,
  },
  {
    id: 'ez-m1-q10', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Reabilitasiya mərkəzində çox əsəbisiniz və dərhal sərt bir mesaj yazıb göndərmək istəyirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Emosiyanın zirvəsinin keçməsi üçün bir az ara verin, sonra sakit yazın.`,
      B: `Mesajı dərhal, hiss etdiyiniz kimi yazıb göndərin.`,
      C: `Mesajın tonu sərt çıxsa da, bunu fərq etmədən göndərin.`,
      D: `Mesajı yazın, lakin göndərmədən əvvəl tam fərqli bir işə keçin.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Əsəbin zirvəsi keçənə qədər bir az ara verib sonra sakit yazmaq ən doğru davranışdır (A). Mesajı yazıb, göndərmədən başqa işə keçmək də zirvəni yumşaldır (D). Mesajı dərhal hiss etdiyiniz kimi göndərmək peşmançılığa apara bilər (B). Mesajın tonu sərt çıxsa da, bunu fərq etmədən göndərmək isə qarşı tərəfi incidə bilər, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'ez-m1-q11', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kvest otağı komandasında güclü bir emosiya yaşayırsınız və onu anlamağa çalışırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hissin nəyə işarə etdiyini, məqsədini anlayın.`,
      B: `Hissin zirvəsinin keçməsinə bir az imkan verin.`,
      C: `Hiss yarananda dərhal ona uyğun hərəkət edin.`,
      D: `Hissi nəyin tətiklədiyini müəyyən edin.`,
    },
    correct: ['D', 'A', 'B', 'C'],
    explanation: `Güclü emosiyanı anlamaq onu nəyin tətiklədiyini müəyyən etməklə başlayır (D), sonra hissin nəyə işarə etdiyini, məqsədini anlamaq (A) və zirvəsinin keçməsinə bir az imkan vermək (B). Hiss yarananda dərhal ona uyğun hərəkət etmək isə çox vaxt peşmançılıq yaradır, ən zəifdir (C).`,
  },
  {
    id: 'ez-m1-q12', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yoga studiyasında iki iştirakçı arasında qızğın mübahisə gedir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səsinizi qaldırıb hər ikisini bir anda susdurun.`,
      B: `Sakit ton, qəbuledici dil və ortaq nöqtə ilə gərginliyi azaldın.`,
      C: `Tərəf tutub birini müdafiə edin.`,
      D: `Tərəflərə özləri həll etməyi deyib otaqdan çıxın.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Qızğın mübahisədə ən uyğun davranış sakit ton, qəbuledici dil və ortaq nöqtə ilə gərginliyi azaltmaqdır (B). Tərəf tutub birini müdafiə etmək münaqişəni dərinləşdirir (C). Səs qaldırıb susdurmaq anlıq kəsir, lakin səbəbi həll etmir (A). Tərəflərə özləri həll etməyi deyib otaqdan çıxmaq isə vəziyyəti idarəsiz qoyur, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m1-q13', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Kitab mağazasında bir həmkar sevincli bir xəbərini sizinlə bölüşür. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Qısaca "təbrik edirəm" deyib öz işinizə davam edin.`,
      B: `Sevincinə səmimi şərik olun, detalları soruşub onunla birlikdə sevinin.`,
      C: `"Mənim də belə vaxtım olub" deyib söhbəti özünüzə çevirin.`,
      D: `Sevindiyinizi bildirin, lakin detallara girmədən keçin.`,
    },
    correct: { A: 2, B: 4, C: 1, D: 3 },
    explanation: `Sevincli xəbərdə ən güclü reaksiya səmimi şərik olmaq, detalları soruşub onunla birlikdə sevinməkdir (B, 4). Sevindiyinizi bildirib detallara girməmək də müsbətdir, lakin zəif əlaqədir (D, 3). Qısaca təbrik edib işə davam etmək anı kiçildir (A, 2). "Mənim də belə vaxtım olub" deyib söhbəti özünüzə çevirmək isə onun sevincini kölgədə qoyur, ən zəif seçimdir (C, 1).`,
  },
  {
    id: 'ez-m1-q14', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Konsert zalında həmkarınız narahatdır və problemini bölüşür. Ona kömək etməyin ən effektiv və ən az effektiv yolunu seçin.`,
    options: {
      A: `Problemini tamamilə öz üzərinizə götürüb əvəzinə həll edin.`,
      B: `Onun əvəzinə qərar verib həlli ona diktə edin.`,
      C: `Hisslərini anlamaqda və öz həllini tapmaqda ona kömək edin, məsuliyyəti onda saxlayın.`,
      D: `Dinləyin, lakin heç bir dəstək və ya istiqamət təklif etməyin.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Ən güclü kömək hisslərini anlamaqda və öz həllini tapmaqda ona dəstək olmaq, məsuliyyəti isə onda saxlamaqdır (C). Problemini bütövlükdə öz üzərinizə götürmək onu asılı edir (A). Yalnız dinləyib heç bir dəstək təklif etməmək yarımçıqdır (D). Onun əvəzinə qərar verib həlli diktə etmək isə həm onun iradəsini, həm öyrənməsini əlindən alır, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'ez-m1-q15', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Geyim mağazasında güclü bir emosiyanı məhz həmin anda idarə edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Bir an dayanıb dərindən nəfəs alın.`,
      B: `Sakit və ölçülü cavab verin.`,
      C: `Vəziyyəti yenidən, daha sakit çərçivədə şərh edin.`,
      D: `Hiss yarananda dərhal, ölçüb-biçmədən cavab verin.`,
    },
    correct: ['A', 'C', 'B', 'D'],
    explanation: `Güclü emosiyanı həmin anda idarə etmək bir an dayanıb dərindən nəfəs almaqla başlayır (A), sonra vəziyyəti daha sakit çərçivədə şərh etmək (C) və sakit, ölçülü cavab vermək (B). Hiss yarananda dərhal, ölçüb-biçmədən cavab vermək isə vəziyyəti pisləşdirə bilər, ən zəifdir (D).`,
  },
  {
    id: 'ez-m1-q16', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Gözəllik salonunda komanda üzvü həm sizi sevindirən, həm də narahat edən bir xəbər verir; eyni anda iki fərqli hiss yaşayırsınız. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız müsbət hissə diqqət yetirib narahatlığı kənara atın.`,
      B: `Yalnız narahatlığa fokuslanıb müsbət tərəfi qaçırın.`,
      C: `İki ziddiyyətli hiss qarışıqlıq yaratdığı üçün hisslərinizi tam bir kənara qoyun.`,
      D: `Hər iki hissi də tanıyın və qərar verməzdən əvvəl hər ikisini nəzərə alın.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Eyni anda iki fərqli hiss yaşayanda ən təsirli yanaşma hər ikisini tanımaq və qərardan əvvəl hər ikisini nəzərə almaqdır (D). Yalnız müsbətə (A) və ya yalnız narahatlığa (B) baxmaq mənzərənin yarısını qaçırır. İki hissin qarışıqlığından qaçıb hissləri tamamilə bir kənara qoymaq isə dəyərli məlumatı itirir, ən az təsirlidir (C).`,
  },
  {
    id: 'ez-m1-q17', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/surprise.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Bir üzdə qaşlar yuxarıya, düz xətt boyunca qalxıb, göz qapaqları geniş açılıb və alın əzələləri (frontalis) aktivdir, lakin qaşların ortası aşağıya və bir-birinə doğru çəkilməyib. Bu ifadə hansı emosiyaya daha çox uyğundur?`,
    options: {
      A: `Təəccüb`,
      B: `Qorxu`,
      C: `Qəzəb`,
      D: `İkrah`,
    },
    correct: 'A',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `Təəccüb və qorxunu fərqləndirən əsas əlamət qaşların ortasıdır. Təəccübdə qaşlar yuxarı qalxır, lakin ortası aşağı çəkilmir. Qorxuda corrugator əzələsi qaşların ortasını aşağı və bir-birinə doğru çəkir, alında şaquli xətt yaranır. Burada belə əlamət yoxdur, deməli A təəccübdür. C qəzəb (qaşlar aşağı) və D ikrah (burun qırışı, üst dodağın qalxması) bütövlükdə fərqli əzələ nümunələridir. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-m1-q18', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Sürücülük məktəbində gözlənilməz bir tənqid sizi qıcıqlandırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Reaksiya ilə hadisə arasında fasilə verib hissinizi adlandırın, sonra cavab verin.`,
      B: `Qıcığı saxlamağa çalışmadan tonunuzda büruzə verin.`,
      C: `Hissi inkar edib heç nə hiss etmədiyinizi deyin.`,
      D: `Tənqidin məzmununu nəzərdən keçirmədən onu tam rədd edin.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Qıcıqlandıranda reaksiya ilə hadisə arasında fasilə verib hissi adlandırmaq, sonra cavab vermək ən doğru davranışdır; hissi adlandırmaq onun şiddətini azaldır (A). Tənqidi məzmununa baxmadan tam rədd etmək faydalı ola biləcək məlumatı itirir (D). Hissi inkar etmək onu gizlədir (C). Qıcığı saxlamağa çalışmadan tonunuzda büruzə vermək isə peşman olacağınız reaksiyaya gətirir, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m1-q19', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Uşaq xəstəxanasında gərgin bir anda artıq kəskin reaksiya vermisiniz. Sonrasında bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Heç nə olmamış kimi davam edib məsələni açmayın.`,
      B: `Kəskin reaksiyanızı vəziyyətlə haqlı çıxarıb davam edin.`,
      C: `Reaksiyanızı özünüz üçün qeyd edin, lakin qarşı tərəflə danışmayın.`,
      D: `Sakitləşəndən sonra reaksiyanızı etiraf edib lazımdırsa üzr istəyin və düzəldin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Kəskin reaksiyadan sonra ən uyğun addım sakitləşəndən sonra onu etiraf edib lazımdırsa üzr istəmək və düzəltməkdir (D, 4). Reaksiyanı özünüz üçün qeyd etmək, lakin qarşı tərəflə danışmamaq bir qədər faydalıdır (C, 3). Reaksiyanı vəziyyətlə haqlı çıxarmaq məsuliyyəti azaldır (B, 2). Heç nə olmamış kimi davam edib məsələni açmamaq isə münasibətdə qalan zədəni düzəltmir, ən az faydalı seçimdir (A, 1).`,
  },
  {
    id: 'ez-m1-q20', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Sənət emalatxanasında yaxın həmkarınız ağır şəxsi problemini danışır və siz çox təsirlənirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Onun emosiyasına o qədər qapılın ki, özünüz də işləyə bilməyəsiniz.`,
      B: `Ona səmimi dəstək olun, lakin obyektivliyinizi və emosional sərhədinizi qoruyun.`,
      C: `Hisslərini ikinci plana qoyub yalnız işə fokuslanın.`,
      D: `Söhbətdən büsbütün qaçıb mövzunu dəyişin.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Çox təsirləndiyiniz halda ən güclü davranış səmimi dəstək olmaq, eyni zamanda obyektivliyinizi və emosional sərhədinizi qorumaqdır (B). Onun emosiyasına o qədər qapılmaq ki, işləyə bilməyəsiniz, hər ikinizə zərər verir (A). Söhbətdən büsbütün qaçıb mövzunu dəyişmək onu tək qoyur (D). Hisslərini bütövlükdə kənara qoyub soyuq davranmaq isə yaxın həmkara dəstəyi tam kəsir, ən zəifdir (C).`,
  },
  {
    id: 'ez-m1-q21', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Planetarium turunda bir qonaq açıq şəkildə hirslənib və narahatdır; onu sakitləşdirməyə çalışırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `"Sakit ol" deyib dərhal məntiqli həll təklif edin.`,
      B: `Həllə keçməzdən əvvəl ona bir az toxtamaq vaxtı verin.`,
      C: `Onun hissini mübahisə etmədən qəbul etdiyinizi bildirin.`,
      D: `Əvvəlcə öz tonunuzu sakit saxlayıb səsinizi aşağı tutun.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Hirsli birini sakitləşdirmək əvvəlcə öz tonunuzu sakit saxlamaqla başlayır (D), sonra hissini mübahisəsiz qəbul etmək (C) və həllə keçməzdən əvvəl ona toxtamaq vaxtı vermək (B). "Sakit ol" deyib hələ hirsliykən məntiqli həll təklif etmək isə çox vaxt əksini doğurur, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m1-q22', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Şəhər turu bələdçiliyində sakit, diqqətli əhvaldasınız. Qarşınızda həm detallı marşrut planlaması, həm enerjili qrup qarşılaması var. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Əhvalınızı nəzərə almadan işləri gəldiyi kimi görün.`,
      B: `Sakit əhvalınıza baxmayaraq əvvəlcə enerjili qarşılamanı zorla edin.`,
      C: `Hazırkı sakit, diqqətli əhvalınıza uyğun gələn detallı planlama işini indi görün, enerjili işi enerjiniz artanda.`,
      D: `Əhvalınız dəyişənə qədər heç bir işə başlamayın.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Hazırkı əhvalınıza uyğun işi seçmək məhsuldarlığı artırır: sakit, diqqətli halınızda detallı planlamanı görmək ən effektivdir (C). Sakit halınızda enerjili qarşılamanı zorla etmək işi də, əhvalınızı da pisləşdirir (B). Əhvalı nəzərə almadan işləri gəldiyi kimi görmək uyğunluğu itirir (A). Əhvalınız dəyişənə qədər heç bir işə başlamamaq isə hazırkı halınıza uyğun işi də dayandırır, ən zəif seçimdir (D).`,
  },
  {
    id: 'ez-m1-q23', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Tələbə məsləhət mərkəzində gözlənilməz bir xəbər sizdə narahatlıq yaradır, lakin indi həmin narahatlığa görə addım atmaq düzgün deyil. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Narahatlığın orada olmasına icazə verin, ötəri olduğunu bilib ona görə tələm-tələsik hərəkət etməyin.`,
      B: `Narahatlığı azaltmaq üçün dərhal düşünülməmiş bir addım atın.`,
      C: `Narahatlığı yayındırmaq üçün özünüzü başqa işlə məşğul edin.`,
      D: `Narahatlığı tamamilə danıb heç nə hiss etmədiyinizi deyin.`,
    },
    correct: { A: 4, B: 1, C: 3, D: 2 },
    explanation: `Bəzən ən təsirli yanaşma narahatlığın olmasına icazə verib ona görə tələsik hərəkət etməməkdir (A, 4). Diqqəti başqa işə yönəltmək keçici rahatlıq verir (C, 3). Narahatlığı bütövlükdə danmaq onu gizlədir (D, 2). Narahatlığı azaltmaq üçün dərhal düşünülməmiş addım atmaq isə çox vaxt vəziyyəti pisləşdirir, ən az faydalı seçimdir (B, 1).`,
  },
  {
    id: 'ez-m1-q24', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Könüllülər təşkilatında bir həmkar sakit görünür, lakin siz özünüz narahat olduğunuz üçün onun da narahat olduğunu düşünürsünüz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Öz narahatlığınızı ona aid edib buna görə davranın.`,
      B: `Hər ikinizin narahat olduğunu güman edib mövzunu açmayın.`,
      C: `Öz narahatlığınızı tam danıb yalnız onun halına baxın.`,
      D: `Öz narahatlığınızı onun halından ayırıb, həqiqətən nə hiss etdiyini soruşaraq yoxlayın.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Ən güclü davranış öz narahatlığınızı onun halından ayırıb həqiqətən nə hiss etdiyini soruşaraq yoxlamaqdır (D). Hər ikinizin narahat olduğunu güman edib mövzunu açmamaq yanlış fərziyyəyə əsaslanır (B). Öz narahatlığınızı tamamilə danmaq özünüzü gözardı edir (C). Öz narahatlığınızı ona aid edib buna görə davranmaq isə öz hissinizi başqasına proyeksiya etməkdir, ən zəifdir (A).`,
  },
  {
    id: 'ez-m1-q25', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sərgi mərkəzində son həftələrdə enerjinizin və işə marağınızın getdikcə azaldığını fərq edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İş yükü, istirahət və ya dəstək baxımından nəyi dəyişə biləcəyinizi planlaşdırın.`,
      B: `Enerji və maraq düşüşünü bir siqnal kimi qəbul edib qeyd edin.`,
      C: `Əlamətləri əhəmiyyətsiz sayıb eyni templə davam edin.`,
      D: `Bu düşüşün hansı səbəblərdən qaynaqlandığını araşdırın.`,
    },
    correct: ['B', 'D', 'A', 'C'],
    explanation: `Tükənmənin erkən əlamətlərini idarə etmək onları bir siqnal kimi qəbul edib qeyd etməklə başlayır (B), sonra səbəbləri araşdırmaq (D) və iş yükü, istirahət və ya dəstək baxımından nəyi dəyişə biləcəyinizi planlaşdırmaq (A). Əlamətləri əhəmiyyətsiz sayıb eyni templə davam etmək isə tükənməni dərinləşdirir, ən az təsirlidir (C).`,
  },
  {
    id: 'ez-m1-q26', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Uşaq teatrında çox istədiyiniz bir vəzifə başqasına verilir və məyus olursunuz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Məyusluğu özünüzə etiraf edin, ötəri olduğunu bilin və peşəkar münasibətinizi qoruyun.`,
      B: `Məyusluğu büruzə verməmək üçün heç nə hiss etmədiyinizi deyin.`,
      C: `Məyusluğu seçilən şəxsə və ya qərar verənə qarşı soyuqluqla göstərin.`,
      D: `Məyusluğu uzun müddət üzərinizdə saxlayıb hər şeyə laqeyd olun.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `İstədiyinizi əldə etməyəndə ən doğru davranış məyusluğu özünüzə etiraf etmək, ötəri olduğunu bilmək və peşəkar münasibəti qorumaqdır (A). Heç nə hiss etmədiyinizi demək hissi gizlədir (B). Məyusluğu uzun saxlayıb hər şeyə laqeyd olmaq özünüzə zərər verir (D). Məyusluğu seçilən şəxsə və ya qərar verənə soyuqluqla göstərmək isə münasibətləri pozur, ən zəif seçimdir (C).`,
  },
  {
    id: 'ez-m1-q27', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `İctimai məsləhət xəttində güclü bir hiss yaşayırsınız, lakin müştəri qarşısındasınız. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Hissi müştəri qarşısında saxlayıb sonra uyğun yerdə işləyin.`,
      B: `Hissi tanıyın, peşəkar davranışı qoruyun və sonra uyğun şəraitdə ifadə edin.`,
      C: `Hissi müştərinin qarşısında olduğu kimi büruzə verin.`,
      D: `Hissi bütövlükdə danıb bir daha ona qayıtmayın.`,
    },
    correct: { A: 3, B: 4, C: 1, D: 2 },
    explanation: `Ən güclü yanaşma hissi tanımaq, müştəri qarşısında peşəkar davranışı qorumaq və sonra uyğun şəraitdə ifadə etməkdir (B, 4). Hissi indi saxlayıb sonra işləmək də yaxşıdır (A, 3). Hissi tam danıb heç qayıtmamaq onu işlənməmiş qoyur (D, 2). Hissi müştəri qarşısında olduğu kimi büruzə vermək isə həm peşəkarlığı pozur, ən az faydalı seçimdir (C, 1).`,
  },
  {
    id: 'ez-m1-q28', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Restoran zalında həmkarınız bu gün qaşqabaqlıdır və sizinlə qısa danışır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Dərhal "məndən inciyib" deyə qəti nəticə çıxarıb özünüzü pis hiss edin.`,
      B: `Davranışın çoxlu səbəbi ola biləcəyini bilib şəxsən qəbul etmədən normal davranın.`,
      C: `Onu narahat edən nəsə etdiyinizi düşünüb dərhal uzun-uzadı üzr istəyin.`,
      D: `Hər ehtimala qarşı onunla ünsiyyəti azaldın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Ən güclü davranış həmkarın qaşqabağının çoxlu səbəbi ola biləcəyini bilib onu şəxsən qəbul etmədən normal davranmaqdır (B). Etdiyinizi düşünüb dərhal uzun üzr istəmək yoxlanmamış fərziyyəyə əsaslanır (C). Hər ehtimala qarşı ünsiyyəti azaltmaq məsafə yaradır (D). Dərhal "məndən inciyib" deyə nəticə çıxarıb özünüzü pis hiss etmək isə başqasının əhvalını əsassız olaraq özünüzə aid etməkdir, ən zəifdir (A).`,
  },
  {
    id: 'ez-m1-q29', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Gözəllik akademiyasında özünüzdə qarışıq bir hiss var və onu dəqiq adlandırmaq istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Onu oxşar hisslərdən, məsələn əsəbilik, məyusluq, narahatlıqdan fərqləndirin.`,
      B: `Hissi sadəcə "pis" deyə ümumiləşdirib keçin.`,
      C: `Bir an dayanıb nəsə hiss etdiyinizi fərq edin.`,
      D: `Hissi mümkün qədər dəqiq adlandırın.`,
    },
    correct: ['C', 'A', 'D', 'B'],
    explanation: `Hissi dəqiq adlandırmaq əvvəlcə nəsə hiss etdiyinizi fərq etməklə başlayır (C), sonra onu oxşar hisslərdən fərqləndirmək (A) və mümkün qədər dəqiq adlandırmaq (D). Hissi sadəcə "pis" deyə ümumiləşdirmək isə onu anlamağa və idarə etməyə imkan vermir, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m1-q30', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sürücülük kursunda fikirlərinə qətiyyən qatılmadığınız bir həmkarın mövqeyini anlamağa çalışırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Razı olmadığınız üçün onu dinləməyə dəyməz sayın.`,
      B: `Mühakiməni bir anlıq kənara qoyub açıq dinləyin.`,
      C: `Onun mövqeyinin arxasındakı səbəbi və hissi anlamağa çalışın.`,
      D: `Anladığınızı öz sözlərinizlə təkrar edib doğru başa düşdüyünüzü yoxlayın.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Razı olmadığınız mövqeyi anlamaq mühakiməni bir anlıq kənara qoyub açıq dinləməklə başlayır (B), sonra mövqenin arxasındakı səbəbi və hissi anlamaq (C) və anladığınızı öz sözlərinizlə təkrar edib yoxlamaq (D). Razı olmadığınız üçün onu dinləməyə dəyməz saymaq isə anlamağı tamamilə bağlayır, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m1-q31', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Xəstəxana qeydiyyatında bir ziyarətçi hirslə dərdini danışır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hələ hirsliykən dərhal məntiqli izah və həll təklif edin.`,
      B: `Hissinə toxunmadan yalnız prosedurdan danışın.`,
      C: `Əvvəlcə hissini eşitdiyinizi bildirib qəbul edin, sonra həllə keçin.`,
      D: `Hirsinə görə onunla qısa, soyuq davranın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Hirsli birini ən uyğun yolla idarə etmək əvvəlcə hissini eşitdiyinizi bildirib qəbul etmək, sonra həllə keçməkdir (C). Yalnız prosedurdan danışıb hissinə toxunmamaq onu eşidilməmiş qoyur (B). Hirsinə görə soyuq davranmaq gərginliyi artırır (D). Hələ hirsliykən dərhal məntiqli izah və həll təklif etmək isə bu anda qəbul edilmir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m1-q32', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Planetarium turunda bir həmkar pərt görünür və geri çəkilib. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Onun seçiminə hörmət edib istədiyi məkanı və ya dəstəyi verin.`,
      B: `Hazır olduqda yanında olacağınızı sakitcə bildirin.`,
      C: `Nə istədiyini nəzərə almadan onu danışmağa məcbur edin.`,
      D: `Onun indi məkan, yoxsa dəstək istədiyini fərq etməyə çalışın.`,
    },
    correct: ['D', 'B', 'A', 'C'],
    explanation: `Geri çəkilmiş həmkara yanaşmaq onun indi məkan, yoxsa dəstək istədiyini fərq etməklə başlayır (D), sonra hazır olduqda yanında olacağınızı sakitcə bildirmək (B) və seçiminə hörmət edib istədiyini vermək (A). Nə istədiyini nəzərə almadan onu danışmağa məcbur etmək isə təzyiq yaradır, ən zəifdir (C).`,
  },
  {
    id: 'ez-m1-q33', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Uşaq xəstəxanasında bir səhv etmisiniz və özünüzü çox sərt tənqid edirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Özünüzü həddən artıq tənqid edib səhvi lazımından böyük göstərin.`,
      B: `Səhvi qəbul edin, lakin üzərində uzun müddət dayanmayın.`,
      C: `Səhvi bütövlükdə unutmağa çalışıb heç düşünməyin.`,
      D: `Səhvə insani yanaşın, dərsini çıxarın və eyni dəstəyi özünüzə də göstərin.`,
    },
    correct: { A: 1, B: 3, C: 2, D: 4 },
    explanation: `Səhvdən sonra ən güclü yanaşma ona insani yanaşmaq, dərsini çıxarmaq və başqasına göstərəcəyiniz dəstəyi özünüzə də göstərməkdir (D, 4). Səhvi qəbul edib üzərində uzun dayanmamaq da sağlamdır (B, 3). Səhvi tam unutmağa çalışmaq dərs çıxarmağa imkan vermir (C, 2). Özünüzü həddən artıq tənqid edib səhvi lazımından böyük göstərmək isə nə düzəldir, nə öyrədir, ən az təsirlidir (A, 1).`,
  },
  {
    id: 'ez-m1-q34', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Musiqi məktəbində bir qərar verməlisiniz, lakin bu gün əsəbi olduğunuzu və bunun mühakimənizə təsir edə biləcəyini hiss edirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Əsəbiliyin qərara təsir etmədiyini düşünüb dərhal qərar verin.`,
      B: `Qərarı tamamilə başqasına ötürün.`,
      C: `Əsəbiniz keçənə qədər bütün qərarlardan qaçın.`,
      D: `Əhvalınızın təsirini tanıyın, mümkünsə qərarı bir az təxirə salın və ya faktlara ikiqat diqqət yetirin.`,
    },
    correct: 'D',
    explanation: `Ən güclü davranış əhvalınızın mühakiməyə təsirini tanıyıb, mümkünsə qərarı bir az təxirə salmaq və ya faktlara ikiqat diqqət yetirməkdir (D). Əsəbiliyin təsir etmədiyini düşünüb dərhal qərar vermək qərəzi gözardı edir (A). Qərarı bütövlükdə başqasına ötürmək məsuliyyətdən qaçmaqdır (B). Əsəb keçənə qədər bütün qərarlardan qaçmaq isə həddən artıqdır (C).`,
  },
  {
    id: 'ez-m1-q35', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/disgust.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Bir üzdə burun qırışıb, üst dodaq yuxarı qalxıb və qaşlar bir qədər aşağıdır. Bu ifadə hansı emosiyaya daha çox uyğundur?`,
    options: {
      A: `Qəzəb`,
      B: `İkrah`,
      C: `Təəccüb`,
      D: `Sevinc`,
    },
    correct: 'B',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `İkrahın əsas əlaməti burun qırışması və üst dodağın yuxarı qalxmasıdır; bu üzdə hər ikisi var, deməli B (ikrah) doğru cavabdır. Qəzəbdə qaşlar enir və göz qapaqları gərilir, burun qırışması olmur (A). Təəccübdə qaşlar yuxarı qalxır və ağız açılır (C). Sevincdə yanaqlar qalxır və təbəssüm olur (D). Bu siqnallar burada yoxdur. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-m1-q36', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tələbə yataqxanasında bir tələbə kəskin tonla "nə istəyirsən, elə et" deyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Tonu saymayıb birbaşa mövzunu dəyişin.`,
      B: `Sözü hərfi mənada qəbul edib istədiyinizi edin.`,
      C: `Tonuna görə onu sərtliklə qınayın.`,
      D: `Söz ilə tonun uyğunsuzluğunu görüb əslində nəyin onu narahat etdiyini mehribanca soruşun.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Kəskin tonla deyilən "nə istəyirsən, elə et" sözündə ən təsirli davranış söz ilə tonun uyğunsuzluğunu görüb əslində nəyin narahat etdiyini mehribanca soruşmaqdır (D). Tonuna görə onu sərtliklə qınamaq gərginliyi artırır (C). Tonu saymayıb mövzunu dəyişmək siqnalı buraxır (A). Sözü hərfi mənada qəbul edib istədiyinizi etmək isə əsl mesajı tam qaçırır, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m1-q37', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sürücülük məktəbində bir həmkarın davranışı sizi incidib və bunu ona bildirmək istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Nə hiss etdiyinizi və səbəbini özünüz üçün aydınlaşdırın.`,
      B: `Hissi ittiham deyil, öz hissiniz kimi ifadə edin, məsələn "mən ... hiss etdim".`,
      C: `Hissi ittiham şəklində birbaşa onun üzünə boşaldın.`,
      D: `Danışmaq üçün uyğun vaxt və sakit şərait seçin.`,
    },
    correct: ['A', 'D', 'B', 'C'],
    explanation: `İncikliyi konstruktiv çatdırmaq əvvəlcə nə hiss etdiyinizi və səbəbini özünüz üçün aydınlaşdırmaqla başlayır (A), sonra uyğun vaxt və sakit şərait seçmək (D) və hissi ittiham deyil, öz hissiniz kimi ifadə etmək (B). Hissi ittiham şəklində birbaşa onun üzünə boşaltmaq isə münasibəti pozur və problemi həll etmir, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'ez-m1-q38', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Gözəllik akademiyasında bir həmkar pərt vəziyyətini sizdən daha yavaş emal edir və siz səbirsizlik hiss edirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Səbirsizliyi göstərib onu tələsdirin.`,
      B: `Səbirsizliyinizi içinizdə saxlayın, lakin narahatlığınız bir az hiss olunur.`,
      C: `Hər kəsin emosiyanı fərqli sürətlə emal etdiyini xatırlayıb ona vaxt verin.`,
      D: `Səbirsiz olduğunuz üçün söhbəti yarımçıq kəsib onu tək buraxın.`,
    },
    correct: { A: 1, B: 3, C: 4, D: 2 },
    explanation: `Ən güclü yanaşma hər kəsin emosiyanı fərqli sürətlə emal etdiyini xatırlayıb ona vaxt verməkdir (C, 4). Səbirsizliyi içinizdə saxlamaq, az da olsa hiss olunsa belə, tələsdirməkdən yaxşıdır (B, 3). Səbirsizlikdən söhbəti yarımçıq kəsib onu tək buraxmaq dəstəyi kəsir (D, 2). Səbirsizliyi göstərib onu tələsdirmək isə emal prosesini pozur, ən zəifdir (A, 1).`,
  },
  {
    id: 'ez-m1-q39', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Klinikada bir həmkar daim mənfi əhval yayır və bu, sizin əhvalınıza təsir edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Onunla mehriban qalın, lakin mənfi əhvalını öz üzərinizə götürməmək üçün emosional məsafə saxlayın.`,
      B: `Onun mənfi əhvalına qoşulub birlikdə şikayətlənin.`,
      C: `Onunla qısa və formal davranıb aranıza məsafə qoyun.`,
      D: `Hər ünsiyyətdən qaçıb onu tam kənarlaşdırın.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Daim mənfi əhval yayan həmkarla ən doğru davranış mehriban qalıb, mənfi əhvalını öz üzərinizə götürməmək üçün emosional məsafə saxlamaqdır (A). Onunla qısa, formal davranıb məsafə qoymaq soyuq görünsə də emosional məsafəni qoruyur (C). Hər ünsiyyətdən qaçıb tamamilə kənarlaşdırmaq iş münasibətini çətinləşdirir (D). Onun mənfi əhvalına qoşulub birlikdə şikayətlənmək isə mənfi əhvalı sizə də yoluxdurur və bu davranışı gücləndirir, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m1-q40', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sənət emalatxanasında bir qrupla işləyirsiniz və ümumi əhvalı oxumaq istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Qrupun sizinlə eyni hissdə olduğunu güman edib davam edin.`,
      B: `Dəyişiklikləri və ümumi tondan fərqlənənləri fərq edin.`,
      C: `Qrupun ümumi enerjisini və tonunu müşahidə edin.`,
      D: `Yanaşmanızı qrupun real əhvalına uyğunlaşdırın.`,
    },
    correct: ['C', 'B', 'D', 'A'],
    explanation: `Qrupun ümumi əhvalını oxumaq onun enerjisini və tonunu müşahidə etməklə başlayır (C), sonra dəyişiklikləri və ümumi tondan fərqlənənləri fərq etmək (B) və yanaşmanızı qrupun real əhvalına uyğunlaşdırmaq (D). Qrupun sizinlə eyni hissdə olduğunu güman edib davam etmək isə real əhvalı qaçırır, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m1-q41', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Çağrı mərkəzində bir həmkar həmişəkindən artıq şən görünür, lakin bu, bir az süni təsir bağışlayır. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Şənliyin altında nəsə ola biləcəyini nəzərə alıb mehribanca, təzyiqsiz hal-əhval tutun.`,
      B: `Şənliyini olduğu kimi qəbul edib heç düşünməyin.`,
      C: `Bir müddət müşahidə edib davranışında dəyişiklik olub-olmadığına baxın.`,
      D: `Onu "süni davranmaqda" ittiham edin.`,
    },
    correct: { A: 4, B: 1, C: 3, D: 2 },
    explanation: `Süni görünən şənlikdə ən uyğun yanaşma altında nəsə ola biləcəyini nəzərə alıb mehribanca, təzyiqsiz hal-əhval tutmaqdır (A, 4). Bir müddət müşahidə edib dəyişikliyə baxmaq da məqbuldur (C, 3). Onu süni davranmaqda ittiham etmək münasibəti pozur (D, 2). Şənliyini olduğu kimi qəbul edib heç düşünməmək isə altdakı hissi qaçırır, ən az faydalı seçimdir (B, 1).`,
  },
  {
    id: 'ez-m1-q42', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Aptekdə vacib bir iş görərkən gözlənilməz bir xəbər sizi pisləşdirir, lakin işi davam etdirməlisiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `İşi dayandırıb xəbəri uzun-uzadı götür-qoy etməyə başlayın.`,
      B: `Bir an dayanıb nəfəs alın, diqqətinizi yenidən cari işə yönəldib davam edin.`,
      C: `Pisləşdiyinizi bilsəniz də, heç nə etmədən eyni templə davam edin.`,
      D: `İşi yarıda saxlayıb əhvalınız düzələnə qədər başqa işlərə keçin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Pisləşdirən xəbərdən sonra işi davam etdirmək üçün ən güclü yol bir an dayanıb nəfəs almaq, diqqəti yenidən cari işə yönəltməkdir (B). İşi dayandırıb xəbəri uzun götür-qoy etmək diqqəti tamam itirir (A). Heç nə etmədən eyni templə davam etmək pisləşmiş halı idarəsiz qoyur (C). İşi yarıda saxlayıb sonraya keçirmək isə vaxtında bitməli işə birbaşa zərər vurur, ən zəifdir (D).`,
  },
  {
    id: 'ez-m1-q43', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Restoran zalında işiniz başınızdan aşır və bir həmkar kömək təklif edir. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hansı işi rahat ötürə biləcəyinizi müəyyən edin.`,
      B: `Doğrudan da kömək lazım olduğunu özünüzə etiraf edin.`,
      C: `Təşəkkür edib köməyi qəbul edin və işi aydın bölüşdürün.`,
      D: `Kömək təklifini "özüm bacararam" deyə rədd edib təkbaşına çətinləşin.`,
    },
    correct: ['B', 'A', 'C', 'D'],
    explanation: `Köməyi qəbul etmək əvvəlcə doğrudan da kömək lazım olduğunu özünüzə etiraf etməklə başlayır (B), sonra hansı işi rahat ötürə biləcəyinizi müəyyən etmək (A) və təşəkkür edib köməyi qəbul edərək işi aydın bölüşdürmək (C). Köməyi "özüm bacararam" deyə rədd edib təkbaşına çətinləşmək isə həm sizə, həm işə zərər verir, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m1-q44', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Sərgi mərkəzində çox həyəcanlandıran bir imkan yaranır və dərhal "hə" demək istəyirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Həyəcanın təsiri ilə detalları soruşmadan razılıq verin.`,
      B: `Həyəcanı tanıyın, lakin qərar verməzdən əvvəl bir az aydın düşünməyə vaxt ayırın.`,
      C: `Həyəcanı bölüşün, lakin detalları soruşandan sonra qərar verin.`,
      D: `Həyəcanı bütövlükdə boğub maraqsız görünün.`,
    },
    correct: { A: 1, B: 4, C: 3, D: 2 },
    explanation: `Müsbət həyəcanı da idarə etmək lazımdır: ən təsirli yanaşma həyəcanı tanımaq, lakin qərardan əvvəl bir az aydın düşünməyə vaxt ayırmaqdır (B, 4). Həyəcanı bölüşüb detalları soruşandan sonra qərar vermək də yaxşıdır (C, 3). Həyəcanı tam boğub maraqsız görünmək hissi gizlədir (D, 2). Həyəcanla dərhal, düşünmədən razılıq vermək isə düşünülməmiş öhdəliyə apara bilər, ən zəif seçimdir (A, 1).`,
  },
  {
    id: 'ez-m1-q45', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Reabilitasiya zalında bir həmkar sizdən məsləhət istəyir, lakin əslində sadəcə dinlənilmək istədiyi hiss olunur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız dinləyin, lakin sonradan istəsə də heç vaxt məsləhət verməyin.`,
      B: `İstədiyi kimi dərhal uzun məsləhət verin.`,
      C: `Əvvəlcə diqqətlə dinləyin, sonra məsləhət istəyib-istəmədiyini incə şəkildə yoxlayın.`,
      D: `Nə dinləyin, nə məsləhət verin, mövzunu dəyişin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Sözdəki istəklə əsl ehtiyac fərqli ola bilər: ən doğru davranış əvvəlcə diqqətlə dinləmək, sonra məsləhət istəyib-istəmədiyini incə yoxlamaqdır (C). Dərhal uzun məsləhət vermək əsl ehtiyacı qaçıra bilər (B). Yalnız dinləyib sonradan istəsə də heç məsləhət verməmək çevik deyil (A). Nə dinləmək, nə məsləhət vermək, mövzunu dəyişmək isə onu tamamilə eşitməməkdir, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m1-q46', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Şəhər turunda bir həmkar açıq qəzəbli görünür, lakin altında başqa bir hiss ola biləcəyini düşünürsünüz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Üzə çıxan əsl hissə uyğun, anlayışlı cavab verin.`,
      B: `Yalnız qəzəbə reaksiya verib səbəbini araşdırmayın.`,
      C: `Mehribanca soruşaraq əsl narahatlığı üzə çıxarmağa çalışın.`,
      D: `Qəzəbin altında inciklik və ya qorxu kimi başqa bir hiss ola biləcəyini nəzərə alın.`,
    },
    correct: ['D', 'C', 'A', 'B'],
    explanation: `Səthi qəzəbi anlamaq onun altında inciklik və ya qorxu kimi başqa hiss ola biləcəyini nəzərə almaqla başlayır (D), sonra mehribanca soruşub əsl narahatlığı üzə çıxarmaq (C) və üzə çıxan hissə uyğun, anlayışlı cavab vermək (A). Yalnız qəzəbə reaksiya verib səbəbini araşdırmamaq isə əsl məsələni qaçırır, ən zəifdir (B).`,
  },
  {
    id: 'ez-m1-q47', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Uşaq teatrında biri işinizi səmimi tərifləyir. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `"Əslində elə də yaxşı deyildi" deyə tərifi rədd edin.`,
      B: `Tərifi eşitməzlikdən gəlib mövzunu dəyişin.`,
      C: `Səmimi təşəkkür edib tərifi rahat qəbul edin.`,
      D: `Təşəkkür edin, lakin dərhal həddən artıq tərif qaytarın.`,
    },
    correct: { A: 2, B: 1, C: 4, D: 3 },
    explanation: `Tərifi ən uyğun qarşılamaq səmimi təşəkkür edib onu rahat qəbul etməkdir (C, 4). Təşəkkür edib dərhal həddən artıq tərif qaytarmaq qismən qəribə görünsə də müsbətdir (D, 3). "Elə də yaxşı deyildi" deyə tərifi rədd etmək onu dəyərsizləşdirir (A, 2). Tərifi eşitməzlikdən gəlib mövzunu dəyişmək isə qarşı tərəfi narahat edir, ən az təsirlidir (B, 1).`,
  },
  {
    id: 'ez-m1-q48', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yay düşərgəsində bir həmkardan qısa, quru bir mesaj alırsınız və tonunu mənfi oxuyursunuz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Mesajdan inciyib həmin şəxslə ünsiyyəti azaldın.`,
      B: `Mesaja ümumiyyətlə cavab vermədən keçin.`,
      C: `Mesajı mənfi tonda oxuyub eyni quru tonla cavab verin.`,
      D: `Yazılı mesajda tonun asanlıqla yanlış oxuna biləcəyini bilib mənanı dəqiqləşdirin.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Yazılı mesajda ən güclü yanaşma tonun asanlıqla yanlış oxuna biləcəyini bilib mənanı dəqiqləşdirməkdir (D). Mesaja ümumiyyətlə cavab verməmək məsələni həll etmir (B). Mənfi tonda oxuyub eyni quru tonla cavab vermək yanlış fərziyyəni böyüdür (C). Mesajdan inciyib ünsiyyəti azaltmaq isə yoxlanmamış fərziyyəyə əsasən münasibəti zədələyir, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m1-q49', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Könüllülər mərkəzində biri işinizi tənqid edir və özünüzü müdafiəyə keçmiş hiss edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Müdafiə hissini fərq edib bir an dayanın.`,
      B: `Dərhal müdafiəyə keçib tənqidi rədd edin.`,
      C: `Tənqiddə doğru ola biləcək hissəni axtarın.`,
      D: `Aydınlaşdırıcı sual verib sakit cavab verin.`,
    },
    correct: ['A', 'C', 'D', 'B'],
    explanation: `Müdafiə hissini idarə etmək onu fərq edib bir an dayanmaqla başlayır (A), sonra tənqiddə doğru ola biləcək hissəni axtarmaq (C) və aydınlaşdırıcı sual verib sakit cavab vermək (D). Dərhal müdafiəyə keçib tənqidi rədd etmək isə faydalı ola biləcək məlumatı itirir, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'ez-m1-q50', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Məsləhət xəttində uzun, çətin bir gündən sonra komandanız birlikdə kiçik bir uğur qazanır. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Uğuru qısaca qeyd edib dərhal növbəti işə keçin.`,
      B: `"Bu, adi bir şeydir" deyib heç fikir verməyin.`,
      C: `Yalnız hələ görülməli işlərdən danışıb anı ötürün.`,
      D: `Bir an dayanıb uğuru komanda ilə birlikdə dəyərləndirin və qiymətləndirin.`,
    },
    correct: { A: 3, B: 1, C: 2, D: 4 },
    explanation: `Müsbət anı dəyərləndirmək komandaya enerji verir: ən təsirli yanaşma bir an dayanıb uğuru birlikdə qiymətləndirməkdir (D, 4). Uğuru qısaca qeyd edib növbəti işə keçmək də pis deyil (A, 3). Yalnız görülməli işlərdən danışıb anı ötürmək uğuru kölgədə qoyur (C, 2). "Bu, adi bir şeydir" deyib heç fikir verməmək isə komandanın əməyini dəyərsizləşdirir, ən zəifdir (B, 1).`,
  },
  {
    id: 'ez-m1-q51', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kitab mağazasında saatlardır fasiləsiz işləyirsiniz, diqqətiniz dağılır və əsəbiləşirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Bunları bir fasilə siqnalı kimi qəbul edib qısa ara verin, sonra davam edin.`,
      B: `Əsəbi olduğunuzu fərq etsəniz də, bunun ünsiyyətinizə təsirini nəzərə almadan işi davam etdirin.`,
      C: `İşi büsbütün atıb günü bitirin.`,
      D: `Bu əlamətləri keçici sayıb eyni templə işləməyə davam edin.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Dağılan diqqət və əsəbilik bir fasilə siqnalıdır: ən doğru davranış qısa ara verib sonra davam etməkdir (A). İşi büsbütün atıb günü bitirmək həddən artıq reaksiyadır (C). Əsəbi olduğunuzu fərq etsəniz də, ünsiyyətinizə təsirini nəzərə almadan işi davam etdirmək münasibətə xələl gətirə bilər (B). Bu əlamətləri keçici sayıb eyni templə davam etmək isə həm keyfiyyəti, həm halınızı pisləşdirir, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m1-q52', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Akademiyada bir tələbənin nə hiss etdiyini düşündüyünüzü yoxlamaq istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Təxmininizi mehribanca, sual şəklində ona çatdırın.`,
      B: `Onun cavabına görə anlayışınızı düzəldin.`,
      C: `Müşahidələrə əsasən ehtiyatlı bir təxmin qurun.`,
      D: `İlk təxmininizi doğru sayıb ona görə davranın.`,
    },
    correct: ['C', 'A', 'B', 'D'],
    explanation: `Emosiya oxumağı dəqiqləşdirmək müşahidələrə əsasən ehtiyatlı bir təxmin qurmaqla başlayır (C), sonra təxmini mehribanca, sual şəklində çatdırmaq (A) və onun cavabına görə anlayışınızı düzəltmək (B). İlk təxmini doğru sayıb ona görə davranmaq isə səhv oxumağa apara bilər, ən zəif seçimdir (D).`,
  },
  {
    id: 'ez-m1-q53', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Teatr səhnəsi arxasında komandanız narahatdır, siz isə nikbin qalmaq istəyirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız narahatlıqlara fokuslanıb nikbinliyi bütövlükdə kənara qoyun.`,
      B: `Narahatlıqları ciddi qəbul edin, eyni zamanda real ümid və irəli yolu göstərin.`,
      C: `Narahatlıqları qeyd edin, lakin heç bir yol göstərmədən keçin.`,
      D: `"Hər şey yaxşı olacaq" deyib narahatlıqlarını eşitməyin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Ən güclü yanaşma narahatlıqları ciddi qəbul etmək, eyni zamanda real ümid və irəli yolu göstərməkdir (B). Narahatlıqları qeyd edib heç bir yol göstərməmək yarımçıqdır (C). Yalnız narahatlıqlara fokuslanıb nikbinliyi kənara qoymaq ruhdan salır (A). "Hər şey yaxşı olacaq" deyib narahatlıqları eşitməmək isə real hissləri inkar edir, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m1-q54', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sürücülük kursunda kiçik bir səhvinizlə bir həmkarı narahat etmisiniz və düzəltmək istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Dəfələrlə, həddindən artıq üzr istəyib həmkarı narahat edin.`,
      B: `Səhvi səmimi, qısa şəkildə etiraf edib üzr istəyin.`,
      C: `Bundan sonra normal, rahat davranışa qayıdın.`,
      D: `Vəziyyəti necə düzəldəcəyinizi bildirin.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `Münasibəti bərpa etmək səhvi səmimi, qısa şəkildə etiraf edib üzr istəməklə başlayır (B), sonra vəziyyəti necə düzəldəcəyinizi bildirmək (D) və bundan sonra normal, rahat davranışa qayıtmaq (C). Dəfələrlə, həddindən artıq üzr istəmək isə həmkarı daha da narahat edir və diqqəti sizin narahatlığınıza çəkir, ən zəifdir (A).`,
  },
  {
    id: 'ez-m1-q55', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Bərbərxanada bir həmkar sizin də istədiyiniz bir uğur qazanır və içinizdə paxıllığa bənzər bir hiss yaranır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Paxıllığı onun uğurunu kiçiltməklə büruzə verin.`,
      B: `Hissi danıb heç nə hiss etmədiyinizi deyin.`,
      C: `Hissi özünüzə etiraf edin, onu səmimi təbrik edin və öz hədəflərinizə fokuslanın.`,
      D: `Hissi uzun müddət üzərinizdə saxlayıb əhvalınızı pozun.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Paxıllığa bənzər hissdə ən uyğun davranış onu özünüzə etiraf etmək, həmkarı səmimi təbrik etmək və öz hədəflərinizə fokuslanmaqdır (C). Hissi danmaq onu gizlədir (B). Hissi uzun saxlayıb əhvalınızı pozmaq özünüzə zərər verir (D). Paxıllığı onun uğurunu kiçiltməklə büruzə vermək isə həm münasibəti, həm öz nüfuzunuzu zədələyir, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m1-q56', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `İncəsənət qalereyasında bir həmkarın xahişini rədd etməlisiniz, lakin onu incitməkdən narahatsınız. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Cavabı qeyri-müəyyən saxlayıb həm "hə", həm "yox" kimi səslənin.`,
      B: `Qısaca rədd edib səbəbini izah etmədən mövzunu bağlayın.`,
      C: `Narahatlığa görə razılıq verin, sonra peşman olun.`,
      D: `Mehriban, lakin aydın şəkildə "yox" deyib səbəbini qısaca izah edin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `İncitməkdən narahat olsanız da, ən güclü davranış mehriban, lakin aydın "yox" deyib səbəbini qısaca izah etməkdir (D). Cavabı qeyri-müəyyən saxlamaq qarşı tərəfi çaşdırır (A). Narahatlığa görə razılıq verib sonra peşman olmaq özünüzü çətinə salır (C). Kəskin, soyuq rədd edib mövzunu bağlamaq isə münasibəti lazımsız yerə zədələyir, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m1-q57', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Fizioterapiya otağında bir həmkar bir səhvi düzəldildikdən sonra yüngülləşmiş, lakin bir az utanmış görünür. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Həm yüngülləşməni, həm utancı incə şəkildə oxuyub onu rahatlatacaq tonla davranın.`,
      B: `Səhvi başqalarının yanında xatırladıb zarafata çevirin.`,
      C: `Yalnız səhvə fokuslanıb utancını daha da artırın.`,
      D: `Heç bir hiss görmədiyinizi düşünüb adi davranın.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `İncə qarışıq siqnalları, yüngülləşmə və utancı oxuyub onu rahatlatacaq tonla davranmaq ən təsirli davranışdır (A). Heç bir hiss görmədiyinizi düşünüb adi davranmaq qaçırılmış imkandır (D). Yalnız səhvə fokuslanıb utancını artırmaq lazımsızdır (C). Səhvi başqalarının yanında xatırladıb zarafata çevirmək isə onu açıq şəkildə utandırır, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'ez-m1-q58', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Gənclər mərkəzində gözlənilməz bir problem bütün komandanı həyəcanlandırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Komandanın həyəcanına qoşulub birlikdə təşvişə düşün.`,
      B: `Əvvəlcə öz sakitliyinizi qoruyun, sonra aydın, sakit tonla komandanı toxtadın.`,
      C: `Komandadan tez toplanmağı tələb edib həyəcanı önəmsəməyin.`,
      D: `Heç nə deməyib hərənin öz başının çarəsinə baxmasına buraxın.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Komanda həyəcanlananda ən doğru davranış əvvəlcə öz sakitliyinizi qorumaq, sonra aydın, sakit tonla komandanı toxtatmaqdır, çünki sakitlik də yoluxur (B). Heç nə deməyib hərəni tək buraxmaq idarəsizliyə yol verir (D). Həyəcana qoşulub birlikdə təşvişə düşmək vəziyyəti pisləşdirir (A). Komandadan tez toplanmağı tələb edib həyəcanı önəmsəməmək isə hissləri arxa plana atıb etimadı zəiflədir, ən zəifdir (C).`,
  },
  {
    id: 'ez-m1-q59', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Konsert zalında müəyyən bir mövzu hər dəfə sizi qeyri-adi dərəcədə əsəbiləşdirir və bunu fərq etmisiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Mövzu hər dəfə qalxanda söhbətdən birdən çıxıb gedin.`,
      B: `Tətikləyicini yalnız xarici səbəblərlə izah edib öz reaksiyanıza baxmayın.`,
      C: `Bunun sizin üçün bir tətikləyici olduğunu tanıyıb həmin anlarda daha ehtiyatlı reaksiya verin.`,
      D: `Hər dəfə eyni cür kəskin reaksiya verməyə davam edin.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Təkrarlanan tətikləyicidə ən uyğun davranış bunun sizin üçün bir tətikləyici olduğunu tanıyıb həmin anlarda daha ehtiyatlı reaksiya verməkdir (C). Mövzu qalxanda söhbətdən birdən çıxıb getmək qaçınmadır (A). Hər dəfə eyni kəskin reaksiyanı davam etdirmək heç nəyi dəyişmir (D). Tətikləyicini yalnız xarici səbəblərlə izah edib öz reaksiyanıza baxmamaq isə problemin təkrarlanmasına yol açır, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m1-q60', course: 'ez', mock_num: 1, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Geyim mağazasında bir həmkara onun üçün arzuolunmaz bir xəbəri çatdırmalısınız. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Xəbəri quru, soyuq şəkildə deyib dərhal uzaqlaşın.`,
      B: `Xəbəri verməyi təxirə salıb həmkarı qaranlıqda saxlayın.`,
      C: `Xəbəri yumşaltmaq üçün o qədər dolaşdırın ki, əsl mesaj itsin.`,
      D: `Xəbəri açıq, lakin mehriban şəkildə verin və hisslərinə yer ayırın.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Arzuolunmaz xəbəri çatdırmağın ən güclü yolu onu açıq, lakin mehriban şəkildə vermək və hisslərinə yer ayırmaqdır (D). Xəbəri o qədər dolaşdırmaq ki, əsl mesaj itsin, qarışıqlıq yaradır (C). Xəbəri verməyi təxirə salıb həmkarı qaranlıqda saxlamaq narahatlığı uzadır (B). Xəbəri quru, soyuq deyib dərhal uzaqlaşmaq isə onu çətin anda tək qoyur, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m2-q1', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Aptek piştaxtasında iki müştəri növbə üstündə mübahisə edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Sakit ton və ortaq nöqtə ilə hər ikisini eşidib gərginliyi azaldın.`,
      B: `Səsinizi qaldırıb hər ikisini bir anda susdurun.`,
      C: `Birinin tərəfini tutub digərini haqsız çıxarın.`,
      D: `Tərəflərə özləri həll etməyi deyib piştaxtadan uzaqlaşın.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `İki müştəri arasındakı mübahisədə ən təsirli davranış sakit ton və ortaq nöqtə ilə hər ikisini eşidib gərginliyi azaltmaqdır (A). Tərəf tutmaq münaqişəni dərinləşdirir (C). Səs qaldırıb susdurmaq anlıq kəsir (B). Uzaqlaşıb tərəflərə özləri həll etməyi deyib uzaqlaşmaq isə vəziyyəti idarəsiz qoyur, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m2-q2', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Süni daş sexində gözlənilməz bir maneə işinizi bloklayır və əsəbiləşirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Əsəbi bir an üçün qəbul edib sakitləşin.`,
      B: `Nəyə təsir edə biləcəyinizi, nəyə yox, ayırın.`,
      C: `Edə biləcəyiniz faydalı bir addımı seçib hərəkətə keçin.`,
      D: `Əsəbi komanda yoldaşlarınızla bölüşüb gərginliyi onlara da keçirin.`,
    },
    correct: ['A', 'B', 'C', 'D'],
    explanation: `Bloklanıb əsəbiləşəndə ən doğru ardıcıllıq əsəbi bir an qəbul edib sakitləşmək (A), nəyə təsir edə biləcəyinizi ayırmaq (B) və faydalı bir addım seçib hərəkətə keçməkdir (C). Əsəbi komanda yoldaşlarına keçirmək isə gərginliyi yayır və problemi həll etmir, ən zəifdir (D).`,
  },
  {
    id: 'ez-m2-q3', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Tibbi qeydiyyat şöbəsində bir həmkar bir işin alınmamasından məyusdur. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Məyusluğunu eşidib qəbul edin, sonra birlikdə növbəti addıma baxın.`,
      B: `Dərhal həll yolları sadalayıb keçin.`,
      C: `"O qədər də mühüm deyildi" deyin.`,
      D: `Anladığınızı bildirib lazım olsa dəstək təklif edin.`,
    },
    correct: { A: 4, B: 2, C: 1, D: 3 },
    explanation: `Məyus həmkara ən uyğun reaksiya məyusluğunu eşidib qəbul etmək, sonra birlikdə növbəti addıma baxmaqdır (A, 4). Anladığınızı bildirib dəstək təklif etmək də güclüdür (D, 3). Dərhal həll sadalamaq hissi ötür (B, 2). "O qədər də mühüm deyildi" demək isə hissini kiçildir, ən az təsirlidir (C, 1).`,
  },
  {
    id: 'ez-m2-q4', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Abituriyent qəbul mərkəzində bir gənc sualınızı zarafatla yan keçir, lakin narahat göründüyünü hiss edirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Zarafatına qoşulub mövzunu bağlayın.`,
      B: `Zarafatın altında narahatlıq ola biləcəyini görüb mehribanca, təzyiqsiz yenidən soruşun.`,
      C: `Onu açıq danışmamaqda ittiham edin.`,
      D: `Yalnız zarafatı qəbul edib narahatlığı tam qaçırın.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Zarafatla yan keçilən sualda ən güclü davranış altında narahatlıq ola biləcəyini görüb mehribanca yenidən soruşmaqdır (B). Zarafatına qoşulub mövzunu bağlamaq da onu rahatladır, lakin əsl hissi açmır (A). Onu açıq danışmamaqda ittiham etmək təzyiq yaradır (C). Yalnız zarafatı qəbul edib narahatlığı tamamilə qaçırmaq isə əsl siqnalı görmür, ən zəif seçimdir (D).`,
  },
  {
    id: 'ez-m2-q5', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `İdman akademiyasında özünüzdə adsız, qarışıq bir gərginlik hiss edirsiniz və onu anlamaq istəyirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Gərginliyi vacib saymayıb işə davam edin.`,
      B: `Hissi şəxsi zəiflik sayıb özünüzü tənqid edin.`,
      C: `Bir an dayanıb hissi adlandırın və onu nəyin doğurduğunu anlayın.`,
      D: `Gərginliyi ətrafdakıların üstünə çıxın.`,
    },
    correct: 'C',
    explanation: `Adsız gərginlikdə ən təsirli davranış bir an dayanıb hissi adlandırmaq və onu nəyin doğurduğunu anlamaqdır (C). Gərginliyi vacib saymayıb davam etmək dəyərli siqnalı itirə bilər (A). Hissi şəxsi zəiflik sayıb özünüzü tənqid etmək faydasızdır (B). Gərginliyi ətrafdakıların üstünə çıxmaq isə həm haqsız, həm münasibəti pozandır (D).`,
  },
  {
    id: 'ez-m2-q6', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Nəqliyyat dispetçer mərkəzində həmkarınız çətin, dəyişdirilməsi mümkün olmayan bir vəziyyətdən danışır. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `"Narahat olma, keçər" deyib mövzunu dəyişin.`,
      B: `Vəziyyəti dəyişə bilməsəniz də, bir-bir həll yolları sadalayın.`,
      C: `Diqqətlə dinləyin, hissini adlandırın və yanında olduğunuzu bildirin.`,
      D: `Öz daha çətin növbənizi danışmağa başlayın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Dəyişdirilməsi mümkün olmayan vəziyyətdə ən doğru dəstək diqqətlə dinləmək, hissi adlandırmaq və yanında olduğunuzu bildirməkdir (C). Dəyişə bilməyəcəyiniz həll yolları sadalamaq köməksizdir (B). Söhbəti öz növbənizə çevirmək diqqəti yayındırır (D). "Keçər" deyib mövzunu dəyişmək isə hissini rədd edir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m2-q7', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kinoteatr foyesində bir komanda ilə çətin bir söhbətə başlamazdan əvvəl onların hazır olub-olmadığını qiymətləndirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Uyğun deyilsə, daha yaxşı bir an seçin.`,
      B: `Hazır olub-olmadıqlarına baxmadan dərhal mövzuya keçin.`,
      C: `Qrupun ümumi enerjisini və əhvalını müşahidə edin.`,
      D: `Anın söhbət üçün uyğun olub-olmadığını qiymətləndirin.`,
    },
    correct: ['C', 'D', 'A', 'B'],
    explanation: `Çətin söhbətdən əvvəl qrupun hazırlığını qiymətləndirmək onların enerjisini və əhvalını müşahidə etməklə başlayır (C), sonra anın uyğun olub-olmadığını qiymətləndirmək (D) və uyğun deyilsə daha yaxşı an seçmək (A). Hazırlığa baxmadan dərhal mövzuya keçmək isə söhbəti uğursuzluğa apara bilər, ən zəifdir (B).`,
  },
  {
    id: 'ez-m2-q8', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Suvenir mağazasında növbə rəhbərisiniz və bu gün gərginsiniz; əhvalınız komandaya təsir edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Gərginliyinizi olduğu kimi komandaya ötürün.`,
      B: `Gərgin əhvalınıza görə komandanı günahlandırın.`,
      C: `Hiss etdiyinizi bütövlükdə gizlədib süni şən görünün.`,
      D: `Öz əhvalınızı tənzimləyib komandaya sakit ton ötürün, çünki əhval yoluxur.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Əhval yoluxduğu üçün ən uyğun davranış öz əhvalınızı tənzimləyib komandaya sakit ton ötürməkdir (D). Süni şənlik davamlı deyil (C). Gərginliyi olduğu kimi ötürmək komandaya keçir (A). Gərgin əhvalınıza görə komandanı günahlandırmaq isə haqsız və zərərlidir, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m2-q9', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Vətəndaş qəbulunda vacib bir təqdimatdan əvvəl həyəcanlısınız. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Həyəcana görə təqdimatı təxirə salmağı düşünün.`,
      B: `Həyəcanı tanıyın, enerjiyə çevirin və hazırlığınızı son dəfə gözdən keçirin.`,
      C: `Həyəcanı inkar edib heç nə hiss etmədiyinizi deyin.`,
      D: `Həyəcanı hazırlığa diqqət yönəltmək üçün istifadə edin.`,
    },
    correct: { A: 2, B: 4, C: 1, D: 3 },
    explanation: `Ən güclü yanaşma həyəcanı tanıyıb enerjiyə çevirmək və hazırlığı son dəfə gözdən keçirməkdir (B, 4). Həyəcanı diqqət üçün istifadə etmək də faydalıdır (D, 3). Təqdimatı təxirə salmaq qaçınmadır (A, 2). Həyəcanı inkar etmək isə onu idarə etməyi çətinləşdirir, ən zəif seçimdir (C, 1).`,
  },
  {
    id: 'ez-m2-q10', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Veb-dizayn studiyasında çox əsəbisiniz və dərhal sərt bir cavab yazmaq istəyirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Emosiyanın zirvəsinin keçməsi üçün bir az ara verin, sonra sakit yazın.`,
      B: `Cavabı dərhal, hiss etdiyiniz kimi yazıb göndərin.`,
      C: `Cavabınızın tonu sərt çıxsa da, bunu fərq etmədən göndərin.`,
      D: `Cavabı yazın, lakin göndərmədən əvvəl başqa işə keçin.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Əsəbin zirvəsi keçənə qədər bir az ara verib sonra sakit yazmaq ən güclü davranışdır (A). Cavabı yazıb göndərmədən başqa işə keçmək də zirvəni yumşaldır (D). Dərhal hiss etdiyiniz kimi göndərmək peşmançılığa apara bilər (B). Cavabın tonunun sərt çıxması isə münasibəti pozur, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'ez-m2-q11', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Şahmat klubunda bir uğursuzluqdan sonra hisslərinizi anlayıb irəliləmək istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Uğursuzluqdan çıxarılacaq dərsi müəyyən edin.`,
      B: `Növbəti konkret addımı planlaşdırın.`,
      C: `Hissi danıb heç nə olmamış kimi davam edin.`,
      D: `Hissi tanıyıb adlandırın.`,
    },
    correct: ['D', 'A', 'B', 'C'],
    explanation: `Uğursuzluğu emal etmək hissi tanıyıb adlandırmaqla başlayır (D), sonra çıxarılacaq dərsi müəyyən etmək (A) və növbəti konkret addımı planlaşdırmaq (B). Hissi danıb heç nə olmamış kimi davam etmək isə nə emal, nə öyrənmə verir, ən zəifdir (C).`,
  },
  {
    id: 'ez-m2-q12', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Foto-laboratoriyada bir həmkar özünün həll edə biləcəyi məsələləri davamlı sizə həvalə etməyə çalışır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hər dəfə işi onun əvəzinə özünüz görüb məsələni bağlayın.`,
      B: `Lazımi suallarla onu öz həllinə yönəldib bacardığına inamını gücləndirin.`,
      C: `"Bu sənin işindir" deyib heç bir dəstək vermədən uzaqlaşın.`,
      D: `Bundan sonra onun heç bir sualına cavab verməyin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Davamlı işi ötürən həmkarla ən təsirli davranış lazımi suallarla onu öz həllinə yönəldib özünə inamını gücləndirməkdir (B). "Sənin işindir" deyib heç dəstək verməmək kobud qarşılıqdır (C). Sualına heç cavab verməmək münasibəti pozur (D). Hər dəfə işi onun əvəzinə görmək isə asılılığı möhkəmləndirir və yükünüzü artırır, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m2-q13', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Gənclər mərkəzində bir gənc ruhdan düşüb və bacarmayacağını düşünür. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Sadəcə "hər şey yaxşı olacaq" deyib keçin.`,
      B: `Çətinliyi qəbul edin və onun güclü tərəflərini xatırladın.`,
      C: `Hissini eşidin, sonra real, kiçik bir irəliləyiş addımı göstərin.`,
      D: `"Hamı bacarır, sən niyə bacarmırsan" deyin.`,
    },
    correct: { A: 2, B: 3, C: 4, D: 1 },
    explanation: `Ruhdan düşmüş gəncə ən doğru reaksiya hissini eşitmək, sonra real, kiçik bir irəliləyiş addımı göstərməkdir (C, 4). Çətinliyi qəbul edib güclü tərəflərini xatırlatmaq da dəstəkləyir (B, 3). "Hər şey yaxşı olacaq" deyib keçmək boş təsəllidir (A, 2). "Hamı bacarır, sən niyə bacarmırsan" demək isə onu daha da ruhdan salır, ən zəif seçimdir (D, 1).`,
  },
  {
    id: 'ez-m2-q14', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Onlayn təhsil dəstəyində bir komanda üzvünün şəxsi problemi işinin keyfiyyətinə təsir edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız vəziyyətinə baxıb keyfiyyət düşüşünü heç qeyd etməyin.`,
      B: `Mövzunu ümumiyyətlə açmayıb problemin öz-özünə böyüməsinə imkan verin.`,
      C: `Vəziyyəti anlayışla qarşılayın, eyni zamanda işin standartını qorumaq üçün birlikdə plan qurun.`,
      D: `Yalnız standarta baxıb şəxsi vəziyyətini tam bir kənara qoyun.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Şəxsi problem işə təsir edəndə ən uyğun davranış anlayışı standartla birləşdirmək, birlikdə plan qurmaqdır (C). Yalnız standarta baxıb vəziyyətini unutmaq insani tərəfi itirir (D). Yalnız vəziyyətə baxıb keyfiyyət düşüşünü qeyd etməmək problemi böyüdür (A). Mövzunu açmayıb problemin öz-özünə böyüməsinə imkan vermək isə hər ikisinə zərər verir, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'ez-m2-q15', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sənaye dizaynı bürosunda təbii olaraq xoşlamadığınız bir müştəriyə empatiya göstərməlisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Şəxsi münasibətinizi bir anlıq kənara qoyub onun vəziyyətini dinləyin.`,
      B: `Vəziyyətinə uyğun, hörmətli dəstək göstərin.`,
      C: `Onun nöqteyi-nəzərini və hissini anlamağa çalışın.`,
      D: `Xoşlamadığınız üçün ünsiyyəti minimuma endirib yalnız formal davranın.`,
    },
    correct: ['A', 'C', 'B', 'D'],
    explanation: `Xoşlamadığınız birinə empatiya şəxsi münasibəti bir anlıq kənara qoyub onun vəziyyətini dinləməklə başlayır (A), sonra nöqteyi-nəzərini və hissini anlamaq (C) və hörmətli dəstək göstərmək (B). Xoşlamadığınız üçün ünsiyyəti minimuma endirmək isə peşəkarlığa ziddir, ən zəifdir (D).`,
  },
  {
    id: 'ez-m2-q16', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Rəsm kursunda yaxın bir həmkar davamlı olaraq ağır şəxsi mövzuları sizinlə bölüşür və bu, sizi çox yorur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Mövzu açılan kimi başqa işiniz olduğunu deyib söhbəti tez bitirin.`,
      B: `Onunla ünsiyyəti tamamilə kəsin.`,
      C: `Onu qıramamaq üçün hər dəfə saatlarla dinləyib özünüzü tükədin.`,
      D: `Mehribanlıqla yanında olun, lakin nə qədər dinləyə biləcəyinizə dair yumşaq bir hədd qoyun.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Davamlı ağır mövzularda ən güclü davranış mehribanlıqla yanında olmaq, lakin imkanınıza dair yumşaq hədd qoymaqdır (D). Onu qıramamaq üçün hər dəfə özünüzü tükətmək davamlı deyil (C). Ünsiyyəti bütövlükdə kəsmək münasibəti itirir (B). Mövzu açılan kimi başqa işiniz olduğunu deyib tez bitirmək isə yaxın həmkarı kənarda qoyur, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m2-q17', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/happiness.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Bir üzdə dodaq küncləri yuxarı qalxıb (zygomaticus major), eyni zamanda gözün ətrafındakı əzələ (orbicularis oculi) büzüşüb və göz kənarlarında qırışlar yaranıb. Bu, hansı təbəssümə daha çox uyğundur?`,
    options: {
      A: `Yalnız nəzakətdən doğan təbəssüm`,
      B: `Duchenne (səmimi) təbəssüm`,
      C: `Sosial (formal) təbəssüm`,
      D: `Gizlədilmiş narahatlıq`,
    },
    correct: 'B',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `Duchenne (səmimi) təbəssümü nəzakətli təbəssümdən fərqləndirən əsas əlamət gözün ətrafındakı orbicularis oculi əzələsidir. Bu əzələ iradədən asılı olmayaraq işə düşür və göz kənarlarında qırışlar yaradır. Burada həm zygomaticus, həm orbicularis oculi aktivdir, deməli B səmimi təbəssümdür. A və C yalnız dodaq əzələsini istifadə edir, D isə tam başqa, gərginlik əlamətidir. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-m2-q18', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Audiokitab studiyasında bir nəfər söhbət zamanı dəfələrlə sözünüzü kəsir və qıcıqlanırsınız. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Sakit qalıb fikrinizi bitirmək üçün nəzakətlə, lakin aydın şəkildə söz istəyin.`,
      B: `Eyni ilə onun da sözünü kəsib səsinizi qaldırın.`,
      C: `Qıcığı içinizdə saxlayıb tamamilə susun və geri çəkilin.`,
      D: `Onu kobudluqda ittiham edib söhbəti dayandırın.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Sözünüz dəfələrlə kəsiləndə ən təsirli davranış sakit qalıb nəzakətlə, lakin aydın söz istəməkdir (A). Qıcığı içinizdə saxlayıb bütövlükdə susmaq fikrinizi itirir (C). Eyni ilə onun sözünü kəsib səs qaldırmaq gərginliyi artırır (B). Onu kobudluqda ittiham edib söhbəti dayandırmaq isə münaqişəyə çevirir, ən zəif seçimdir (D).`,
  },
  {
    id: 'ez-m2-q19', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Velosiped icarəsi məntəqəsində bir müştəri tərəddüd edir, lakin bunu açıq demir. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Üz ifadəsini nəzərə alın, lakin yoxlamayın.`,
      B: `Tək bir əlamətdən onun fikrini dəqiq bildiyinizi düşünün.`,
      C: `Yalnız sözlərinə əsaslanıb tərəddüdü qaçırın.`,
      D: `Söz, səs və üz ifadəsini birlikdə oxuyub mehribanca dəqiqləşdirin.`,
    },
    correct: { A: 3, B: 1, C: 2, D: 4 },
    explanation: `Tərəddüd edən müştəridə ən doğru yanaşma söz, səs və üz ifadəsini birlikdə oxuyub mehribanca dəqiqləşdirməkdir (D, 4). Üz ifadəsini nəzərə alıb yoxlamamaq bir qədər faydalıdır (A, 3). Yalnız sözlərə əsaslanıb tərəddüdü qaçırmaq əsl halı görmür (C, 2). Tək bir əlamətdən fikrini dəqiq bildiyinizi düşünmək isə səhv oxumağa aparır, ən az faydalı seçimdir (B, 1).`,
  },
  {
    id: 'ez-m2-q20', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Hostel resepsiyasında sakit, diqqətli əhvaldasınız. Qarşınızda həm detallı sənəd yoxlaması, həm enerjili qonaq qarşılaması var. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Əhvalınız dəyişənə qədər heç bir işə başlamayın.`,
      B: `Sakit, diqqətli əhvalınıza uyğun gələn detallı yoxlamanı indi görün, qarşılamanı enerjiniz artanda.`,
      C: `Əhvalınızı nəzərə almadan işləri gəldiyi kimi görün.`,
      D: `Sakit halınızda enerjili qarşılamanı zorla edin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Hazırkı əhvala uyğun işi seçmək məhsuldarlığı artırır: sakit, diqqətli halda detallı yoxlamanı görmək ən effektivdir (B). İşləri gəldiyi kimi görmək uyğunluğu itirir (C). Əhval dəyişənə qədər heç nə etməmək vaxt itirir (A). Sakit halda enerjili qarşılamanı zorla etmək isə həm işi, həm halınızı pisləşdirir, ən zəifdir (D).`,
  },
  {
    id: 'ez-m2-q21', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Toy salonunda vacib bir tədbirdən əvvəl narahatlıq hiss edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Narahatlığı tam danıb heç nə hiss etmədiyinizi deyin.`,
      B: `Həmin sahəni hazırlayıb narahatlığı faydalı işə çevirin.`,
      C: `Onun nəyə işarə etdiyini, nəyin hazırlanmasını istədiyini anlayın.`,
      D: `Narahatlığı bir siqnal kimi qəbul edin.`,
    },
    correct: ['D', 'C', 'B', 'A'],
    explanation: `Narahatlığı məhsuldar istifadə etmək onu bir siqnal kimi qəbul etməklə başlayır (D), sonra nəyə işarə etdiyini anlamaq (C) və həmin sahəni hazırlayıb narahatlığı faydalı işə çevirmək (B). Narahatlığı tamamilə danmaq isə dəyərli siqnalı itirir, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m2-q22', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Reklam çap evində xoşlamadığınız bir layihə ləğv olunur; həm yüngülləşmə, həm bir az günah hissi keçirirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yalnız günah hissinə qapılıb yüngülləşməni qaçırın.`,
      B: `İki hiss qarışdığı üçün hisslərinizi bütövlükdə bir kənara qoyun.`,
      C: `Hər iki hissin eyni anda mövcud ola biləcəyini qəbul edib hər ikisini nəzərə alın.`,
      D: `Yalnız yüngülləşməyə fokuslanıb günah hissini inkar edin.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Yüngülləşmə və günah eyni anda yaşananda ən uyğun davranış hər ikisini qəbul edib nəzərə almaqdır (C). Yalnız yüngülləşməyə (D) və ya yalnız günaha (A) baxmaq mənzərənin yarısını qaçırır. İki hissin qarışığından qaçıb hissləri tam bir kənara qoymaq isə dəyərli məlumatı itirir, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m2-q23', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Diş laboratoriyasında gərgin bir anda öz emosiyanızı idarə edirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Bir an dayanıb sakitləşin, sonra cavab verin.`,
      B: `Vəziyyəti yenidən, daha sakit çərçivədə görüb ölçülü cavab verin.`,
      C: `Düşünməyə ara vermədən tez cavab verin.`,
      D: `Hissi tamamilə susdurub heç nə hiss etmədiyinizi deyin.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `Gərgin anda ən güclü yanaşma bir an dayanıb sakitləşmək, sonra cavab verməkdir (A, 4). Vəziyyəti daha sakit çərçivədə görüb ölçülü cavab vermək də güclüdür (B, 3). Hissi bütövlükdə susdurmaq onu gizlədir (D, 2). Düşünməyə ara vermədən tez cavab vermək isə vəziyyəti pisləşdirir, ən az faydalı seçimdir (C, 1).`,
  },
  {
    id: 'ez-m2-q24', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kostyum prokatında nadir bir kostyuma iki nəfər iddialıdır: birinin sabah çıxışı var, digəri sadəcə çox istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Kostyumu daha çox xahiş edənə verin.`,
      B: `Seçimi heç bir əsas olmadan atın.`,
      C: `Qərarı qeyri-müəyyən müddətə təxirə salın.`,
      D: `Hər ikisinin vəziyyətini empatiya ilə anlayın və ehtiyacın təcilliyinə görə şəffaf qərar verin.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Eyni resursa iki iddiada ən təsirli davranış hər ikisini empatiya ilə anlamaq və ehtiyacın təcilliyinə görə şəffaf qərar verməkdir (D). Seçimi heç bir əsas olmadan atmaq ədalətsizdir (B). Qərarı təxirə salmaq imkanı itirir (C). Kostyumu sadəcə daha çox xahiş edənə vermək isə real ehtiyacı gözardı edir, ən zəifdir (A).`,
  },
  {
    id: 'ez-m2-q25', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Heyvan məşqi mərkəzində həm hisslərin, həm faktların rol oynadığı bir qərar verirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Emosional anlayışı faktlarla birləşdirib qərar verin.`,
      B: `Vəziyyətin emosional tərəfini oxuyun.`,
      C: `Yalnız anlıq emosiyaya əsaslanıb qərar verin.`,
      D: `Faktları və nəticələri də nəzərə alın.`,
    },
    correct: ['B', 'D', 'A', 'C'],
    explanation: `Həm hiss, həm fakt olan qərarda ən doğru ardıcıllıq emosional tərəfi oxumaq (B), faktları və nəticələri nəzərə almaq (D) və ikisini birləşdirib qərar verməkdir (A). Yalnız anlıq emosiyaya əsaslanıb qərar vermək isə faktları gözardı edir, ən az təsirlidir (C).`,
  },
  {
    id: 'ez-m2-q26', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Subtitr studiyasında bir həmkar sakit görünür, lakin siz özünüz narahat olduğunuz üçün onun da sizdən narahat olduğunu düşünürsünüz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Öz narahatlığınızı onun halından ayırıb, doğrudan da bir problem olub-olmadığını incə şəkildə soruşun.`,
      B: `Öz narahatlığınızı ona aid edib məsafə saxlamağa başlayın.`,
      C: `Hər ikinizin narahat olduğunu güman edib mövzunu açmayın.`,
      D: `Öz narahatlığınızı danıb yalnız onun halı ilə məşğul olun.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Ən güclü davranış öz narahatlığınızı onun halından ayırıb doğrudan da bir problem olub-olmadığını incə soruşmaqdır (A). Hər ikinizin narahat olduğunu güman edib mövzunu açmamaq yanlış fərziyyəyə əsaslanır (C). Öz narahatlığınızı danmaq özünüzü gözardı edir (D). Öz narahatlığınızı ona aid edib məsafə saxlamaq isə öz hissinizi başqasına proyeksiya etməkdir, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m2-q27', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Uşaq idman klubunda həm hisslərin, həm faktların rol oynadığı həssas bir qərar verirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Vəziyyətin emosional tərəfini oxuyub nəzərə alın.`,
      B: `Emosional anlayışı faktlar və ədalətlə birləşdirib qərar verin.`,
      C: `Yalnız anlıq emosiyaya əsaslanın.`,
      D: `Yalnız faktlara baxıb insani tərəfi unudun.`,
    },
    correct: { A: 3, B: 4, C: 1, D: 2 },
    explanation: `Həssas qərarda ən uyğun yanaşma emosional anlayışı faktlar və ədalətlə birləşdirib qərar verməkdir (B, 4). Emosional tərəfi oxuyub nəzərə almaq da vacibdir, lakin tək başına natamamdır (A, 3). Yalnız faktlara baxıb insani tərəfi unutmaq tarazlığı pozur (D, 2). Yalnız anlıq emosiyaya əsaslanmaq isə obyektivliyi itirir, ən az faydalı seçimdir (C, 1).`,
  },
  {
    id: 'ez-m2-q28', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kosmetika mağazasında rəhbəriniz mesajlarınıza qısa, quru cavablar verir və bunu rədd kimi oxuyursunuz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Quru cavabı şəxsi rədd kimi qəbul edib özünüzü pis hiss edin.`,
      B: `Qısa cavabın çoxlu səbəbi ola biləcəyini bilib işə normal davam edin, lazım olsa dəqiqləşdirin.`,
      C: `Hər ehtimala qarşı rəhbərlə ünsiyyəti azaldın.`,
      D: `Nəsə səhv etdiyinizi düşünüb dərhal uzun-uzadı üzr istəyin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Rəhbərin quru cavabında ən güclü davranış onun çoxlu səbəbi ola biləcəyini bilib normal davam etmək, lazım olsa dəqiqləşdirməkdir (B). Hər ehtimala qarşı ünsiyyəti azaltmaq məsafə yaradır (C). Səhv etdiyinizi düşünüb dərhal uzun üzr istəmək yoxlanmamış fərziyyəyə əsaslanır (D). Quru cavabı şəxsi rədd kimi qəbul edib özünüzü pis hiss etmək isə neytral siqnalı əsassız mənfi oxumaqdır, ən zəifdir (A).`,
  },
  {
    id: 'ez-m2-q29', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Balıq bazarında gözlənilməz bir xəbərdən sonra bir-birinə zidd hisslər keçirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hər birinin nəyi tətiklədiyini anlayın.`,
      B: `Hissləri bir kənara yığıb yalnız işə davam edin.`,
      C: `Hər bir hissi ayrıca adlandırın.`,
      D: `Hər ikisini nəzərə alıb ölçülü davranın.`,
    },
    correct: ['C', 'A', 'D', 'B'],
    explanation: `Zidd hissləri emal etmək hər birini ayrıca adlandırmaqla başlayır (C), sonra hər birinin nəyi tətiklədiyini anlamaq (A) və hər ikisini nəzərə alıb ölçülü davranmaq (D). Hissləri bir kənara yığıb yalnız işə davam etmək isə onları işlənməmiş qoyur, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m2-q30', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Şəhər nəqliyyat məlumat masasında gözlənilməz bir hadisə sizi çaşdırır və diqqətinizi itirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Çaşqınlığı boğub heç nə olmamış kimi sürətlə davam edin.`,
      B: `Bir an dayanıb nəfəs alın.`,
      C: `Diqqətinizi yenidən cari işə yönəldin.`,
      D: `Sakit və ölçülü şəkildə davam edin.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `Çaşıb diqqəti itirəndə ən təsirli ardıcıllıq bir an dayanıb nəfəs almaq (B), diqqəti yenidən cari işə yönəltmək (C) və sakit, ölçülü davam etməkdir (D). Çaşqınlığı boğub sürətlə davam etmək isə səhvə apara bilər, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m2-q31', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Diş laboratoriyasında bir həmkar hirslə uzun-uzadı şikayətlənir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hələ hirsliykən dərhal məntiqli izah və həll təklif edin.`,
      B: `Hissinə toxunmadan yalnız qaydadan danışın.`,
      C: `Əvvəlcə hissini eşitdiyinizi bildirib qəbul edin, sonra birlikdə həllə keçin.`,
      D: `Hirsinə görə onunla soyuq və qısa davranın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Hirsli həmkarla ən doğru davranış əvvəlcə hissini eşitdiyinizi bildirib qəbul etmək, sonra birlikdə həllə keçməkdir (C). Yalnız qaydadan danışıb hissinə toxunmamaq onu eşidilməmiş qoyur (B). Soyuq və qısa davranmaq gərginliyi artırır (D). Hələ hirsliykən dərhal məntiqli izah və həll təklif etmək isə bu anda qəbul edilmir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m2-q32', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Sənaye dizaynı bürosunda işə yeni başlamış, narahat görünən bir nəfəri rahatlatmağa çalışırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Konkret, kiçik bir kömək və ya istiqamət təklif edin.`,
      B: `Onu eşitdiyinizi və burada dəstək olacağınızı bildirin.`,
      C: `Narahatlığını əhəmiyyətsiz sayıb "öyrəşərsən" deyib keçin.`,
      D: `Narahatlığını fərq edib mehribanca qeyd edin.`,
    },
    correct: ['D', 'B', 'A', 'C'],
    explanation: `Narahat yeni nəfəri rahatlatmaq onun narahatlığını fərq edib mehribanca qeyd etməklə başlayır (D), sonra onu eşitdiyinizi və dəstək olacağınızı bildirmək (B) və konkret, kiçik kömək təklif etmək (A). Narahatlığını əhəmiyyətsiz sayıb keçmək isə onu tək qoyur, ən zəifdir (C).`,
  },
  {
    id: 'ez-m2-q33', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Gənclər mərkəzində bir həmkar yaxınını itirib və kədərini bölüşür. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Mövzunu dəyişib onu güldürməyə çalışın.`,
      B: `Sakitcə dinləyin və hissini qəbul etdiyinizi bildirin.`,
      C: `Kədərini eşidin, yanında olun və nə lazımdırsa təklif edin.`,
      D: `Dərhal "həyat davam edir" deyib keçin.`,
    },
    correct: { A: 2, B: 3, C: 4, D: 1 },
    explanation: `Kədərini bölüşən həmkara ən uyğun reaksiya onu eşitmək, yanında olmaq və lazım olanı təklif etməkdir (C, 4). Sakitcə dinləyib hissini qəbul etmək də güclüdür (B, 3). Mövzunu dəyişib güldürməyə çalışmaq hissi yan keçir (A, 2). "Həyat davam edir" deyib keçmək isə kədərini kiçildir, ən az təsirlidir (D, 1).`,
  },
  {
    id: 'ez-m2-q34', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Fizioterapiya klinikasında bir qərar verməlisiniz, lakin bu gün əsəbi olduğunuzu və bunun mühakimənizə təsir edə biləcəyini hiss edirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Əsəbiliyin qərara təsir etmədiyini düşünüb dərhal qərar verin.`,
      B: `Qərarı tam başqasına ötürün.`,
      C: `Əsəbiniz keçənə qədər bütün qərarlardan qaçın.`,
      D: `Əhvalınızın təsirini tanıyın, mümkünsə qərarı bir az təxirə salın və ya faktlara ikiqat diqqət yetirin.`,
    },
    correct: 'D',
    explanation: `Ən güclü davranış əhvalınızın mühakiməyə təsirini tanıyıb, mümkünsə qərarı bir az təxirə salmaq və ya faktlara ikiqat diqqət yetirməkdir (D). Əsəbiliyin təsir etmədiyini düşünüb dərhal qərar vermək qərəzi gözardı edir (A). Qərarı tamamilə başqasına ötürmək məsuliyyətdən qaçmaqdır (B). Əsəb keçənə qədər bütün qərarlardan qaçmaq isə həddən artıqdır (C).`,
  },
  {
    id: 'ez-m2-q35', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/sadness.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Bir üzdə qaşların daxili (orta) küncləri yuxarı qalxıb, alının ortasında kiçik qırışlar var, dodaq küncləri aşağı enib. Bu ifadə hansı emosiyaya daha çox uyğundur?`,
    options: {
      A: `Sevinc`,
      B: `Qəzəb`,
      C: `Kədər`,
      D: `Təəccüb`,
    },
    correct: 'C',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `Qaşların daxili künclərinin yuxarı qalxması, alın ortasındakı qırışlar və dodaq künclərinin enməsi kədərin əlamətidir; bu üzdə hər üçü var, deməli C (kədər) doğru cavabdır. Sevincdə təbəssüm və yanaq qalxması olur (A). Qəzəbdə qaşlar enib gərilir (B). Təəccübdə qaşlar yuxarı qalxır və ağız açılır (D). Bu siqnallar kədər üçün xarakterik deyil. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-m2-q36', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Hostel resepsiyasında bir qonaq həmişəkindən artıq şən görünür, lakin bu, bir az süni təsir bağışlayır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Şənliyini olduğu kimi qəbul edib heç düşünməyin.`,
      B: `Onu süni davranmaqda ittiham edin.`,
      C: `Şənliyini soyuqca qarşılayıb ünsiyyəti qısaldın.`,
      D: `Şənliyin altında nəsə ola biləcəyini görüb mehribanca, təzyiqsiz hal-əhval tutun.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Süni görünən şənlikdə ən güclü davranış altında nəsə ola biləcəyini görüb mehribanca hal-əhval tutmaqdır (D). Şənliyini olduğu kimi qəbul edib heç düşünməmək altdakı hissi qaçırır (A). Soyuqca qarşılayıb ünsiyyəti qısaltmaq lazımsız məsafə yaradır (C). Onu süni davranmaqda ittiham etmək isə münasibəti pozur, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m2-q37', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Süni daş sexində başqalarının yanında bir səhv etdiniz və özünüzü itirmiş hiss edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Bir an dayanıb sakitləşin.`,
      B: `İşə toplanıb davam edin.`,
      C: `Özünüzü toplamağa vaxt ayırmadan tələsik üzr deyib mövzunu dəyişin.`,
      D: `Səhvi sakit şəkildə qəbul edib düzəliş addımını deyin.`,
    },
    correct: ['A', 'D', 'B', 'C'],
    explanation: `İctimai səhvdən sonra özünüzü toplamaq bir an dayanıb sakitləşməklə başlayır (A), sonra səhvi sakit qəbul edib düzəliş addımını demək (D) və işə toplanıb davam etmək (B). Özünüzü toplamadan tələsik üzr deyib mövzunu dəyişmək isə vəziyyəti tam həll etmir, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'ez-m2-q38', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Sürücülük mərkəzində çox həyəcanlandıran bir imkan yaranır və dərhal "hə" demək istəyirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Həyəcanı bölüşün, lakin detalları soruşandan sonra qərar verin.`,
      B: `Həyəcanı bütövlükdə boğub maraqsız görünün.`,
      C: `Həyəcanın təsiri ilə detalları soruşmadan razılıq verin.`,
      D: `Həyəcanı tanıyın, lakin qərar verməzdən əvvəl bir az aydın düşünməyə vaxt ayırın.`,
    },
    correct: { A: 3, B: 2, C: 1, D: 4 },
    explanation: `Müsbət həyəcanı da idarə etmək lazımdır: ən təsirli yanaşma həyəcanı tanımaq, lakin qərardan əvvəl bir az aydın düşünməyə vaxt ayırmaqdır (D, 4). Həyəcanı bölüşüb detalları soruşandan sonra qərar vermək də yaxşıdır (A, 3). Həyəcanı tam boğub maraqsız görünmək hissi gizlədir (B, 2). Həyəcanla dərhal, düşünmədən razılıq vermək isə düşünülməmiş öhdəliyə apara bilər, ən zəifdir (C, 1).`,
  },
  {
    id: 'ez-m2-q39', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `İdman akademiyasında gözlənilməz bir problem bütün komandanı həyəcanlandırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Əvvəlcə öz sakitliyinizi qoruyun, sonra aydın, sakit tonla komandanı toxtadın.`,
      B: `Komandanın həyəcanına qoşulub birlikdə təşvişə düşün.`,
      C: `Komandadan tez toplanmağı tələb edib həyəcanı önəmsəməyin.`,
      D: `Heç nə deməyib hərənin öz başının çarəsinə baxmasına buraxın.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Komanda həyəcanlananda ən doğru davranış əvvəlcə öz sakitliyinizi qorumaq, sonra aydın, sakit tonla komandanı toxtatmaqdır (A). Heç nə deməyib hərəni tək buraxmaq idarəsizliyə yol verir (D). Həyəcana qoşulub təşvişə düşmək vəziyyəti pisləşdirir (B). Komandadan tez toplanmağı tələb edib həyəcanı önəmsəməmək isə hissləri arxa plana atıb etimadı zəiflədir, ən az təsirlidir (C).`,
  },
  {
    id: 'ez-m2-q40', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kinoteatr foyesində günün sonunda özünüzü pis hiss edirsiniz, lakin səbəbini dəqiq bilmirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hissi araşdırmadan ilk ağla gələn səbəbə bağlayın.`,
      B: `Hissi mümkün qədər dəqiq adlandırın.`,
      C: `Hissin nə vaxt və hansı hadisədən sonra başladığını izləyin.`,
      D: `Hissin nəyə işarə etdiyini anlayıb buna görə sağlam addım atın.`,
    },
    correct: ['C', 'B', 'D', 'A'],
    explanation: `Səbəbi bilinməyən pis halı anlamaq onun nə vaxt və hansı hadisədən sonra başladığını izləməklə başlayır (C), sonra hissi dəqiq adlandırmaq (B) və nəyə işarə etdiyini anlayıb sağlam addım atmaq (D). Hissi araşdırmadan ilk ağla gələn səbəbə bağlamaq isə yanlış nəticəyə apara bilər, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m2-q41', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Suvenir mağazasında bir komanda üzvü adətən fəal ikən bu gün qapalı və sakitdir. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Adi davranışındakı dəyişikliyi fərq edib təklikdə mehribanca hal-əhval tutun.`,
      B: `Heç nə fərq etməmiş kimi davam edin.`,
      C: `Dəyişikliyi fərq edin, lakin heç nə soruşmayın.`,
      D: `Sakitliyini "işdən qaçmaq" kimi şərh edib iradınızı bildirin.`,
    },
    correct: { A: 4, B: 2, C: 3, D: 1 },
    explanation: `Adətən fəal üzvün qapanmasında ən uyğun yanaşma dəyişikliyi fərq edib təklikdə mehribanca hal-əhval tutmaqdır (A, 4). Dəyişikliyi fərq edib heç nə soruşmamaq qismən diqqətlidir (C, 3). Heç nə fərq etməmiş kimi davam etmək siqnalı qaçırır (B, 2). Sakitliyini "işdən qaçmaq" kimi şərh edib irad bildirmək isə yanlış və haqsız nəticədir, ən az faydalı seçimdir (D, 1).`,
  },
  {
    id: 'ez-m2-q42', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Audiokitab studiyasında vacib bir iş görərkən gözlənilməz bir xəbər sizi pisləşdirir, lakin işi davam etdirməlisiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `İşi dayandırıb xəbəri uzun-uzadı götür-qoy etməyə başlayın.`,
      B: `Bir an dayanıb nəfəs alın, diqqətinizi yenidən cari işə yönəldib davam edin.`,
      C: `Pisləşdiyinizi bilsəniz də, heç nə etmədən eyni templə davam edin.`,
      D: `İşi yarıda saxlayıb əhvalınız düzələnə qədər başqa işlərə keçin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Pisləşdirən xəbərdən sonra işi davam etdirmək üçün ən güclü yol bir an dayanıb nəfəs almaq, diqqəti yenidən cari işə yönəltməkdir (B). İşi dayandırıb xəbəri uzun götür-qoy etmək diqqəti itirir (A). Heç nə etmədən eyni templə davam etmək pisləşmiş halı idarəsiz qoyur (C). İşi yarıda saxlayıb sonraya keçirmək isə vaxtında bitməli işə birbaşa zərər vurur, ən zəifdir (D).`,
  },
  {
    id: 'ez-m2-q43', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Velosiped icarəsində bir müştərinin nə hiss etdiyini düşündüyünüzü yoxlamaq istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Təxmininizi mehribanca, sual şəklində ona çatdırın.`,
      B: `Müşahidələrə əsasən ehtiyatlı bir təxmin qurun.`,
      C: `Onun cavabına görə anlayışınızı düzəldin.`,
      D: `İlk təxmininizi doğru sayıb ona görə davranın.`,
    },
    correct: ['B', 'A', 'C', 'D'],
    explanation: `Emosiya oxumağı dəqiqləşdirmək müşahidələrə əsasən ehtiyatlı təxmin qurmaqla başlayır (B), sonra təxmini mehribanca, sual şəklində çatdırmaq (A) və onun cavabına görə anlayışınızı düzəltmək (C). İlk təxmini doğru sayıb ona görə davranmaq isə səhv oxumağa apara bilər, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m2-q44', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Vətəndaş qəbulunda gərgin bir anda güclü qəzəb hiss edirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Qəzəbi tamamilə danıb heç nə hiss etmədiyinizi deyin.`,
      B: `Qəzəbin zirvəsi keçənə qədər bir an ara verin, sonra sakit cavab verin.`,
      C: `Qəzəbi saxlamağa çalışmadan cavabınızda büruzə verin.`,
      D: `Vəziyyəti daha sakit çərçivədə görüb ölçülü cavab verin.`,
    },
    correct: { A: 2, B: 4, C: 1, D: 3 },
    explanation: `Güclü qəzəbdə ən təsirli yanaşma zirvə keçənə qədər bir an ara verib sonra sakit cavab verməkdir (B, 4). Vəziyyəti daha sakit çərçivədə görüb ölçülü cavab vermək də güclüdür (D, 3). Qəzəbi bütövlükdə danmaq onu gizlədir (A, 2). Qəzəbi saxlamadan cavabda büruzə vermək isə vəziyyəti pisləşdirir, ən zəif seçimdir (C, 1).`,
  },
  {
    id: 'ez-m2-q45', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Foto-laboratoriyada bir həmkar sizdən məsləhət istəyir, lakin əslində sadəcə dinlənilmək istədiyi hiss olunur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız dinləyin, lakin sonradan istəsə də heç vaxt məsləhət verməyin.`,
      B: `İstədiyi kimi dərhal uzun məsləhət verin.`,
      C: `Əvvəlcə diqqətlə dinləyin, sonra məsləhət istəyib-istəmədiyini incə şəkildə yoxlayın.`,
      D: `Nə dinləyin, nə məsləhət verin, mövzunu dəyişin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Sözdəki istəklə əsl ehtiyac fərqli ola bilər: ən doğru davranış əvvəlcə dinləmək, sonra məsləhət istəyib-istəmədiyini incə yoxlamaqdır (C). Dərhal uzun məsləhət vermək əsl ehtiyacı qaçıra bilər (B). Yalnız dinləyib heç məsləhət verməmək çevik deyil (A). Nə dinləmək, nə məsləhət vermək, mövzunu dəyişmək isə onu tam eşitməməkdir, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m2-q46', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Aptekdə işə marağınızın və diqqətinizin düşdüyünü, darıxdığınızı fərq edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İşinizə maraq qatacaq kiçik bir dəyişiklik edin.`,
      B: `Bu halı əhəmiyyətsiz sayıb eyni cür davam edin.`,
      C: `Onun nəyə işarə etdiyini, nəyin dəyişməsi lazım olduğunu anlayın.`,
      D: `Darıxma və maraq düşüşünü bir siqnal kimi qəbul edin.`,
    },
    correct: ['D', 'C', 'A', 'B'],
    explanation: `Darıxma və maraq düşüşünü idarə etmək onu bir siqnal kimi qəbul etməklə başlayır (D), sonra nəyə işarə etdiyini anlamaq (C) və işə maraq qatacaq kiçik dəyişiklik etmək (A). Bu halı əhəmiyyətsiz sayıb eyni cür davam etmək isə problemi davam etdirir, ən zəifdir (B).`,
  },
  {
    id: 'ez-m2-q47', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Veb-dizayn studiyasında bir həmkar narahatlığını bölüşür və əvvəlcə sadəcə anlaşılmaq istəyir. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `"Narahat olma, keçər" deyib mövzunu yüngülləşdirin.`,
      B: `Hissini qəbul edin, sonra kömək istəyib-istəmədiyini soruşun.`,
      C: `Əvvəlcə dinləyin, hissini təsdiqləyin, sonra birlikdə həll axtarın.`,
      D: `Dərhal həll yollarına keçin.`,
    },
    correct: { A: 1, B: 3, C: 4, D: 2 },
    explanation: `Narahatlığını bölüşən həmkara ən uyğun reaksiya əvvəlcə dinləmək, hissini təsdiqləmək, sonra birlikdə həll axtarmaqdır (C, 4). Hissini qəbul edib kömək istəyib-istəmədiyini soruşmaq da güclüdür (B, 3). Dərhal həll yollarına keçmək hissi yan keçir (D, 2). "Keçər" deyib mövzunu yüngülləşdirmək isə hissini kiçildir, ən az təsirlidir (A, 1).`,
  },
  {
    id: 'ez-m2-q48', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Rəsm kursunda tükənmiş hiss edirsiniz və bir həmkar sizdən növbəti uzun emosional söhbət üçün vaxt istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Xahişi səbəb göstərmədən qısaca rədd edib mövzunu bağlayın.`,
      B: `Cavabı qeyri-müəyyən saxlayıb onu gözləmədə qoyun.`,
      C: `Tükənmiş olsanız da, "yox" deyə bilməyib razılıq verin, sonra özünüzü daha pis hiss edin.`,
      D: `Mehribanlıqla indi tam yardımçı ola bilməyəcəyinizi deyin və uyğun başqa vaxt təklif edin.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Tükənmiş olduğunuz halda ən güclü davranış mehribanlıqla indi tam yardımçı ola bilməyəcəyinizi deyib uyğun başqa vaxt təklif etməkdir (D). Cavabı qeyri-müəyyən saxlayıb gözlətmək çaşqınlıq yaradır (B). "Yox" deyə bilməyib razılıq verib özünüzü daha pis hiss etmək həm sizə, həm söhbətə zərər verir (C). Xahişi səbəb göstərmədən qısaca rədd edib mövzunu bağlamaq isə münasibəti pisləşdirir, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m2-q49', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Abituriyent mərkəzində bir namizəd hirslə şikayətlənir, şikayətinin bir hissəsi haqlı, bir hissəsi haqsızdır. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Sakit dinləyib hissini qəbul edin.`,
      B: `Hirsinə görə bütün şikayəti haqsız sayıb rədd edin.`,
      C: `Şikayətin hansı hissəsinin haqlı olduğunu ayırın.`,
      D: `Haqlı hissəni həll edin, haqsız hissəni hörmətlə izah edin.`,
    },
    correct: ['A', 'C', 'D', 'B'],
    explanation: `Qismən haqlı şikayətdə ən təsirli ardıcıllıq sakit dinləyib hissini qəbul etmək (A), haqlı hissəni ayırmaq (C) və haqlı hissəni həll edib haqsızı hörmətlə izah etməkdir (D). Hirsinə görə bütün şikayəti haqsız sayıb rədd etmək isə həm haqlı tərəfi, həm münasibəti itirir, ən az faydalı seçimdir (B).`,
  },
  {
    id: 'ez-m2-q50', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Şahmat turnirində həm hisslərin, həm faktların rol oynadığı bir qərar verirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Yalnız anlıq emosiyaya əsaslanın.`,
      B: `Yalnız faktlara baxıb insani tərəfi unudun.`,
      C: `Vəziyyətin emosional tərəfini oxuyub nəzərə alın.`,
      D: `Emosional anlayışı faktlar və nəticələrlə birləşdirib qərar verin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Həm hiss, həm fakt olan qərarda ən doğru yanaşma emosional anlayışı faktlar və nəticələrlə birləşdirməkdir (D, 4). Emosional tərəfi oxuyub nəzərə almaq vacibdir, lakin tək başına natamamdır (C, 3). Yalnız faktlara baxıb insani tərəfi unutmaq tarazlığı pozur (B, 2). Yalnız anlıq emosiyaya əsaslanmaq isə obyektivliyi itirir, ən zəifdir (A, 1).`,
  },
  {
    id: 'ez-m2-q51', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Hostel ofisində saatlardır fasiləsiz işləyirsiniz, diqqətiniz dağılır və əsəbiləşirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Bunları bir fasilə siqnalı kimi qəbul edib qısa ara verin, sonra davam edin.`,
      B: `Əsəbi olduğunuzu fərq etsəniz də, bunun ünsiyyətinizə təsirini nəzərə almadan işi davam etdirin.`,
      C: `İşi büsbütün atıb günü bitirin.`,
      D: `Bu əlamətləri keçici sayıb eyni templə işləməyə davam edin.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Dağılan diqqət və əsəbilik bir fasilə siqnalıdır: ən uyğun davranış qısa ara verib sonra davam etməkdir (A). İşi büsbütün atıb günü bitirmək həddən artıq reaksiyadır (C). Əsəbi olduğunuzu fərq etsəniz də, ünsiyyətinizə təsirini nəzərə almadan işi davam etdirmək münasibətə xələl gətirə bilər (B). Bu əlamətləri keçici sayıb eyni templə davam etmək isə həm keyfiyyəti, həm halınızı pisləşdirir, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m2-q52', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Heyvan məşqi mərkəzində qayda pozan bir nəfərlə bağlı qərar verirsiniz; həm onun halını, həm ədaləti nəzərə almalısınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Faktları və ədalətli qaydanı nəzərə alın.`,
      B: `Anlayışı ədalətlə birləşdirib ölçülü qərar verin.`,
      C: `Onun vəziyyətini və hissini anlayın.`,
      D: `Yalnız anlıq emosiyaya əsaslanıb qərar verin.`,
    },
    correct: ['C', 'A', 'B', 'D'],
    explanation: `Həssas intizam qərarında ən güclü ardıcıllıq onun vəziyyətini və hissini anlamaq (C), faktları və ədalətli qaydanı nəzərə almaq (A) və anlayışı ədalətlə birləşdirib ölçülü qərar verməkdir (B). Yalnız anlıq emosiyaya əsaslanıb qərar vermək isə ədaləti və ardıcıllığı itirir, ən zəif seçimdir (D).`,
  },
  {
    id: 'ez-m2-q53', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Subtitr studiyasında bir plan kağız üzərində düzgün görünür, lakin içinizdə güclü bir narahatlıq hissi var. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yalnız hissə əsaslanıb planı bütövlükdə dayandırın.`,
      B: `Narahatlığın hansı konkret məqama işarə etdiyini müəyyən edib həmin yeri yoxlayın.`,
      C: `Bütün planı bir daha, fərq qoymadan başdan yoxlayın.`,
      D: `Hissi əsassız sayıb planı olduğu kimi qəbul edin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Düzgün görünən, lakin sizi narahat edən planda ən təsirli yanaşma narahatlığın hansı konkret məqama işarə etdiyini müəyyən edib həmin yeri yoxlamaqdır (B). Bütün planı fərq qoymadan başdan yoxlamaq səmərəsizdir (C). Yalnız hissə əsaslanıb planı bütövlükdə dayandırmaq yoxlanmamış reaksiyadır (A). Hissi əsassız sayıb planı olduğu kimi qəbul etmək isə real problemi qaçıra bilər, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m2-q54', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Uşaq idman klubunda böyük bir imkandan əvvəl həm həyəcan, həm narahatlıq keçirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hisslərin coşqusu ilə tez qərar verib detalları sonraya saxlayın.`,
      B: `Hər iki hissi tanıyıb adlandırın.`,
      C: `Enerjini hazırlığa yönəldib ölçülü hərəkət edin.`,
      D: `Onların hər birinin nəyə işarə etdiyini anlayın.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `Həyəcan və narahatlıq birlikdə olanda ən doğru ardıcıllıq hər iki hissi tanıyıb adlandırmaq (B), hər birinin nəyə işarə etdiyini anlamaq (D) və enerjini hazırlığa yönəldib ölçülü hərəkət etməkdir (C). Hisslərin coşqusu ilə tələsik qərar vermək isə nəzarəti itirir, ən zəifdir (A).`,
  },
  {
    id: 'ez-m2-q55', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kosmetika mağazasında gözlənilməz bir tənqid sizi qıcıqlandırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hissi inkar edib heç nə hiss etmədiyinizi deyin.`,
      B: `Tənqidin məzmununa baxmadan onu tamamilə rədd edin.`,
      C: `Fasilə verib hissinizi dəqiq adlandırın, məsələn "qıcıqlandım, hirsli deyiləm", sonra ölçülü cavab verin.`,
      D: `Qıcığı saxlamağa çalışmadan tonunuzda büruzə verin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Qıcıqlananda ən uyğun davranış fasilə verib hissi dəqiq adlandırmaq, sonra ölçülü cavab verməkdir; hissi dəqiq adlandırmaq onu mütənasib idarə etməyə kömək edir (C). Tənqidi məzmununa baxmadan rədd etmək faydalı məlumatı itirir (B). Hissi inkar etmək onu gizlədir (A). Qıcığı tonunuzda büruzə vermək isə peşmançılığa apara bilər, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m2-q56', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Toy salonunda işinizlə fəxr edirsiniz, lakin onun layiqincə qiymətləndirilmədiyini görüb məyus olursunuz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız fəxrə fokuslanıb məyusluğu inkar edin.`,
      B: `Yalnız məyusluğa qapılıb gördüyünüz işin dəyərini unudun.`,
      C: `İki hiss qarışdığı üçün heç birini araşdırmadan diqqətinizi işə yönəldin.`,
      D: `Həm fəxri, həm məyusluğu tanıyıb hər ikisini özünüzə etiraf edin.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Fəxr və məyusluq birlikdə yaşananda ən güclü davranış hər ikisini tanıyıb özünüzə etiraf etməkdir (D). Yalnız fəxrə (A) və ya yalnız məyusluğa (B) baxmaq mənzərənin yarısını qaçırır. İki hissin heç birini araşdırmadan diqqəti yalnız işə yönəltmək isə dəyərli məlumatı itirir, ən zəif seçimdir (C).`,
  },
  {
    id: 'ez-m2-q57', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tibbi qeydiyyatda bir həmkar pərt vəziyyətini sizdən daha yavaş emal edir və siz səbirsizlik hiss edirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hər kəsin emosiyanı fərqli sürətlə emal etdiyini xatırlayıb ona vaxt verin.`,
      B: `Səbirsizliyinizi içinizdə saxlayın, lakin narahatlığınız bir az hiss olunur.`,
      C: `Söhbəti qısaldıb onu öz halı ilə tək buraxın.`,
      D: `Səbirsizliyi göstərib onu tələsdirin.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Ən güclü davranış hər kəsin emosiyanı fərqli sürətlə emal etdiyini xatırlayıb ona vaxt verməkdir (A). Səbirsizliyi içinizdə saxlamaq, az hiss olunsa belə, tələsdirməkdən yaxşıdır (B). Söhbəti qısaldıb onu tək buraxmaq dəstəyi kəsir (C). Səbirsizliyi göstərib onu tələsdirmək isə emal prosesini pozur, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m2-q58', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Onlayn dəstək komandasında bir həmkar sizin də istədiyiniz bir uğur qazanır və içinizdə paxıllığa bənzər bir hiss yaranır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Paxıllığı onun uğurunu kiçiltməklə büruzə verin.`,
      B: `Hissi özünüzə etiraf edin, onu səmimi təbrik edin və öz hədəflərinizə fokuslanın.`,
      C: `Hissi danıb heç nə hiss etmədiyinizi deyin.`,
      D: `Hissi uzun müddət üzərinizdə saxlayıb əhvalınızı pozun.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Paxıllığa bənzər hissdə ən təsirli davranış onu özünüzə etiraf etmək, həmkarı səmimi təbrik etmək və öz hədəflərinizə fokuslanmaqdır (B). Hissi danmaq onu gizlədir (C). Hissi uzun saxlayıb əhvalınızı pozmaq özünüzə zərər verir (D). Paxıllığı onun uğurunu kiçiltməklə büruzə vermək isə həm münasibəti, həm nüfuzunuzu zədələyir, ən zəifdir (A).`,
  },
  {
    id: 'ez-m2-q59', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Şahmat klubunda müəyyən bir mövzu hər dəfə sizi qeyri-adi dərəcədə əsəbiləşdirir və bunu fərq etmisiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Tətikləyicini yalnız xarici səbəblərlə izah edib öz reaksiyanıza baxmayın.`,
      B: `Mövzu qalxanda söhbətdən hər dəfə birdən çıxıb gedin.`,
      C: `Bunun sizin üçün bir tətikləyici olduğunu tanıyıb həmin anlarda daha ehtiyatlı reaksiya verin.`,
      D: `Hər dəfə eyni cür kəskin reaksiya verməyə davam edin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Təkrarlanan tətikləyicidə ən doğru davranış bunun sizin üçün bir tətikləyici olduğunu tanıyıb həmin anlarda daha ehtiyatlı reaksiya verməkdir (C). Mövzu qalxanda söhbətdən hər dəfə birdən çıxıb getmək qaçınmadır (B). Hər dəfə eyni kəskin reaksiyanı davam etdirmək heç nəyi dəyişmir (D). Tətikləyicini yalnız xarici səbəblərlə izah edib öz reaksiyanıza baxmamaq isə problemi həll etmir, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m2-q60', course: 'ez', mock_num: 2, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Kostyum prokatında bir qərarda özünüzün müəyyən bir nəfərə meylli olduğunuzu fərq edirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Meyli inkar edib qərarın bütövlükdə obyektiv olduğunu güman edin.`,
      B: `Meylinizə uyğun qərar verib bunu özünüzə haqq qazandırın.`,
      C: `Qərarı tam başqasına ötürüb məsələdən uzaqlaşın.`,
      D: `Bu meyli fərq edib qərarı şəffaf meyarlara və faktlara əsasən verin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Öz meylinizi fərq edəndə ən uyğun davranış onu tanıyıb qərarı şəffaf meyarlara və faktlara əsasən verməkdir (D). Qərarı tamamilə başqasına ötürmək məsuliyyətdən qaçmaqdır (C). Meyli inkar edib qərarın obyektiv olduğunu güman etmək qərəzi gizli saxlayır (A). Meylinizə uyğun qərar verib bunu haqq qazandırmaq isə ədaləti birbaşa pozur, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m3-q1', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Su idmanı mərkəzində iki üzv növbə üstündə qızğın mübahisə edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Tərəflərə özləri həll etməyi deyib bir kənara çəkilin.`,
      B: `Sakit ton və ortaq nöqtə ilə hər ikisini eşidib gərginliyi azaldın.`,
      C: `Səsinizi qaldırıb hər ikisini bir anda susdurun.`,
      D: `Birinin tərəfini tutub digərini haqsız çıxarın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `İki üzv arasındakı mübahisədə ən güclü davranış sakit ton və ortaq nöqtə ilə hər ikisini eşidib gərginliyi azaltmaqdır (B). Tərəf tutmaq münaqişəni dərinləşdirir (D). Səs qaldırıb susdurmaq yalnız anlıq kəsir (C). Uzaqlaşıb tərəflərə özləri həll etməyi deyib uzaqlaşmaq isə vəziyyəti idarəsiz qoyur, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m3-q2', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Mətbəx studiyasında gözlənilməz bir maneə işinizi bloklayır və əsəbiləşirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Edə biləcəyiniz faydalı bir addımı seçib hərəkətə keçin.`,
      B: `Əsəbi bir an üçün qəbul edib sakitləşin.`,
      C: `Nəyə təsir edə biləcəyinizi, nəyə yox, ayırın.`,
      D: `Əsəbi komanda yoldaşlarınızla bölüşüb gərginliyi onlara da keçirin.`,
    },
    correct: ['B', 'C', 'A', 'D'],
    explanation: `Bloklanıb əsəbiləşəndə ən təsirli ardıcıllıq əsəbi bir an qəbul edib sakitləşmək (B), nəyə təsir edə biləcəyinizi ayırmaq (C) və faydalı bir addım seçib hərəkətə keçməkdir (A). Əsəbi komanda yoldaşlarına keçirmək isə gərginliyi yayır və problemi həll etmir, ən zəifdir (D).`,
  },
  {
    id: 'ez-m3-q3', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Antikvar mağazasında bir həmkar bir işin alınmamasından məyusdur. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Anladığınızı bildirib lazım olsa dəstək təklif edin.`,
      B: `Məyusluğunu eşidib qəbul edin, sonra birlikdə növbəti addıma baxın.`,
      C: `Dərhal həll yolları sadalayıb keçin.`,
      D: `"O qədər də mühüm deyildi" deyin.`,
    },
    correct: { A: 3, B: 4, C: 2, D: 1 },
    explanation: `Məyus həmkara ən doğru reaksiya məyusluğunu eşidib qəbul etmək, sonra birlikdə növbəti addıma baxmaqdır (B, 4). Anladığınızı bildirib dəstək təklif etmək də güclüdür (A, 3). Dərhal həll sadalamaq hissi ötür (C, 2). "O qədər də mühüm deyildi" demək isə hissini kiçildir, ən az təsirlidir (D, 1).`,
  },
  {
    id: 'ez-m3-q4', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tibb bacısı məntəqəsində bir həmkar sualınızı zarafatla yan keçir, lakin narahat göründüyünü hiss edirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Onu açıq danışmamaqda ittiham edin.`,
      B: `Yalnız zarafatı qəbul edib narahatlığı bütövlükdə qaçırın.`,
      C: `Zarafatın altında narahatlıq ola biləcəyini görüb mehribanca, təzyiqsiz yenidən soruşun.`,
      D: `Zarafatına qoşulub mövzunu bağlayın.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Zarafatla yan keçilən sualda ən uyğun davranış altında narahatlıq ola biləcəyini görüb mehribanca yenidən soruşmaqdır (C). Zarafatına qoşulub mövzunu bağlamaq onu bir az rahatladır, lakin əsl hissi açmır (D). Onu açıq danışmamaqda ittiham etmək təzyiq yaradır (A). Yalnız zarafatı qəbul edib narahatlığı tam qaçırmaq isə əsl siqnalı görmür, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m3-q5', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Tələbə yataqxanasında özünüzdə adsız, qarışıq bir gərginlik hiss edirsiniz və onu anlamaq istəyirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Bir an dayanıb hissi adlandırın və onu nəyin doğurduğunu anlayın.`,
      B: `Gərginliyi vacib saymayıb işə davam edin.`,
      C: `Hissi şəxsi zəiflik sayıb özünüzü tənqid edin.`,
      D: `Gərginliyi ətrafdakıların üstünə çıxın.`,
    },
    correct: 'A',
    explanation: `Adsız gərginlikdə ən güclü davranış bir an dayanıb hissi adlandırmaq və onu nəyin doğurduğunu anlamaqdır (A). Gərginliyi vacib saymayıb davam etmək dəyərli siqnalı itirə bilər (B). Hissi şəxsi zəiflik sayıb özünüzü tənqid etmək faydasızdır (C). Gərginliyi ətrafdakıların üstünə çıxmaq isə həm haqsız, həm münasibəti pozandır (D).`,
  },
  {
    id: 'ez-m3-q6', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Hobbi dərnəyində bir həmkar dəyişdirilməsi mümkün olmayan çətin bir vəziyyətdən danışır. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Vəziyyəti dəyişə bilməsəniz də, bir-bir həll yolları sadalayın.`,
      B: `Öz daha çətin təcrübənizi danışmağa başlayın.`,
      C: `"Narahat olma, keçər" deyib mövzunu dəyişin.`,
      D: `Diqqətlə dinləyin, hissini adlandırın və yanında olduğunuzu bildirin.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Dəyişdirilməsi mümkün olmayan vəziyyətdə ən təsirli dəstək diqqətlə dinləmək, hissi adlandırmaq və yanında olduğunuzu bildirməkdir (D). Dəyişə bilməyəcəyiniz həll yolları sadalamaq köməksizdir (A). Söhbəti öz təcrübənizə çevirmək diqqəti yayındırır (B). "Keçər" deyib mövzunu dəyişmək isə hissini rədd edir, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'ez-m3-q7', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Barista kursunda bir qrupla çətin bir söhbətə başlamazdan əvvəl onların hazır olub-olmadığını qiymətləndirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Qrupun ümumi enerjisini və əhvalını müşahidə edin.`,
      B: `Hazır olub-olmadıqlarına baxmadan dərhal mövzuya keçin.`,
      C: `Uyğun deyilsə, daha yaxşı bir an seçin.`,
      D: `Anın söhbət üçün uyğun olub-olmadığını qiymətləndirin.`,
    },
    correct: ['A', 'D', 'C', 'B'],
    explanation: `Çətin söhbətdən əvvəl qrupun hazırlığını qiymətləndirmək onların enerjisini və əhvalını müşahidə etməklə başlayır (A), sonra anın uyğun olub-olmadığını qiymətləndirmək (D) və uyğun deyilsə daha yaxşı an seçmək (C). Hazırlığa baxmadan dərhal mövzuya keçmək isə söhbəti uğursuzluğa apara bilər, ən zəifdir (B).`,
  },
  {
    id: 'ez-m3-q8', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qoruq bələdçiliyində qrup rəhbərisiniz və bu gün gərginsiniz; əhvalınız qrupa təsir edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Öz əhvalınızı tənzimləyib qrupa sakit ton ötürün, çünki əhval yoluxur.`,
      B: `Gərginliyinizi olduğu kimi qrupa ötürün.`,
      C: `Gərgin əhvalınıza görə qrupu günahlandırın.`,
      D: `Hiss etdiyinizi tamamilə gizlədib süni şən görünün.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Əhval yoluxduğu üçün ən doğru davranış öz əhvalınızı tənzimləyib qrupa sakit ton ötürməkdir (A). Süni şənlik davamlı deyil (D). Gərginliyi olduğu kimi ötürmək qrupa keçir (B). Gərgin əhvalınıza görə qrupu günahlandırmaq isə haqsız və zərərlidir, ən az təsirlidir (C).`,
  },
  {
    id: 'ez-m3-q9', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Heykəltəraşlıq emalatxanasında vacib bir təqdimatdan əvvəl həyəcanlısınız. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Həyəcanı hazırlığa diqqət yönəltmək üçün istifadə edin.`,
      B: `Həyəcana görə təqdimatı təxirə salmağı düşünün.`,
      C: `Həyəcanı tanıyın, enerjiyə çevirin və hazırlığınızı son dəfə gözdən keçirin.`,
      D: `Həyəcanı inkar edib heç nə hiss etmədiyinizi deyin.`,
    },
    correct: { A: 3, B: 2, C: 4, D: 1 },
    explanation: `Ən güclü yanaşma həyəcanı tanıyıb enerjiyə çevirmək və hazırlığı son dəfə gözdən keçirməkdir (C, 4). Həyəcanı diqqət üçün istifadə etmək də faydalıdır (A, 3). Təqdimatı təxirə salmaq qaçınmadır (B, 2). Həyəcanı inkar etmək isə onu idarə etməyi çətinləşdirir, ən zəif seçimdir (D, 1).`,
  },
  {
    id: 'ez-m3-q10', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Uşaq oyun mərkəzində çox əsəbisiniz və dərhal sərt bir cavab yazmaq istəyirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Cavabı yazın, lakin göndərmədən əvvəl başqa işə keçin.`,
      B: `Emosiyanın zirvəsinin keçməsi üçün bir az ara verin, sonra sakit yazın.`,
      C: `Cavabı dərhal, hiss etdiyiniz kimi yazıb göndərin.`,
      D: `Cavabınızın tonu sərt çıxsa da, bunu fərq etmədən göndərin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Əsəbin zirvəsi keçənə qədər bir az ara verib sonra sakit yazmaq ən uyğun davranışdır (B). Cavabı yazıb göndərmədən başqa işə keçmək də zirvəni yumşaldır (A). Dərhal hiss etdiyiniz kimi göndərmək peşmançılığa apara bilər (C). Cavabın tonunun sərt çıxması isə münasibəti pozur, ən az faydalı seçimdir (D).`,
  },
  {
    id: 'ez-m3-q11', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Musiqi alətləri mağazasında bir uğursuzluqdan sonra hisslərinizi anlayıb irəliləmək istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Uğursuzluqdan çıxarılacaq dərsi müəyyən edin.`,
      B: `Hissi danıb heç nə olmamış kimi davam edin.`,
      C: `Hissi tanıyıb adlandırın.`,
      D: `Növbəti konkret addımı planlaşdırın.`,
    },
    correct: ['C', 'A', 'D', 'B'],
    explanation: `Uğursuzluğu emal etmək hissi tanıyıb adlandırmaqla başlayır (C), sonra çıxarılacaq dərsi müəyyən etmək (A) və növbəti konkret addımı planlaşdırmaq (D). Hissi danıb heç nə olmamış kimi davam etmək isə nə emal, nə öyrənmə verir, ən zəifdir (B).`,
  },
  {
    id: 'ez-m3-q12', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Balıqçılıq dərnəyində bir həmkar özünün həll edə biləcəyi məsələləri davamlı sizə həvalə etməyə çalışır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `"Bu sənin işindir" deyib heç bir dəstək vermədən uzaqlaşın.`,
      B: `Bundan sonra onun heç bir sualına cavab verməyin.`,
      C: `Lazımi suallarla onu öz həllinə yönəldib bacardığına inamını gücləndirin.`,
      D: `Hər dəfə işi onun əvəzinə özünüz görüb məsələni bağlayın.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Davamlı işi ötürən həmkarla ən güclü davranış lazımi suallarla onu öz həllinə yönəldib özünə inamını gücləndirməkdir (C). "Sənin işindir" deyib heç dəstək verməmək kobud qarşılıqdır (A). Sualına heç cavab verməmək münasibəti pozur (B). Hər dəfə işi onun əvəzinə görmək isə asılılığı möhkəmləndirir və yükünüzü artırır, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m3-q13', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Nitq terapiyası mərkəzində bir gənc ruhdan düşüb və bacarmayacağını düşünür. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `"Hamı bacarır, sən niyə bacarmırsan" deyin.`,
      B: `Sadəcə "hər şey yaxşı olacaq" deyib keçin.`,
      C: `Çətinliyi qəbul edin və onun güclü tərəflərini xatırladın.`,
      D: `Hissini eşidin, sonra real, kiçik bir irəliləyiş addımı göstərin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Ruhdan düşmüş gəncə ən təsirli reaksiya hissini eşitmək, sonra real, kiçik bir irəliləyiş addımı göstərməkdir (D, 4). Çətinliyi qəbul edib güclü tərəflərini xatırlatmaq da dəstəkləyir (C, 3). "Hər şey yaxşı olacaq" deyib keçmək boş təsəllidir (B, 2). "Hamı bacarır, sən niyə bacarmırsan" demək isə onu daha da ruhdan salır, ən zəif seçimdir (A, 1).`,
  },
  {
    id: 'ez-m3-q14', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Podkast studiyasında bir komanda üzvünün şəxsi problemi işinin keyfiyyətinə təsir edir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Yalnız standarta baxıb şəxsi vəziyyətini bütövlükdə bir kənara qoyun.`,
      B: `Yalnız vəziyyətinə baxıb keyfiyyət düşüşünü heç qeyd etməyin.`,
      C: `Mövzunu ümumiyyətlə açmayıb problemin öz-özünə böyüməsinə imkan verin.`,
      D: `Vəziyyəti anlayışla qarşılayın, eyni zamanda işin standartını qorumaq üçün birlikdə plan qurun.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Şəxsi problem işə təsir edəndə ən doğru davranış anlayışı standartla birləşdirmək, birlikdə plan qurmaqdır (D). Yalnız standarta baxıb vəziyyətini unutmaq insani tərəfi itirir (A). Yalnız vəziyyətə baxıb keyfiyyət düşüşünü qeyd etməmək problemi böyüdür (B). Mövzunu açmayıb problemin öz-özünə böyüməsinə imkan vermək isə hər ikisinə zərər verir, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'ez-m3-q15', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kitab klubunda təbii olaraq xoşlamadığınız bir iştirakçıya empatiya göstərməlisiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Vəziyyətinə uyğun, hörmətli dəstək göstərin.`,
      B: `Onun nöqteyi-nəzərini və hissini anlamağa çalışın.`,
      C: `Xoşlamadığınız üçün ünsiyyəti minimuma endirib yalnız formal davranın.`,
      D: `Şəxsi münasibətinizi bir anlıq kənara qoyub onun vəziyyətini dinləyin.`,
    },
    correct: ['D', 'B', 'A', 'C'],
    explanation: `Xoşlamadığınız birinə empatiya şəxsi münasibəti bir anlıq kənara qoyub onun vəziyyətini dinləməklə başlayır (D), sonra nöqteyi-nəzərini və hissini anlamaq (B) və hörmətli dəstək göstərmək (A). Xoşlamadığınız üçün ünsiyyəti minimuma endirmək isə peşəkarlığa ziddir, ən zəifdir (C).`,
  },
  {
    id: 'ez-m3-q16', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Dağ sığınacağında yaxın bir həmkar davamlı olaraq ağır şəxsi mövzuları sizinlə bölüşür və bu, sizi çox yorur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Mehribanlıqla yanında olun, lakin nə qədər dinləyə biləcəyinizə dair yumşaq bir hədd qoyun.`,
      B: `Onu qıramamaq üçün hər dəfə saatlarla dinləyib özünüzü tükədin.`,
      C: `Mövzu açılan kimi başqa işiniz olduğunu deyib söhbəti tez bitirin.`,
      D: `Onunla ünsiyyəti tam kəsin.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Davamlı ağır mövzularda ən uyğun davranış mehribanlıqla yanında olmaq, lakin imkanınıza dair yumşaq hədd qoymaqdır (A). Onu qıramamaq üçün hər dəfə özünüzü tükətmək davamlı deyil (B). Ünsiyyəti tamamilə kəsmək münasibəti itirir (D). Mövzu açılan kimi başqa işiniz olduğunu deyib tez bitirmək isə yaxın həmkarı kənarda qoyur, ən az təsirlidir (C).`,
  },
  {
    id: 'ez-m3-q17', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/disgust.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Bir üzdə burun kökü qırışıb, üst dodaq yuxarı qalxıb və yanaqlar bir qədər yuxarı dartılıb. Qaşlar isə qəzəbdəki kimi aşağı, bir-birinə doğru çəkilməyib. Bu ifadə hansı emosiyaya daha çox uyğundur?`,
    options: {
      A: `Qəzəb`,
      B: `İkrah`,
      C: `Təəccüb`,
      D: `Kədər`,
    },
    correct: 'B',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `İkrahı qəzəbdən fərqləndirən əsas əlamət burun kökünün qırışması və üst dodağın qalxmasıdır (levator labii əzələsi). Qəzəbdə isə qaşlar aşağı və bir-birinə doğru çəkilir, dodaqlar sıxılır, burun qırışığı olmur. Burada burun qırışığı və qalxan üst dodaq var, qaşlar aşağı çəkilməyib, deməli B ikrahdır. C təəccüb (qaşlar yuxarı) və D kədər (dodaq künclərinin aşağı düşməsi) bütövlükdə fərqli nümunələrdir. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-m3-q18', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Ayaqqabı təmiri emalatxanasında bir müştəri söhbət zamanı dəfələrlə sözünüzü kəsir və qıcıqlanırsınız. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Onu kobudluqda ittiham edib söhbəti dayandırın.`,
      B: `Sakit qalıb fikrinizi bitirmək üçün nəzakətlə, lakin aydın şəkildə söz istəyin.`,
      C: `Eyni ilə onun da sözünü kəsib səsinizi qaldırın.`,
      D: `Qıcığı içinizdə saxlayıb tam susun və geri çəkilin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Sözünüz dəfələrlə kəsiləndə ən güclü davranış sakit qalıb nəzakətlə, lakin aydın söz istəməkdir (B). Qıcığı içinizdə saxlayıb tamamilə susmaq fikrinizi itirir (D). Eyni ilə onun sözünü kəsib səs qaldırmaq gərginliyi artırır (C). Onu kobudluqda ittiham edib söhbəti dayandırmaq isə münaqişəyə çevirir, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m3-q19', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Dil mübadiləsi klubunda bir iştirakçı tərəddüd edir, lakin bunu açıq demir. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Söz, səs və üz ifadəsini birlikdə oxuyub mehribanca dəqiqləşdirin.`,
      B: `Üz ifadəsini nəzərə alın, lakin yoxlamayın.`,
      C: `Tək bir əlamətdən onun fikrini dəqiq bildiyinizi düşünün.`,
      D: `Yalnız sözlərinə əsaslanıb tərəddüdü qaçırın.`,
    },
    correct: { A: 4, B: 3, C: 1, D: 2 },
    explanation: `Tərəddüd edən iştirakçıda ən təsirli yanaşma söz, səs və üz ifadəsini birlikdə oxuyub mehribanca dəqiqləşdirməkdir (A, 4). Üz ifadəsini nəzərə alıb yoxlamamaq bir qədər faydalıdır (B, 3). Yalnız sözlərə əsaslanıb tərəddüdü qaçırmaq əsl halı görmür (D, 2). Tək bir əlamətdən fikrini dəqiq bildiyinizi düşünmək isə səhv oxumağa aparır, ən az faydalı seçimdir (C, 1).`,
  },
  {
    id: 'ez-m3-q20', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Şirə barında sakit, diqqətli əhvaldasınız. Qarşınızda həm detallı inventar yoxlaması, həm enerjili müştəri qarşılaması var. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Sakit halınızda enerjili qarşılamanı zorla edin.`,
      B: `Əhvalınız dəyişənə qədər heç bir işə başlamayın.`,
      C: `Sakit, diqqətli əhvalınıza uyğun gələn detallı inventar işini indi görün, qarşılamanı enerjiniz artanda.`,
      D: `Əhvalınızı nəzərə almadan işləri gəldiyi kimi görün.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Hazırkı əhvala uyğun işi seçmək məhsuldarlığı artırır: sakit, diqqətli halda detallı inventarı görmək ən effektivdir (C). İşləri gəldiyi kimi görmək uyğunluğu itirir (D). Əhval dəyişənə qədər heç nə etməmək vaxt itirir (B). Sakit halda enerjili qarşılamanı zorla etmək isə həm işi, həm halınızı pisləşdirir, ən zəifdir (A).`,
  },
  {
    id: 'ez-m3-q21', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Qaçış klubunda vacib bir tədbirdən əvvəl narahatlıq hiss edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Narahatlığı bütövlükdə danıb heç nə hiss etmədiyinizi deyin.`,
      B: `Narahatlığı bir siqnal kimi qəbul edin.`,
      C: `Həmin sahəni hazırlayıb narahatlığı faydalı işə çevirin.`,
      D: `Onun nəyə işarə etdiyini, nəyin hazırlanmasını istədiyini anlayın.`,
    },
    correct: ['B', 'D', 'C', 'A'],
    explanation: `Narahatlığı məhsuldar istifadə etmək onu bir siqnal kimi qəbul etməklə başlayır (B), sonra nəyə işarə etdiyini anlamaq (D) və həmin sahəni hazırlayıb narahatlığı faydalı işə çevirmək (C). Narahatlığı tam danmaq isə dəyərli siqnalı itirir, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m3-q22', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `El sənətləri sərgisində xoşlamadığınız bir vəzifə ləğv olunur; həm yüngülləşmə, həm bir az günah hissi keçirirsiniz. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Yalnız yüngülləşməyə fokuslanıb günah hissini inkar edin.`,
      B: `Yalnız günah hissinə qapılıb yüngülləşməni qaçırın.`,
      C: `İki hiss qarışdığı üçün hisslərinizi tamamilə bir kənara qoyun.`,
      D: `Hər iki hissin eyni anda mövcud ola biləcəyini qəbul edib hər ikisini nəzərə alın.`,
    },
    correct: { best: 'D', worst: 'C' },
    explanation: `Yüngülləşmə və günah eyni anda yaşananda ən doğru davranış hər ikisini qəbul edib nəzərə almaqdır (D). Yalnız yüngülləşməyə (A) və ya yalnız günaha (B) baxmaq mənzərənin yarısını qaçırır. İki hissin qarışığından qaçıb hissləri bütövlükdə bir kənara qoymaq isə dəyərli məlumatı itirir, ən zəif seçimdir (C).`,
  },
  {
    id: 'ez-m3-q23', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Foto klubda gərgin bir anda öz emosiyanızı idarə edirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Hissi tam susdurub heç nə hiss etmədiyinizi deyin.`,
      B: `Bir an dayanıb sakitləşin, sonra cavab verin.`,
      C: `Vəziyyəti yenidən, daha sakit çərçivədə görüb ölçülü cavab verin.`,
      D: `Düşünməyə ara vermədən tez cavab verin.`,
    },
    correct: { A: 2, B: 4, C: 3, D: 1 },
    explanation: `Gərgin anda ən uyğun yanaşma bir an dayanıb sakitləşmək, sonra cavab verməkdir (B, 4). Vəziyyəti daha sakit çərçivədə görüb ölçülü cavab vermək də güclüdür (C, 3). Hissi tam susdurmaq onu gizlədir (A, 2). Düşünməyə ara vermədən tez cavab vermək isə vəziyyəti pisləşdirir, ən az faydalı seçimdir (D, 1).`,
  },
  {
    id: 'ez-m3-q24', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Ədviyyat dükanında nadir bir məhsula iki nəfər iddialıdır: birinin sabah mərasimi var, digəri sadəcə çox istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hər ikisinin vəziyyətini empatiya ilə anlayın və ehtiyacın təcilliyinə görə şəffaf qərar verin.`,
      B: `Məhsulu daha çox xahiş edənə verin.`,
      C: `Seçimi heç bir əsas olmadan atın.`,
      D: `Qərarı qeyri-müəyyən müddətə təxirə salın.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Eyni resursa iki iddiada ən güclü davranış hər ikisini empatiya ilə anlamaq və ehtiyacın təcilliyinə görə şəffaf qərar verməkdir (A). Seçimi heç bir əsas olmadan atmaq ədalətsizdir (C). Qərarı təxirə salmaq imkanı itirir (D). Məhsulu sadəcə daha çox xahiş edənə vermək isə real ehtiyacı gözardı edir, ən zəifdir (B).`,
  },
  {
    id: 'ez-m3-q25', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Stolüstü oyun kafesində həm hisslərin, həm faktların rol oynadığı bir qərar verirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Vəziyyətin emosional tərəfini oxuyun.`,
      B: `Yalnız anlıq emosiyaya əsaslanıb qərar verin.`,
      C: `Faktları və nəticələri də nəzərə alın.`,
      D: `Emosional anlayışı faktlarla birləşdirib qərar verin.`,
    },
    correct: ['A', 'C', 'D', 'B'],
    explanation: `Həm hiss, həm fakt olan qərarda ən təsirli ardıcıllıq emosional tərəfi oxumaq (A), faktları və nəticələri nəzərə almaq (C) və ikisini birləşdirib qərar verməkdir (D). Yalnız anlıq emosiyaya əsaslanıb qərar vermək isə faktları gözardı edir, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m3-q26', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Vinil mağazada bir həmkar sakit görünür, lakin siz özünüz narahat olduğunuz üçün onun da sizdən narahat olduğunu düşünürsünüz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Öz narahatlığınızı danıb yalnız onun halı ilə məşğul olun.`,
      B: `Öz narahatlığınızı onun halından ayırıb, doğrudan da bir problem olub-olmadığını incə şəkildə soruşun.`,
      C: `Öz narahatlığınızı ona aid edib məsafə saxlamağa başlayın.`,
      D: `Hər ikinizin narahat olduğunu güman edib mövzunu açmayın.`,
    },
    correct: { best: 'B', worst: 'C' },
    explanation: `Ən güclü davranış öz narahatlığınızı onun halından ayırıb doğrudan da bir problem olub-olmadığını incə soruşmaqdır (B). Hər ikinizin narahat olduğunu güman edib mövzunu açmamaq yanlış fərziyyəyə əsaslanır (D). Öz narahatlığınızı danmaq özünüzü gözardı edir (A). Öz narahatlığınızı ona aid edib məsafə saxlamaq isə öz hissinizi başqasına proyeksiya etməkdir, ən zəif seçimdir (C).`,
  },
  {
    id: 'ez-m3-q27', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Tikiş dərnəyində həm hisslərin, həm faktların rol oynadığı həssas bir qərar verirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Yalnız anlıq emosiyaya əsaslanın.`,
      B: `Yalnız faktlara baxıb insani tərəfi unudun.`,
      C: `Emosional anlayışı faktlar və ədalətlə birləşdirib qərar verin.`,
      D: `Vəziyyətin emosional tərəfini oxuyub nəzərə alın.`,
    },
    correct: { A: 1, B: 2, C: 4, D: 3 },
    explanation: `Həssas qərarda ən doğru yanaşma emosional anlayışı faktlar və ədalətlə birləşdirib qərar verməkdir (C, 4). Emosional tərəfi oxuyub nəzərə almaq da vacibdir, lakin tək başına natamamdır (D, 3). Yalnız faktlara baxıb insani tərəfi unutmaq tarazlığı pozur (B, 2). Yalnız anlıq emosiyaya əsaslanmaq isə obyektivliyi itirir, ən az faydalı seçimdir (A, 1).`,
  },
  {
    id: 'ez-m3-q28', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Akvarel kursunda rəhbəriniz qısa, quru cavablar verir və bunu rədd kimi oxuyursunuz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hər ehtimala qarşı rəhbərlə ünsiyyəti azaldın.`,
      B: `Nəsə səhv etdiyinizi düşünüb dərhal uzun-uzadı üzr istəyin.`,
      C: `Qısa cavabın çoxlu səbəbi ola biləcəyini bilib işə normal davam edin, lazım olsa dəqiqləşdirin.`,
      D: `Quru cavabı şəxsi rədd kimi qəbul edib özünüzü pis hiss edin.`,
    },
    correct: { best: 'C', worst: 'D' },
    explanation: `Rəhbərin quru cavabında ən uyğun davranış onun çoxlu səbəbi ola biləcəyini bilib normal davam etmək, lazım olsa dəqiqləşdirməkdir (C). Hər ehtimala qarşı ünsiyyəti azaltmaq məsafə yaradır (A). Səhv etdiyinizi düşünüb dərhal uzun üzr istəmək yoxlanmamış fərziyyəyə əsaslanır (B). Quru cavabı şəxsi rədd kimi qəbul edib özünüzü pis hiss etmək isə neytral siqnalı əsassız mənfi oxumaqdır, ən zəifdir (D).`,
  },
  {
    id: 'ez-m3-q29', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kaktus bağçası emalatxanasında gözlənilməz bir xəbərdən sonra bir-birinə zidd hisslər keçirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hər birinin nəyi tətiklədiyini anlayın.`,
      B: `Hər ikisini nəzərə alıb ölçülü davranın.`,
      C: `Hissləri bir kənara yığıb yalnız işə davam edin.`,
      D: `Hər bir hissi ayrıca adlandırın.`,
    },
    correct: ['D', 'A', 'B', 'C'],
    explanation: `Zidd hissləri emal etmək hər birini ayrıca adlandırmaqla başlayır (D), sonra hər birinin nəyi tətiklədiyini anlamaq (A) və hər ikisini nəzərə alıb ölçülü davranmaq (B). Hissləri bir kənara yığıb yalnız işə davam etmək isə onları işlənməmiş qoyur, ən az təsirlidir (C).`,
  },
  {
    id: 'ez-m3-q30', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Astronomiya dərnəyində gözlənilməz bir hadisə sizi çaşdırır və diqqətinizi itirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Çaşqınlığı boğub heç nə olmamış kimi sürətlə davam edin.`,
      B: `Diqqətinizi yenidən cari işə yönəldin.`,
      C: `Bir an dayanıb nəfəs alın.`,
      D: `Sakit və ölçülü şəkildə davam edin.`,
    },
    correct: ['C', 'B', 'D', 'A'],
    explanation: `Çaşıb diqqəti itirəndə ən güclü ardıcıllıq bir an dayanıb nəfəs almaq (C), diqqəti yenidən cari işə yönəltmək (B) və sakit, ölçülü davam etməkdir (D). Çaşqınlığı boğub sürətlə davam etmək isə səhvə apara bilər, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m3-q31', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Qocalar evində bir ziyarətçi hirslə uzun-uzadı şikayətlənir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hələ hirsliykən dərhal məntiqli izah və həll təklif edin.`,
      B: `Hissinə toxunmadan yalnız qaydadan danışın.`,
      C: `Hirsinə görə onunla soyuq və qısa davranın.`,
      D: `Əvvəlcə hissini eşitdiyinizi bildirib qəbul edin, sonra birlikdə həllə keçin.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Hirsli ziyarətçiylə ən təsirli davranış əvvəlcə hissini eşitdiyinizi bildirib qəbul etmək, sonra birlikdə həllə keçməkdir (D). Yalnız qaydadan danışıb hissinə toxunmamaq onu eşidilməmiş qoyur (B). Soyuq və qısa davranmaq gərginliyi artırır (C). Hələ hirsliykən dərhal məntiqli izah və həll təklif etmək isə bu anda qəbul edilmir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m3-q32', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Bərbərxanada işə yeni başlamış, narahat görünən bir nəfəri rahatlatmağa çalışırsınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Narahatlığını fərq edib mehribanca qeyd edin.`,
      B: `Onu eşitdiyinizi və burada dəstək olacağınızı bildirin.`,
      C: `Narahatlığını əhəmiyyətsiz sayıb "öyrəşərsən" deyib keçin.`,
      D: `Konkret, kiçik bir kömək və ya istiqamət təklif edin.`,
    },
    correct: ['A', 'B', 'D', 'C'],
    explanation: `Narahat yeni nəfəri rahatlatmaq onun narahatlığını fərq edib mehribanca qeyd etməklə başlayır (A), sonra onu eşitdiyinizi və dəstək olacağınızı bildirmək (B) və konkret, kiçik kömək təklif etmək (D). Narahatlığını əhəmiyyətsiz sayıb keçmək isə onu tək qoyur, ən zəifdir (C).`,
  },
  {
    id: 'ez-m3-q33', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Reabilitasiya zalında bir həmkar yaxınını itirib və kədərini bölüşür. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Dərhal "həyat davam edir" deyib keçin.`,
      B: `Mövzunu dəyişib onu güldürməyə çalışın.`,
      C: `Sakitcə dinləyin və hissini qəbul etdiyinizi bildirin.`,
      D: `Kədərini eşidin, yanında olun və nə lazımdırsa təklif edin.`,
    },
    correct: { A: 1, B: 2, C: 3, D: 4 },
    explanation: `Kədərini bölüşən həmkara ən doğru reaksiya onu eşitmək, yanında olmaq və lazım olanı təklif etməkdir (D, 4). Sakitcə dinləyib hissini qəbul etmək də güclüdür (C, 3). Mövzunu dəyişib güldürməyə çalışmaq hissi yan keçir (B, 2). "Həyat davam edir" deyib keçmək isə kədərini kiçildir, ən az təsirlidir (A, 1).`,
  },
  {
    id: 'ez-m3-q34', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'single', is_free: false, points: 1,
    question_az: `Bərbərxanada bir qərar verməlisiniz, lakin bu gün əsəbi olduğunuzu və bunun mühakimənizə təsir edə biləcəyini hiss edirsiniz. Ən effektiv davranış hansıdır?`,
    options: {
      A: `Əsəbiliyin qərara təsir etmədiyini düşünüb dərhal qərar verin.`,
      B: `Qərarı bütövlükdə başqasına ötürün.`,
      C: `Əsəbiniz keçənə qədər bütün qərarlardan qaçın.`,
      D: `Əhvalınızın təsirini tanıyın, mümkünsə qərarı bir az təxirə salın və ya faktlara ikiqat diqqət yetirin.`,
    },
    correct: 'D',
    explanation: `Ən güclü davranış əhvalınızın mühakiməyə təsirini tanıyıb, mümkünsə qərarı bir az təxirə salmaq və ya faktlara ikiqat diqqət yetirməkdir (D). Əsəbiliyin təsir etmədiyini düşünüb dərhal qərar vermək qərəzi gözardı edir (A). Qərarı tam başqasına ötürmək məsuliyyətdən qaçmaqdır (B). Əsəb keçənə qədər bütün qərarlardan qaçmaq isə həddən artıqdır (C).`,
  },
  {
    id: 'ez-m3-q35', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'facial',
    svg_question: `<img src="https://swxxutvpafwxwzrtwzjd.supabase.co/storage/v1/object/public/faces/anger.png" alt="Sifət ifadəsi" style="max-width:280px;width:100%;border-radius:12px;display:block;margin:0 auto" />`, is_free: false, points: 1,
    question_az: `Bir üzdə qaşlar aşağı enib bir-birinə yaxınlaşıb, qaşların arasında şaquli qırışlar var, göz qapaqları gərginləşib və dodaqlar bir-birinə sıxılıb. Bu ifadə hansı emosiyaya daha çox uyğundur?`,
    options: {
      A: `Kədər`,
      B: `Təəccüb`,
      C: `Qəzəb`,
      D: `İkrah`,
    },
    correct: 'C',
    svg_options: {
      A: ``,
      B: ``,
      C: ``,
      D: ``,
    },
    explanation: `Qaşların enib bir-birinə yaxınlaşması, aralarındakı şaquli qırışlar, gərgin göz qapaqları və sıxılmış dodaqlar qəzəbin əlamətidir; bu üzdə hər biri var, deməli C (qəzəb) doğru cavabdır. Kədərdə qaşların daxili küncləri yuxarı qalxır (A). Təəccübdə qaşlar yuxarı qalxır və ağız açılır (B). İkrahda burun qırışır, üst dodaq qalxır (D). Bu siqnallar qəzəb üçün xarakterikdir. Real həyatda emosiyalar daha qarışıq görünə bilər. Ona görə üz ifadəsi, səs tonu, sözlərin məzmunu və situasiya birlikdə qiymətləndirilməlidir.`,
  },
  {
    id: 'ez-m3-q36', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Optika salonunda bir müştəri həmişəkindən artıq şən görünür, lakin bu, bir az süni təsir bağışlayır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Şənliyin altında nəsə ola biləcəyini görüb mehribanca, təzyiqsiz hal-əhval tutun.`,
      B: `Şənliyini olduğu kimi qəbul edib heç düşünməyin.`,
      C: `Onu süni davranmaqda ittiham edin.`,
      D: `Şənliyini soyuqca qarşılayıb ünsiyyəti qısaldın.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Süni görünən şənlikdə ən uyğun davranış altında nəsə ola biləcəyini görüb mehribanca hal-əhval tutmaqdır (A). Şənliyini olduğu kimi qəbul edib heç düşünməmək altdakı hissi qaçırır (B). Soyuqca qarşılayıb ünsiyyəti qısaltmaq lazımsız məsafə yaradır (D). Onu süni davranmaqda ittiham etmək isə münasibəti pozur, ən zəif seçimdir (C).`,
  },
  {
    id: 'ez-m3-q37', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Dərzi atelyesində başqalarının yanında bir səhv etdiniz və özünüzü itirmiş hiss edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Özünüzü toplamağa vaxt ayırmadan tələsik üzr deyib mövzunu dəyişin.`,
      B: `Bir an dayanıb sakitləşin.`,
      C: `Səhvi sakit şəkildə qəbul edib düzəliş addımını deyin.`,
      D: `İşə toplanıb davam edin.`,
    },
    correct: ['B', 'C', 'D', 'A'],
    explanation: `İctimai səhvdən sonra özünüzü toplamaq bir an dayanıb sakitləşməklə başlayır (B), sonra səhvi sakit qəbul edib düzəliş addımını demək (C) və işə toplanıb davam etmək (D). Özünüzü toplamadan tələsik üzr deyib mövzunu dəyişmək isə vəziyyəti tam həll etmir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m3-q38', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Yoga studiyasında çox həyəcanlandıran bir imkan yaranır və dərhal "hə" demək istəyirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Həyəcanı tanıyın, lakin qərar verməzdən əvvəl bir az aydın düşünməyə vaxt ayırın.`,
      B: `Həyəcanı bölüşün, lakin detalları soruşandan sonra qərar verin.`,
      C: `Həyəcanı tamamilə boğub maraqsız görünün.`,
      D: `Həyəcanın təsiri ilə detalları soruşmadan razılıq verin.`,
    },
    correct: { A: 4, B: 3, C: 2, D: 1 },
    explanation: `Müsbət həyəcanı da idarə etmək lazımdır: ən güclü yanaşma həyəcanı tanımaq, lakin qərardan əvvəl bir az aydın düşünməyə vaxt ayırmaqdır (A, 4). Həyəcanı bölüşüb detalları soruşandan sonra qərar vermək də yaxşıdır (B, 3). Həyəcanı bütövlükdə boğub maraqsız görünmək hissi gizlədir (C, 2). Həyəcanla dərhal, düşünmədən razılıq vermək isə düşünülməmiş öhdəliyə apara bilər, ən zəifdir (D, 1).`,
  },
  {
    id: 'ez-m3-q39', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Yoga studiyasında gözlənilməz bir problem bütün qrupu həyəcanlandırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Heç nə deməyib hərənin öz başının çarəsinə baxmasına buraxın.`,
      B: `Əvvəlcə öz sakitliyinizi qoruyun, sonra aydın, sakit tonla qrupu toxtadın.`,
      C: `Qrupun həyəcanına qoşulub birlikdə təşvişə düşün.`,
      D: `Qrupdan tez toplanmağı tələb edib həyəcanı önəmsəməyin.`,
    },
    correct: { best: 'B', worst: 'D' },
    explanation: `Qrup həyəcanlananda ən təsirli davranış əvvəlcə öz sakitliyinizi qorumaq, sonra aydın, sakit tonla qrupu toxtatmaqdır (B). Heç nə deməyib hərəni tək buraxmaq idarəsizliyə yol verir (A). Həyəcana qoşulub təşvişə düşmək vəziyyəti pisləşdirir (C). Qrupdan tez toplanmağı tələb edib həyəcanı önəmsəməmək isə hissləri arxa plana atıb etimadı zəiflədir, ən az təsirlidir (D).`,
  },
  {
    id: 'ez-m3-q40', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Kvest otağında günün sonunda özünüzü pis hiss edirsiniz, lakin səbəbini dəqiq bilmirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Hissin nəyə işarə etdiyini anlayıb buna görə sağlam addım atın.`,
      B: `Hissi araşdırmadan ilk ağla gələn səbəbə bağlayın.`,
      C: `Hissi mümkün qədər dəqiq adlandırın.`,
      D: `Hissin nə vaxt və hansı hadisədən sonra başladığını izləyin.`,
    },
    correct: ['D', 'C', 'A', 'B'],
    explanation: `Səbəbi bilinməyən pis halı anlamaq onun nə vaxt və hansı hadisədən sonra başladığını izləməklə başlayır (D), sonra hissi dəqiq adlandırmaq (C) və nəyə işarə etdiyini anlayıb sağlam addım atmaq (A). Hissi araşdırmadan ilk ağla gələn səbəbə bağlamaq isə yanlış nəticəyə apara bilər, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m3-q41', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Kosmetika mağazasında bir komanda üzvü adətən fəal ikən bu gün qapalı və sakitdir. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Sakitliyini "işdən qaçmaq" kimi şərh edib iradınızı bildirin.`,
      B: `Adi davranışındakı dəyişikliyi fərq edib təklikdə mehribanca hal-əhval tutun.`,
      C: `Heç nə fərq etməmiş kimi davam edin.`,
      D: `Dəyişikliyi fərq edin, lakin heç nə soruşmayın.`,
    },
    correct: { A: 1, B: 4, C: 2, D: 3 },
    explanation: `Adətən fəal üzvün qapanmasında ən doğru yanaşma dəyişikliyi fərq edib təklikdə mehribanca hal-əhval tutmaqdır (B, 4). Dəyişikliyi fərq edib heç nə soruşmamaq qismən diqqətlidir (D, 3). Heç nə fərq etməmiş kimi davam etmək siqnalı qaçırır (C, 2). Sakitliyini "işdən qaçmaq" kimi şərh edib irad bildirmək isə yanlış və haqsız nəticədir, ən az faydalı seçimdir (A, 1).`,
  },
  {
    id: 'ez-m3-q42', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çay evində vacib bir iş görərkən gözlənilməz bir xəbər sizi pisləşdirir, lakin işi davam etdirməlisiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `İşi yarıda saxlayıb əhvalınız düzələnə qədər başqa işlərə keçin.`,
      B: `İşi dayandırıb xəbəri uzun-uzadı götür-qoy etməyə başlayın.`,
      C: `Bir an dayanıb nəfəs alın, diqqətinizi yenidən cari işə yönəldib davam edin.`,
      D: `Pisləşdiyinizi bilsəniz də, heç nə etmədən eyni templə davam edin.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Pisləşdirən xəbərdən sonra işi davam etdirmək üçün ən uyğun yol bir an dayanıb nəfəs almaq, diqqəti yenidən cari işə yönəltməkdir (C). İşi dayandırıb xəbəri uzun götür-qoy etmək diqqəti itirir (B). Heç nə etmədən eyni templə davam etmək pisləşmiş halı idarəsiz qoyur (D). İşi yarıda saxlayıb sonraya keçirmək isə vaxtında bitməli işə birbaşa zərər vurur, ən zəifdir (A).`,
  },
  {
    id: 'ez-m3-q43', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Çay evində bir qonağın nə hiss etdiyini düşündüyünüzü yoxlamaq istəyirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `İlk təxmininizi doğru sayıb ona görə davranın.`,
      B: `Onun cavabına görə anlayışınızı düzəldin.`,
      C: `Müşahidələrə əsasən ehtiyatlı bir təxmin qurun.`,
      D: `Təxmininizi mehribanca, sual şəklində ona çatdırın.`,
    },
    correct: ['C', 'D', 'B', 'A'],
    explanation: `Emosiya oxumağı dəqiqləşdirmək müşahidələrə əsasən ehtiyatlı təxmin qurmaqla başlayır (C), sonra təxmini mehribanca, sual şəklində çatdırmaq (D) və onun cavabına görə anlayışınızı düzəltmək (B). İlk təxmini doğru sayıb ona görə davranmaq isə səhv oxumağa apara bilər, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m3-q44', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Hostel resepsiyasında gərgin bir anda güclü qəzəb hiss edirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Vəziyyəti daha sakit çərçivədə görüb ölçülü cavab verin.`,
      B: `Qəzəbi tam danıb heç nə hiss etmədiyinizi deyin.`,
      C: `Qəzəbin zirvəsi keçənə qədər bir an ara verin, sonra sakit cavab verin.`,
      D: `Qəzəbi saxlamağa çalışmadan cavabınızda büruzə verin.`,
    },
    correct: { A: 3, B: 2, C: 4, D: 1 },
    explanation: `Güclü qəzəbdə ən güclü yanaşma zirvə keçənə qədər bir an ara verib sonra sakit cavab verməkdir (C, 4). Vəziyyəti daha sakit çərçivədə görüb ölçülü cavab vermək də güclüdür (A, 3). Qəzəbi tamamilə danmaq onu gizlədir (B, 2). Qəzəbi saxlamadan cavabda büruzə vermək isə vəziyyəti pisləşdirir, ən zəif seçimdir (D, 1).`,
  },
  {
    id: 'ez-m3-q45', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Çərçivələmə emalatxanasında bir həmkar sizdən məsləhət istəyir, lakin əslində sadəcə dinlənilmək istədiyi hiss olunur. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Nə dinləyin, nə məsləhət verin, mövzunu dəyişin.`,
      B: `Yalnız dinləyin, lakin sonradan istəsə də heç vaxt məsləhət verməyin.`,
      C: `İstədiyi kimi dərhal uzun məsləhət verin.`,
      D: `Əvvəlcə diqqətlə dinləyin, sonra məsləhət istəyib-istəmədiyini incə şəkildə yoxlayın.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Sözdəki istəklə əsl ehtiyac fərqli ola bilər: ən təsirli davranış əvvəlcə dinləmək, sonra məsləhət istəyib-istəmədiyini incə yoxlamaqdır (D). Dərhal uzun məsləhət vermək əsl ehtiyacı qaçıra bilər (C). Yalnız dinləyib heç məsləhət verməmək çevik deyil (B). Nə dinləmək, nə məsləhət vermək, mövzunu dəyişmək isə onu bütövlükdə eşitməməkdir, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m3-q46', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Musiqi məktəbində işə marağınızın və diqqətinizin düşdüyünü, darıxdığınızı fərq edirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Darıxma və maraq düşüşünü bir siqnal kimi qəbul edin.`,
      B: `İşinizə maraq qatacaq kiçik bir dəyişiklik edin.`,
      C: `Onun nəyə işarə etdiyini, nəyin dəyişməsi lazım olduğunu anlayın.`,
      D: `Bu halı əhəmiyyətsiz sayıb eyni cür davam edin.`,
    },
    correct: ['A', 'C', 'B', 'D'],
    explanation: `Darıxma və maraq düşüşünü idarə etmək onu bir siqnal kimi qəbul etməklə başlayır (A), sonra nəyə işarə etdiyini anlamaq (C) və işə maraq qatacaq kiçik dəyişiklik etmək (B). Bu halı əhəmiyyətsiz sayıb eyni cür davam etmək isə problemi davam etdirir, ən zəifdir (D).`,
  },
  {
    id: 'ez-m3-q47', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Konsert zalında bir həmkar narahatlığını bölüşür və əvvəlcə sadəcə anlaşılmaq istəyir. Bu reaksiyaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Dərhal həll yollarına keçin.`,
      B: `"Narahat olma, keçər" deyib mövzunu yüngülləşdirin.`,
      C: `Hissini qəbul edin, sonra kömək istəyib-istəmədiyini soruşun.`,
      D: `Əvvəlcə dinləyin, hissini təsdiqləyin, sonra birlikdə həll axtarın.`,
    },
    correct: { A: 2, B: 1, C: 3, D: 4 },
    explanation: `Narahatlığını bölüşən həmkara ən doğru reaksiya əvvəlcə dinləmək, hissini təsdiqləmək, sonra birlikdə həll axtarmaqdır (D, 4). Hissini qəbul edib kömək istəyib-istəmədiyini soruşmaq da güclüdür (C, 3). Dərhal həll yollarına keçmək hissi yan keçir (A, 2). "Keçər" deyib mövzunu yüngülləşdirmək isə hissini kiçildir, ən az təsirlidir (B, 1).`,
  },
  {
    id: 'ez-m3-q48', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Sənət studiyasında tükənmiş hiss edirsiniz və bir həmkar sizdən növbəti uzun emosional söhbət üçün vaxt istəyir. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Mehribanlıqla indi tam yardımçı ola bilməyəcəyinizi deyin və uyğun başqa vaxt təklif edin.`,
      B: `Xahişi səbəb göstərmədən qısaca rədd edib mövzunu bağlayın.`,
      C: `Cavabı qeyri-müəyyən saxlayıb onu gözləmədə qoyun.`,
      D: `Tükənmiş olsanız da, "yox" deyə bilməyib razılıq verin, sonra özünüzü daha pis hiss edin.`,
    },
    correct: { best: 'A', worst: 'B' },
    explanation: `Tükənmiş olduğunuz halda ən uyğun davranış mehribanlıqla indi tam yardımçı ola bilməyəcəyinizi deyib uyğun başqa vaxt təklif etməkdir (A). Cavabı qeyri-müəyyən saxlayıb gözlətmək çaşqınlıq yaradır (C). "Yox" deyə bilməyib razılıq verib özünüzü daha pis hiss etmək həm sizə, həm söhbətə zərər verir (D). Xahişi səbəb göstərmədən qısaca rədd edib mövzunu bağlamaq isə münasibəti pisləşdirir, ən zəif seçimdir (B).`,
  },
  {
    id: 'ez-m3-q49', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Fizioterapiya otağında bir xəstə hirslə şikayətlənir, şikayətinin bir hissəsi haqlı, bir hissəsi haqsızdır. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Şikayətin hansı hissəsinin haqlı olduğunu ayırın.`,
      B: `Sakit dinləyib hissini qəbul edin.`,
      C: `Hirsinə görə bütün şikayəti haqsız sayıb rədd edin.`,
      D: `Haqlı hissəni həll edin, haqsız hissəni hörmətlə izah edin.`,
    },
    correct: ['B', 'A', 'D', 'C'],
    explanation: `Qismən haqlı şikayətdə ən güclü ardıcıllıq sakit dinləyib hissini qəbul etmək (B), haqlı hissəni ayırmaq (A) və haqlı hissəni həll edib haqsızı hörmətlə izah etməkdir (D). Hirsinə görə bütün şikayəti haqsız sayıb rədd etmək isə həm haqlı tərəfi, həm münasibəti itirir, ən az faydalı seçimdir (C).`,
  },
  {
    id: 'ez-m3-q50', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'likert', is_free: false, points: 1,
    question_az: `Sənət studiyasında həm hisslərin, həm faktların rol oynadığı bir qərar verirsiniz. Bu yanaşmaları qiymətləndirin: 1 (ən zəif) ... 4 (ən güclü).`,
    options: {
      A: `Emosional anlayışı faktlar və nəticələrlə birləşdirib qərar verin.`,
      B: `Yalnız anlıq emosiyaya əsaslanın.`,
      C: `Yalnız faktlara baxıb insani tərəfi unudun.`,
      D: `Vəziyyətin emosional tərəfini oxuyub nəzərə alın.`,
    },
    correct: { A: 4, B: 1, C: 2, D: 3 },
    explanation: `Həm hiss, həm fakt olan qərarda ən təsirli yanaşma emosional anlayışı faktlar və nəticələrlə birləşdirməkdir (A, 4). Emosional tərəfi oxuyub nəzərə almaq vacibdir, lakin tək başına natamamdır (D, 3). Yalnız faktlara baxıb insani tərəfi unutmaq tarazlığı pozur (C, 2). Yalnız anlıq emosiyaya əsaslanmaq isə obyektivliyi itirir, ən zəifdir (B, 1).`,
  },
  {
    id: 'ez-m3-q51', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Xəttatlıq emalatxanasında saatlardır fasiləsiz işləyirsiniz, diqqətiniz dağılır və əsəbiləşirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Bu əlamətləri keçici sayıb eyni templə işləməyə davam edin.`,
      B: `Bunları bir fasilə siqnalı kimi qəbul edib qısa ara verin, sonra davam edin.`,
      C: `Əsəbi olduğunuzu fərq etsəniz də, bunun ünsiyyətinizə təsirini nəzərə almadan işi davam etdirin.`,
      D: `İşi büsbütün atıb günü bitirin.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Dağılan diqqət və əsəbilik bir fasilə siqnalıdır: ən doğru davranış qısa ara verib sonra davam etməkdir (B). İşi büsbütün atıb günü bitirmək həddən artıq reaksiyadır (D). Əsəbi olduğunuzu fərq etsəniz də, ünsiyyətinizə təsirini nəzərə almadan işi davam etdirmək münasibətə xələl gətirə bilər (C). Bu əlamətləri keçici sayıb eyni templə davam etmək isə həm keyfiyyəti, həm halınızı pisləşdirir, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m3-q52', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `Yay düşərgəsində qayda pozan bir nəfərlə bağlı qərar verirsiniz; həm onun halını, həm ədaləti nəzərə almalısınız. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Yalnız anlıq emosiyaya əsaslanıb qərar verin.`,
      B: `Faktları və ədalətli qaydanı nəzərə alın.`,
      C: `Anlayışı ədalətlə birləşdirib ölçülü qərar verin.`,
      D: `Onun vəziyyətini və hissini anlayın.`,
    },
    correct: ['D', 'B', 'C', 'A'],
    explanation: `Həssas intizam qərarında ən uyğun ardıcıllıq onun vəziyyətini və hissini anlamaq (D), faktları və ədalətli qaydanı nəzərə almaq (B) və anlayışı ədalətlə birləşdirib ölçülü qərar verməkdir (C). Yalnız anlıq emosiyaya əsaslanıb qərar vermək isə ədaləti və ardıcıllığı itirir, ən zəif seçimdir (A).`,
  },
  {
    id: 'ez-m3-q53', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Reabilitasiya mərkəzində bir plan kağız üzərində düzgün görünür, lakin içinizdə güclü bir narahatlıq hissi var. Ən effektiv və ən az effektiv yanaşmanı seçin.`,
    options: {
      A: `Hissi əsassız sayıb planı olduğu kimi qəbul edin.`,
      B: `Yalnız hissə əsaslanıb planı bütövlükdə dayandırın.`,
      C: `Narahatlığın hansı konkret məqama işarə etdiyini müəyyən edib həmin yeri yoxlayın.`,
      D: `Bütün planı bir daha, fərq qoymadan başdan yoxlayın.`,
    },
    correct: { best: 'C', worst: 'A' },
    explanation: `Düzgün görünən, lakin sizi narahat edən planda ən güclü yanaşma narahatlığın hansı konkret məqama işarə etdiyini müəyyən edib həmin yeri yoxlamaqdır (C). Bütün planı fərq qoymadan başdan yoxlamaq səmərəsizdir (D). Yalnız hissə əsaslanıb planı bütövlükdə dayandırmaq yoxlanmamış reaksiyadır (B). Hissi əsassız sayıb planı olduğu kimi qəbul etmək isə real problemi qaçıra bilər, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m3-q54', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'ranking', is_free: false, points: 1,
    question_az: `İncəsənət qalereyasında böyük bir imkandan əvvəl həm həyəcan, həm narahatlıq keçirirsiniz. Addımları ən effektiv ardıcıllıqla sıralayın (ən effektivdən ən az effektivə).`,
    options: {
      A: `Onların hər birinin nəyə işarə etdiyini anlayın.`,
      B: `Enerjini hazırlığa yönəldib ölçülü hərəkət edin.`,
      C: `Hər iki hissi tanıyıb adlandırın.`,
      D: `Hisslərin coşqusu ilə tez qərar verib detalları sonraya saxlayın.`,
    },
    correct: ['C', 'A', 'B', 'D'],
    explanation: `Həyəcan və narahatlıq birlikdə olanda ən təsirli ardıcıllıq hər iki hissi tanıyıb adlandırmaq (C), hər birinin nəyə işarə etdiyini anlamaq (A) və enerjini hazırlığa yönəldib ölçülü hərəkət etməkdir (B). Hisslərin coşqusu ilə tələsik qərar vermək isə nəzarəti itirir, ən zəifdir (D).`,
  },
  {
    id: 'ez-m3-q55', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Konsert zalında gözlənilməz bir tənqid sizi qıcıqlandırır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Qıcığı saxlamağa çalışmadan tonunuzda büruzə verin.`,
      B: `Hissi inkar edib heç nə hiss etmədiyinizi deyin.`,
      C: `Tənqidin məzmununa baxmadan onu tam rədd edin.`,
      D: `Fasilə verib hissinizi dəqiq adlandırın, məsələn "qıcıqlandım, hirsli deyiləm", sonra ölçülü cavab verin.`,
    },
    correct: { best: 'D', worst: 'A' },
    explanation: `Qıcıqlananda ən doğru davranış fasilə verib hissi dəqiq adlandırmaq, sonra ölçülü cavab verməkdir; hissi dəqiq adlandırmaq onu mütənasib idarə etməyə kömək edir (D). Tənqidi məzmununa baxmadan rədd etmək faydalı məlumatı itirir (C). Hissi inkar etmək onu gizlədir (B). Qıcığı tonunuzda büruzə vermək isə peşmançılığa apara bilər, ən az təsirlidir (A).`,
  },
  {
    id: 'ez-m3-q56', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Gözəllik salonunda işinizlə fəxr edirsiniz, lakin onun layiqincə qiymətləndirilmədiyini görüb məyus olursunuz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Həm fəxri, həm məyusluğu tanıyıb hər ikisini özünüzə etiraf edin.`,
      B: `Yalnız fəxrə fokuslanıb məyusluğu inkar edin.`,
      C: `Yalnız məyusluğa qapılıb gördüyünüz işin dəyərini unudun.`,
      D: `İki hiss qarışdığı üçün heç birini araşdırmadan diqqətinizi işə yönəldin.`,
    },
    correct: { best: 'A', worst: 'D' },
    explanation: `Fəxr və məyusluq birlikdə yaşananda ən uyğun davranış hər ikisini tanıyıb özünüzə etiraf etməkdir (A). Yalnız fəxrə (B) və ya yalnız məyusluğa (C) baxmaq mənzərənin yarısını qaçırır. İki hissin heç birini araşdırmadan diqqəti yalnız işə yönəltmək isə dəyərli məlumatı itirir, ən zəif seçimdir (D).`,
  },
  {
    id: 'ez-m3-q57', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Tələbə məsləhət otağında bir tələbə pərt vəziyyətini sizdən daha yavaş emal edir və siz səbirsizlik hiss edirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Səbirsizliyi göstərib onu tələsdirin.`,
      B: `Hər kəsin emosiyanı fərqli sürətlə emal etdiyini xatırlayıb ona vaxt verin.`,
      C: `Səbirsizliyinizi içinizdə saxlayın, lakin narahatlığınız bir az hiss olunur.`,
      D: `Söhbəti qısaldıb onu öz halı ilə tək buraxın.`,
    },
    correct: { best: 'B', worst: 'A' },
    explanation: `Ən güclü davranış hər kəsin emosiyanı fərqli sürətlə emal etdiyini xatırlayıb ona vaxt verməkdir (B). Səbirsizliyi içinizdə saxlamaq, az hiss olunsa belə, tələsdirməkdən yaxşıdır (C). Söhbəti qısaldıb onu tək buraxmaq dəstəyi kəsir (D). Səbirsizliyi göstərib onu tələsdirmək isə emal prosesini pozur, ən az faydalı seçimdir (A).`,
  },
  {
    id: 'ez-m3-q58', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Sürücülük məktəbində bir həmkar sizin də istədiyiniz bir uğur qazanır və içinizdə paxıllığa bənzər bir hiss yaranır. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hissi uzun müddət üzərinizdə saxlayıb əhvalınızı pozun.`,
      B: `Paxıllığı onun uğurunu kiçiltməklə büruzə verin.`,
      C: `Hissi özünüzə etiraf edin, onu səmimi təbrik edin və öz hədəflərinizə fokuslanın.`,
      D: `Hissi danıb heç nə hiss etmədiyinizi deyin.`,
    },
    correct: { best: 'C', worst: 'B' },
    explanation: `Paxıllığa bənzər hissdə ən güclü davranış onu özünüzə etiraf etmək, həmkarı səmimi təbrik etmək və öz hədəflərinizə fokuslanmaqdır (C). Hissi danmaq onu gizlədir (D). Hissi uzun saxlayıb əhvalınızı pozmaq özünüzə zərər verir (A). Paxıllığı onun uğurunu kiçiltməklə büruzə vermək isə həm münasibəti, həm nüfuzunuzu zədələyir, ən zəifdir (B).`,
  },
  {
    id: 'ez-m3-q59', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Uşaq teatrında müəyyən bir mövzu hər dəfə sizi qeyri-adi dərəcədə əsəbiləşdirir və bunu fərq etmisiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Hər dəfə eyni cür kəskin reaksiya verməyə davam edin.`,
      B: `Tətikləyicini yalnız xarici səbəblərlə izah edib öz reaksiyanıza baxmayın.`,
      C: `Mövzu qalxanda söhbətdən hər dəfə birdən çıxıb gedin.`,
      D: `Bunun sizin üçün bir tətikləyici olduğunu tanıyıb həmin anlarda daha ehtiyatlı reaksiya verin.`,
    },
    correct: { best: 'D', worst: 'B' },
    explanation: `Təkrarlanan tətikləyicidə ən təsirli davranış bunun sizin üçün bir tətikləyici olduğunu tanıyıb həmin anlarda daha ehtiyatlı reaksiya verməkdir (D). Mövzu qalxanda söhbətdən hər dəfə birdən çıxıb getmək qaçınmadır (C). Hər dəfə eyni kəskin reaksiyanı davam etdirmək heç nəyi dəyişmir (A). Tətikləyicini yalnız xarici səbəblərlə izah edib öz reaksiyanıza baxmamaq isə problemi həll etmir, ən az təsirlidir (B).`,
  },
  {
    id: 'ez-m3-q60', course: 'ez', mock_num: 3, topic: 'ez',
    q_type: 'dual', is_free: false, points: 1,
    question_az: `Sərgi mərkəzində bir qərarda özünüzün müəyyən bir nəfərə meylli olduğunuzu fərq edirsiniz. Ən effektiv və ən az effektiv davranışı seçin.`,
    options: {
      A: `Bu meyli fərq edib qərarı şəffaf meyarlara və faktlara əsasən verin.`,
      B: `Meyli inkar edib qərarın tamamilə obyektiv olduğunu güman edin.`,
      C: `Meylinizə uyğun qərar verib bunu özünüzə haqq qazandırın.`,
      D: `Qərarı bütövlükdə başqasına ötürüb məsələdən uzaqlaşın.`,
    },
    correct: { best: 'A', worst: 'C' },
    explanation: `Öz meylinizi fərq edəndə ən doğru davranış onu tanıyıb qərarı şəffaf meyarlara və faktlara əsasən verməkdir (A). Qərarı tam başqasına ötürmək məsuliyyətdən qaçmaqdır (D). Meyli inkar edib qərarın obyektiv olduğunu güman etmək qərəzi gizli saxlayır (B). Meylinizə uyğun qərar verib bunu haqq qazandırmaq isə ədaləti birbaşa pozur, ən zəif seçimdir (C).`,
  },
];